
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("ah9qo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eaaa23a968450e17340047f7baad741>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77b2cd79a239cc3e$var$_react = $77b2cd79a239cc3e$var$_interopRequireDefault((parcelRequire("euxye")));

var $77b2cd79a239cc3e$var$_baseNew = $77b2cd79a239cc3e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $77b2cd79a239cc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77b2cd79a239cc3e$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $77b2cd79a239cc3e$var$_react.default.createElement($77b2cd79a239cc3e$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$77b2cd79a239cc3e$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $77b2cd79a239cc3e$var$_default = module.exports.default = $77b2cd79a239cc3e$var$StatusErrorIcon;

});
parcelRegister("6tEFs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("52mjj")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("52mjj")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $52mjj = parcelRequire("52mjj");

});
parcelRegister("52mjj", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $a65219e3129d1a75$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $a65219e3129d1a75$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $a65219e3129d1a75$var$svgStyles = null;
const $a65219e3129d1a75$var$iconStyles = null;
const $a65219e3129d1a75$var$smallIconStyles = null;
const $a65219e3129d1a75$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $a65219e3129d1a75$var$baseHcmStyles = null;
const $a65219e3129d1a75$var$scaleSize = null;
const $a65219e3129d1a75$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $a65219e3129d1a75$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $a65219e3129d1a75$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $a65219e3129d1a75$export$f04a61298a47a40f = /*#__PURE__*/ (0, $euxye.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $a65219e3129d1a75$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $4jQY2.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va18uv _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $4jQY2.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $a65219e3129d1a75$var$coreSizeSmall[spacing] : $a65219e3129d1a75$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a65219e3129d1a75$export$2e2bcd8739ae039 = $a65219e3129d1a75$export$f04a61298a47a40f;

});



parcelRegister("8Qvei", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43780b3395052aa320d1077123ecca9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $670b679f69983844$var$_react = $670b679f69983844$var$_interopRequireDefault((parcelRequire("euxye")));

var $670b679f69983844$var$_baseNew = $670b679f69983844$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $670b679f69983844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $670b679f69983844$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $670b679f69983844$var$_react.default.createElement($670b679f69983844$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$670b679f69983844$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $670b679f69983844$var$_default = module.exports.default = $670b679f69983844$var$StatusSuccessIcon;

});

parcelRegister("ld25x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6af69c0da1151808644d1b7c1f4d031c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70c6e94f8301f90$var$_react = $f70c6e94f8301f90$var$_interopRequireDefault((parcelRequire("euxye")));

var $f70c6e94f8301f90$var$_baseNew = $f70c6e94f8301f90$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $f70c6e94f8301f90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70c6e94f8301f90$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f70c6e94f8301f90$var$_react.default.createElement($f70c6e94f8301f90$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f70c6e94f8301f90$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f70c6e94f8301f90$var$_default = module.exports.default = $f70c6e94f8301f90$var$ChevronDownIcon;

});

parcelRegister("aFpts", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43da111d5da2bc4c58e22bdbb274e37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c417e5441443669$var$_react = $7c417e5441443669$var$_interopRequireDefault((parcelRequire("euxye")));

var $7c417e5441443669$var$_baseNew = $7c417e5441443669$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $7c417e5441443669$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c417e5441443669$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $7c417e5441443669$var$_react.default.createElement($7c417e5441443669$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$7c417e5441443669$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $7c417e5441443669$var$_default = module.exports.default = $7c417e5441443669$var$ChevronUpIcon;

});

parcelRegister("i68tN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdf99897c5696ca9ecbe3cd832bc46f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2cf5d6a2313fa30$var$_react = $d2cf5d6a2313fa30$var$_interopRequireDefault((parcelRequire("euxye")));

var $d2cf5d6a2313fa30$var$_baseNew = $d2cf5d6a2313fa30$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $d2cf5d6a2313fa30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2cf5d6a2313fa30$var$CrossIcon = (props)=>/*#__PURE__*/ $d2cf5d6a2313fa30$var$_react.default.createElement($d2cf5d6a2313fa30$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$d2cf5d6a2313fa30$var$CrossIcon.displayName = 'CrossIcon';
var $d2cf5d6a2313fa30$var$_default = module.exports.default = $d2cf5d6a2313fa30$var$CrossIcon;

});

parcelRegister("bgJDP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6464fc3501ef95b4ce0d44356e317be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $834497c8bfc663af$var$_react = $834497c8bfc663af$var$_interopRequireDefault((parcelRequire("euxye")));

var $834497c8bfc663af$var$_baseNew = $834497c8bfc663af$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $834497c8bfc663af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $834497c8bfc663af$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $834497c8bfc663af$var$_react.default.createElement($834497c8bfc663af$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$834497c8bfc663af$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $834497c8bfc663af$var$_default = module.exports.default = $834497c8bfc663af$var$StatusInformationIcon;

});

parcelRegister("8QmUu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d15ab13bccd5974ddb056f1635cc0800>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6704f3849a093481$var$_react = $6704f3849a093481$var$_interopRequireDefault((parcelRequire("euxye")));

var $6704f3849a093481$var$_baseNew = $6704f3849a093481$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $6704f3849a093481$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6704f3849a093481$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $6704f3849a093481$var$_react.default.createElement($6704f3849a093481$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$6704f3849a093481$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $6704f3849a093481$var$_default = module.exports.default = $6704f3849a093481$var$StatusWarningIcon;

});

parcelRegister("5ySJg", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("lGdeT")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("lGdeT")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("hExZX")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("hExZX")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("cHlnW")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("cHlnW")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $c4e639dc1b853f95$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("7MmBF")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("7MmBF")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("4QdkY")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("4QdkY")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("c5bMY")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("cRhez")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("1NVGR")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("kabGl")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("2J2dU")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("2J2dU")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("ja81e")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("ja81e")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("rdwEA")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("78a5e")).GROWTH_CONTEXT);
$parcel$export(module.exports, "GrowthAnalyticsContext", () => (parcelRequire("78a5e")).GrowthAnalyticsContext);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("lX9Wi")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("a4B2I")).ROVO_EXTENSION_CONTEXT);

var $lGdeT = parcelRequire("lGdeT");

var $hExZX = parcelRequire("hExZX");

var $cHlnW = parcelRequire("cHlnW");


var $7MmBF = parcelRequire("7MmBF");

var $4QdkY = parcelRequire("4QdkY");

var $c5bMY = parcelRequire("c5bMY");

var $cRhez = parcelRequire("cRhez");

var $1NVGR = parcelRequire("1NVGR");

var $kabGl = parcelRequire("kabGl");

var $2J2dU = parcelRequire("2J2dU");

var $ja81e = parcelRequire("ja81e");

var $rdwEA = parcelRequire("rdwEA");

var $78a5e = parcelRequire("78a5e");

var $lX9Wi = parcelRequire("lX9Wi");

var $a4B2I = parcelRequire("a4B2I");

});
parcelRegister("lGdeT", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $ed7cdf6f5fee7d98$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $ed7cdf6f5fee7d98$export$3fe25500478a635c);

var $5MMX8 = parcelRequire("5MMX8");
const $ed7cdf6f5fee7d98$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $ed7cdf6f5fee7d98$export$3fe25500478a635c = (0, $5MMX8.default)($ed7cdf6f5fee7d98$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("5MMX8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1bb71bacfbad419$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");
const $f1bb71bacfbad419$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $f1bb71bacfbad419$export$2e2bcd8739ae039 = $f1bb71bacfbad419$var$createNamespaceContext;

});
parcelRegister("hUqPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d3e01795f8ef1df$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $dwtyn = parcelRequire("dwtyn");

var $dgWJg = parcelRequire("dgWJg");

var $dH2m9 = parcelRequire("dH2m9");
const $0d3e01795f8ef1df$var$AnalyticsContext = (props)=>{
    const computeIsModernContext = ()=>(0, $dwtyn.default) || (0, $iqfTZ.fg)('analytics-next-use-legacy-context') === false;
    // Gated by analytics-next-lock-context-type(-all-afm): capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    const [lockedIsModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState(computeIsModernContext);
    const isModernContext = (0, $iqfTZ.fg)('analytics-next-lock-context-type-all-afm') || (0, $iqfTZ.fg)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dH2m9.default), {
        ...props
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dgWJg.default), {
        ...props
    });
};
$0d3e01795f8ef1df$var$AnalyticsContext.displayName = "AnalyticsContext";
var $0d3e01795f8ef1df$export$2e2bcd8739ae039 = $0d3e01795f8ef1df$var$AnalyticsContext;

});
parcelRegister("dwtyn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c103120909778a4$export$2e2bcd8739ae039);
/// <reference types="node" />

var $gIMgJ = parcelRequire("gIMgJ");
const $4c103120909778a4$var$_default_1 = typeof $gIMgJ !== 'undefined' && $gIMgJ !== null && $gIMgJ.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
var $4c103120909778a4$export$2e2bcd8739ae039 = $4c103120909778a4$var$_default_1;

});

parcelRegister("dgWJg", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffc9cca28b31f4ad$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");

var $jW7qO = parcelRequire("jW7qO");
const $ffc9cca28b31f4ad$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
};
const $ffc9cca28b31f4ad$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ffc9cca28b31f4ad$var$AnalyticsContext extends (0, $euxye.Component) {
    static{
        this.contextTypes = $ffc9cca28b31f4ad$var$ContextTypes;
    }
    static{
        this.childContextTypes = $ffc9cca28b31f4ad$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $ffc9cca28b31f4ad$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $ffc9cca28b31f4ad$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jW7qO.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
$ffc9cca28b31f4ad$var$AnalyticsContext.displayName = "AnalyticsContext";
var $ffc9cca28b31f4ad$export$2e2bcd8739ae039 = $ffc9cca28b31f4ad$var$AnalyticsContext;

});
parcelRegister("jW7qO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e83932d24816bf53$export$2e2bcd8739ae039);

var $cVx7i = parcelRequire("cVx7i");
var $e83932d24816bf53$export$2e2bcd8739ae039 = (0, $cVx7i.default);

});
parcelRegister("cVx7i", function(module, exports) {
$parcel$export(module.exports, "default", () => $96947f2efc6648ae$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
var $96947f2efc6648ae$var$AnalyticsNextContext = (0, $euxye.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $96947f2efc6648ae$export$2e2bcd8739ae039 = $96947f2efc6648ae$var$AnalyticsNextContext;

});



parcelRegister("dH2m9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d744f3efb46fe6f$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jW7qO = parcelRequire("jW7qO");

var $9BThh = parcelRequire("9BThh");

var $7v5Xl = parcelRequire("7v5Xl");
const $9d744f3efb46fe6f$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $7v5Xl.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $9BThh.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $euxye.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $euxye.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jW7qO.default).Provider, {
        value: value,
        children: children
    });
};
$9d744f3efb46fe6f$var$AnalyticsContext.displayName = "AnalyticsContext";
var $9d744f3efb46fe6f$export$2e2bcd8739ae039 = $9d744f3efb46fe6f$var$AnalyticsContext;

});
parcelRegister("9BThh", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $fecdc17d438a737e$export$d1f587f82ad51c4);

var $euxye = parcelRequire("euxye");

var $jW7qO = parcelRequire("jW7qO");
const $fecdc17d438a737e$export$d1f587f82ad51c4 = ()=>{
    return (0, $euxye.useContext)((0, $jW7qO.default));
};

});

parcelRegister("7v5Xl", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $356bab4db98e69cd$export$1d27a74659855e44);

var $euxye = parcelRequire("euxye");
const $356bab4db98e69cd$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $euxye.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("hExZX", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $f744ce8f6cca9633$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $f744ce8f6cca9633$export$d0a82da1a0b94929);

var $5MMX8 = parcelRequire("5MMX8");
const $f744ce8f6cca9633$export$1fd3aad76a7c6788 = 'navigationCtx';
const $f744ce8f6cca9633$export$d0a82da1a0b94929 = (0, $5MMX8.default)($f744ce8f6cca9633$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("cHlnW", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $0bd834b166d80f65$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $0bd834b166d80f65$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $0bd834b166d80f65$export$629cada6c5e621e1);

var $5MMX8 = parcelRequire("5MMX8");
const $0bd834b166d80f65$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $0bd834b166d80f65$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $0bd834b166d80f65$export$629cada6c5e621e1 = (0, $5MMX8.default)($0bd834b166d80f65$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("7MmBF", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $9b6ce372bd611d03$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $9b6ce372bd611d03$export$4119ddb38ccbfb87);

var $5MMX8 = parcelRequire("5MMX8");
const $9b6ce372bd611d03$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $9b6ce372bd611d03$export$4119ddb38ccbfb87 = (0, $5MMX8.default)($9b6ce372bd611d03$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("4QdkY", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $50321d02a3a4000b$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $50321d02a3a4000b$export$6f8e7ff1e3feafd7);

var $5MMX8 = parcelRequire("5MMX8");
const $50321d02a3a4000b$export$da1befb791e93c7e = 'NotificationsCtx';
const $50321d02a3a4000b$export$6f8e7ff1e3feafd7 = (0, $5MMX8.default)($50321d02a3a4000b$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("c5bMY", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $36af1d4fadcbdf69$export$fc7a65795610cb71);

var $5MMX8 = parcelRequire("5MMX8");
const $36af1d4fadcbdf69$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $36af1d4fadcbdf69$export$745926731087ebe2 = (0, $5MMX8.default)($36af1d4fadcbdf69$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("cRhez", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $b92a0d5e35a5482d$export$4906017439f33fc0);

var $5MMX8 = parcelRequire("5MMX8");
const $b92a0d5e35a5482d$export$4906017439f33fc0 = 'atlasCtx';
const $b92a0d5e35a5482d$export$43ebbe41370d4543 = (0, $5MMX8.default)($b92a0d5e35a5482d$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("1NVGR", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $6d1c3687a193a571$export$aa18ab4fff926c9e);

var $5MMX8 = parcelRequire("5MMX8");
const $6d1c3687a193a571$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $6d1c3687a193a571$export$d283110f5d85c8f2 = (0, $5MMX8.default)($6d1c3687a193a571$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("kabGl", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $2f777e111ab3da6a$export$3240443bf2b83834);

var $5MMX8 = parcelRequire("5MMX8");
const $2f777e111ab3da6a$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $2f777e111ab3da6a$export$6d568da622ce0a08 = (0, $5MMX8.default)($2f777e111ab3da6a$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("2J2dU", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $08be7a09d75cd8dd$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $08be7a09d75cd8dd$export$dcd232f3be312f94);

var $5MMX8 = parcelRequire("5MMX8");
const $08be7a09d75cd8dd$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $08be7a09d75cd8dd$export$dcd232f3be312f94 = (0, $5MMX8.default)($08be7a09d75cd8dd$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("ja81e", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $0093f1cc6bf1f661$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $0093f1cc6bf1f661$export$de3826c30468da26);

var $5MMX8 = parcelRequire("5MMX8");
const $0093f1cc6bf1f661$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $0093f1cc6bf1f661$export$de3826c30468da26 = (0, $5MMX8.default)($0093f1cc6bf1f661$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("rdwEA", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $8f0a09c22f8f6a45$export$c2a811a4e42f4af5);

var $5MMX8 = parcelRequire("5MMX8");
const $8f0a09c22f8f6a45$export$c2a811a4e42f4af5 = 'avpCtx';
const $8f0a09c22f8f6a45$export$da383e8879a25b03 = (0, $5MMX8.default)($8f0a09c22f8f6a45$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("78a5e", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $5d2767ee99b4f40e$export$82023f2f4bfb06c1);
$parcel$export(module.exports, "GrowthAnalyticsContext", () => $5d2767ee99b4f40e$export$84980182680018f);

var $5MMX8 = parcelRequire("5MMX8");
const $5d2767ee99b4f40e$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $5d2767ee99b4f40e$export$84980182680018f = (0, $5MMX8.default)($5d2767ee99b4f40e$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("lX9Wi", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $06f41b909dcb1e6e$export$6d3c48fd1b3e4f3b);

var $5MMX8 = parcelRequire("5MMX8");
const $06f41b909dcb1e6e$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $06f41b909dcb1e6e$export$e4e6df99270bbbb1 = (0, $5MMX8.default)($06f41b909dcb1e6e$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("a4B2I", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $5ad3be4300af8e0d$export$fae437eb1dd9520c);

var $5MMX8 = parcelRequire("5MMX8");
const $5ad3be4300af8e0d$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $5ad3be4300af8e0d$export$7fcecc25ee38fbef = (0, $5MMX8.default)($5ad3be4300af8e0d$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("bHcfq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("9YCxR")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("bYMEe")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("8GASP")).FabricChannel);

var $9YCxR = parcelRequire("9YCxR");

var $bYMEe = parcelRequire("bYMEe");

var $8GASP = parcelRequire("8GASP");

});
parcelRegister("9YCxR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9b64cb9c661d58f$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $9trDs = parcelRequire("9trDs");

var $cMFH1 = parcelRequire("cMFH1");

var $bYMEe = parcelRequire("bYMEe");

var $frbv6 = parcelRequire("frbv6");

var $kdDm3 = parcelRequire("kdDm3");

var $DCds6 = parcelRequire("DCds6");

var $9KRIy = parcelRequire("9KRIy");

var $7c2Di = parcelRequire("7c2Di");

var $laHn3 = parcelRequire("laHn3");

var $9zYuw = parcelRequire("9zYuw");

var $5VXFI = parcelRequire("5VXFI");

var $kPQd0 = parcelRequire("kPQd0");

var $hrWfZ = parcelRequire("hrWfZ");

var $7bGZo = parcelRequire("7bGZo");

var $a7zJy = parcelRequire("a7zJy");

var $8BzOq = parcelRequire("8BzOq");

var $48PBu = parcelRequire("48PBu");

var $igNBH = parcelRequire("igNBH");

var $4SkJq = parcelRequire("4SkJq");

var $5ZtJc = parcelRequire("5ZtJc");
const $b9b64cb9c661d58f$var$listenerMap = {
    [(0, $8GASP.FabricChannel).elements]: (0, $9trDs.default),
    [(0, $8GASP.FabricChannel).editor]: (0, $kdDm3.default),
    [(0, $8GASP.FabricChannel).atlaskit]: (0, $cMFH1.default),
    [(0, $8GASP.FabricChannel).navigation]: (0, $frbv6.default),
    [(0, $8GASP.FabricChannel).media]: (0, $DCds6.default),
    [(0, $8GASP.FabricChannel).peopleTeams]: (0, $9KRIy.default),
    [(0, $8GASP.FabricChannel).notifications]: (0, $7c2Di.default),
    [(0, $8GASP.FabricChannel).recentWork]: (0, $laHn3.default),
    [(0, $8GASP.FabricChannel).atlas]: (0, $9zYuw.default),
    [(0, $8GASP.FabricChannel).crossFlow]: (0, $5VXFI.default),
    [(0, $8GASP.FabricChannel).linkingPlatform]: (0, $kPQd0.default),
    [(0, $8GASP.FabricChannel).postOffice]: (0, $hrWfZ.default),
    [(0, $8GASP.FabricChannel).aiMate]: (0, $7bGZo.default),
    [(0, $8GASP.FabricChannel).avp]: (0, $a7zJy.default),
    [(0, $8GASP.FabricChannel).growth]: (0, $8BzOq.default),
    [(0, $8GASP.FabricChannel).omniChannel]: (0, $48PBu.default),
    [(0, $8GASP.FabricChannel).townsquareHome]: (0, $igNBH.default),
    [(0, $8GASP.FabricChannel).rovoExtension]: (0, $4SkJq.default),
    [(0, $8GASP.FabricChannel).teamworkGraph]: (0, $5ZtJc.default)
};
class $b9b64cb9c661d58f$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $bYMEe.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($b9b64cb9c661d58f$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$b9b64cb9c661d58f$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
$b9b64cb9c661d58f$var$FabricAnalyticsListeners.displayName = "FabricAnalyticsListeners";
var $b9b64cb9c661d58f$export$2e2bcd8739ae039 = $b9b64cb9c661d58f$var$FabricAnalyticsListeners;

});
parcelRegister("8GASP", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $02542ff8076b045a$export$8faa0b115ef0268b);
var $02542ff8076b045a$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("9trDs", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $73aa8b41e3974f06$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $73aa8b41e3974f06$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $f6SzU = parcelRequire("f6SzU");

var $8GASP = parcelRequire("8GASP");

var $5M6QO = parcelRequire("5M6QO");
const $73aa8b41e3974f06$export$ed71ae78997933a = 'fabricElements';
class $73aa8b41e3974f06$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $8GASP.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $5M6QO.handleEvent)(event, $73aa8b41e3974f06$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}
$73aa8b41e3974f06$export$2e2bcd8739ae039.displayName = "FabricElementsListener";

});
parcelRegister("f6SzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcf71f947e1c0198$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $dwtyn = parcelRequire("dwtyn");

var $1h5nD = parcelRequire("1h5nD");

var $8D82E = parcelRequire("8D82E");
const $bcf71f947e1c0198$var$AnalyticsListener = (props)=>{
    const computeIsModernContext = ()=>(0, $dwtyn.default) || (0, $iqfTZ.fg)('analytics-next-use-legacy-context') === false;
    // Gated by analytics-next-lock-context-type(-all-afm): capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    const [lockedIsModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState(computeIsModernContext);
    const isModernContext = (0, $iqfTZ.fg)('analytics-next-lock-context-type-all-afm') || (0, $iqfTZ.fg)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8D82E.default), {
        ...props
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1h5nD.default), {
        ...props
    });
};
$bcf71f947e1c0198$var$AnalyticsListener.displayName = "AnalyticsListener";
var $bcf71f947e1c0198$export$2e2bcd8739ae039 = $bcf71f947e1c0198$var$AnalyticsListener;

});
parcelRegister("1h5nD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6ac1e77f6111544$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");

var $jW7qO = parcelRequire("jW7qO");
const $c6ac1e77f6111544$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
};
const $c6ac1e77f6111544$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c6ac1e77f6111544$var$AnalyticsListener extends (0, $euxye.Component) {
    static{
        this.contextTypes = $c6ac1e77f6111544$var$ContextTypes;
    }
    static{
        this.childContextTypes = $c6ac1e77f6111544$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $c6ac1e77f6111544$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $c6ac1e77f6111544$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jW7qO.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
$c6ac1e77f6111544$var$AnalyticsListener.displayName = "AnalyticsListener";
var $c6ac1e77f6111544$export$2e2bcd8739ae039 = $c6ac1e77f6111544$var$AnalyticsListener;

});

parcelRegister("8D82E", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e2f7bfb0659ee46$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jW7qO = parcelRequire("jW7qO");

var $9BThh = parcelRequire("9BThh");

var $7v5Xl = parcelRequire("7v5Xl");
const $5e2f7bfb0659ee46$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $9BThh.useAnalyticsContext)();
    const onEventRef = (0, $7v5Xl.useTrackedRef)(onEvent);
    const channelRef = (0, $7v5Xl.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $euxye.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $euxye.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jW7qO.default).Provider, {
        value: value,
        children: children
    });
};
$5e2f7bfb0659ee46$var$AnalyticsListener.displayName = "AnalyticsListener";
var $5e2f7bfb0659ee46$export$2e2bcd8739ae039 = $5e2f7bfb0659ee46$var$AnalyticsListener;

});


parcelRegister("5M6QO", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $5baf457329329d0c$export$d6e5ca10785815df);

var $enl0k = parcelRequire("enl0k");

var $6FnYv = parcelRequire("6FnYv");
const $5baf457329329d0c$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $6FnYv.processEventPayload)(event, tags);
    (0, $enl0k.sendEvent)(logger, client)(payload);
};

});
parcelRegister("enl0k", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $e8de48cf46aa8454$export$7329bcdc3edcd90e);
const $e8de48cf46aa8454$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $e8de48cf46aa8454$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($e8de48cf46aa8454$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("6FnYv", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $bd245ff483f5f1cd$export$c37d638b7f2ca192);

parcelRequire("5ySJg");
var $cHlnW = parcelRequire("cHlnW");
var $lGdeT = parcelRequire("lGdeT");

var $6Fltw = parcelRequire("6Fltw");

var $9trDs = parcelRequire("9trDs");

var $kdDm3 = parcelRequire("kdDm3");
const $bd245ff483f5f1cd$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, item), {});
const $bd245ff483f5f1cd$var$fieldExtractor = (contextKey)=>$bd245ff483f5f1cd$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $bd245ff483f5f1cd$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $9trDs.ELEMENTS_TAG:
            return 0, $lGdeT.ELEMENTS_CONTEXT;
        case 0, $kdDm3.EDITOR_TAG:
            return 0, $cHlnW.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $bd245ff483f5f1cd$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $6d4033511f75ada1$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $bd245ff483f5f1cd$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $bd245ff483f5f1cd$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $6d4033511f75ada1$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $bd245ff483f5f1cd$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $bd245ff483f5f1cd$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $bd245ff483f5f1cd$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $bd245ff483f5f1cd$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$bd245ff483f5f1cd$var$updatePayloadWithContext(primaryTag, event),
        tags: $bd245ff483f5f1cd$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

parcelRegister("kdDm3", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $c72be9cf3e265f3a$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $c72be9cf3e265f3a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $f6SzU = parcelRequire("f6SzU");

var $8GASP = parcelRequire("8GASP");

var $5M6QO = parcelRequire("5M6QO");
const $c72be9cf3e265f3a$export$a1d9dc589a29b3aa = 'editor';
const $c72be9cf3e265f3a$export$8aa0d788f94a809 = 'fabricEditor';
class $c72be9cf3e265f3a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $8GASP.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $5M6QO.handleEvent)(event, [
                $c72be9cf3e265f3a$export$a1d9dc589a29b3aa,
                $c72be9cf3e265f3a$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}
$c72be9cf3e265f3a$export$2e2bcd8739ae039.displayName = "FabricEditorListener";

});




parcelRegister("cMFH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $28b74304c69c70fc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $776dk = parcelRequire("776dk");

var $3M9Z8 = parcelRequire("3M9Z8");
function $28b74304c69c70fc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).atlaskit,
        processEvent: (0, $776dk.default)
    });
}
$28b74304c69c70fc$export$2e2bcd8739ae039.displayName = "AtlaskitListener";

});
parcelRegister("776dk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9f3a300760370ae$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");


var $7KJ63 = parcelRequire("7KJ63");

var $2GJNK = parcelRequire("2GJNK");

var $886kc = parcelRequire("886kc");

var $1erCl = parcelRequire("1erCl");

var $9nhVb = parcelRequire("9nhVb");

var $bntcD = parcelRequire("bntcD");
const $e9f3a300760370ae$var$ATLASKIT_TAG = 'atlaskit';
const $e9f3a300760370ae$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e9f3a300760370ae$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bntcD.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $886kc.getExtraAttributes)(event);
    const components = (0, $2GJNK.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $9nhVb.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $e9f3a300760370ae$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $1erCl.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e9f3a300760370ae$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $6d4033511f75ada1$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $7KJ63.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $6d4033511f75ada1$export$947dac6c72b26f81) || eventType === (0, $6d4033511f75ada1$export$12346a674644c156) || eventType === (0, $6d4033511f75ada1$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("7KJ63", function(module, exports) {
$parcel$export(module.exports, "getActionSubject", () => $fd20c0e0dc80d99d$export$6f40cdf6d42c018d);
/**
 * Largely taken from analytics-web-react
 */ 
var $lJvjd = parcelRequire("lJvjd");
const $fd20c0e0dc80d99d$export$6f40cdf6d42c018d = (event)=>{
    const overrides = (0, $lJvjd.extractFromEventContext)('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};

});
parcelRegister("lJvjd", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $a34d9b8b277f4b49$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $a34d9b8b277f4b49$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);

});


parcelRegister("2GJNK", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $e0d2dd08a0890113$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $lJvjd = parcelRequire("lJvjd");
const $e0d2dd08a0890113$export$4e811121b221213b = (event)=>(0, $lJvjd.extractFromEventContext)('component', event);

});

parcelRegister("886kc", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $c97df59755e3d106$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $6Fltw = parcelRequire("6Fltw");

var $lJvjd = parcelRequire("lJvjd");
const $c97df59755e3d106$export$67c3590839ebecdd = (event)=>(0, $lJvjd.extractFromEventContext)('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraAttributes), {});

});

parcelRegister("1erCl", function(module, exports) {
$parcel$export(module.exports, "getPackageHierarchy", () => $30753a66ea668eb4$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $9nhVb = parcelRequire("9nhVb");
function $30753a66ea668eb4$export$4e0b83da1896ebc7(event) {
    const packages = (0, $9nhVb.getPackageInfo)(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});
parcelRegister("9nhVb", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $ff0154d79591a2d8$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $ff0154d79591a2d8$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);

});


parcelRegister("bntcD", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $5a6cb16cf076299a$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $lJvjd = parcelRequire("lJvjd");
const $5a6cb16cf076299a$export$5f9bc633b116660f = (event)=>(0, $lJvjd.extractFromEventContext)('source', event);

});


parcelRegister("3M9Z8", function(module, exports) {
$parcel$export(module.exports, "default", () => $d092155f622bc8e1$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $f6SzU = parcelRequire("f6SzU");

var $enl0k = parcelRequire("enl0k");
class $d092155f622bc8e1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $enl0k.sendEvent)(logger, client)(payload);
        };
    }
}
$d092155f622bc8e1$export$2e2bcd8739ae039.displayName = "GenericAnalyticsListener";

});


parcelRegister("bYMEe", function(module, exports) {
$parcel$export(module.exports, "LOG_LEVEL", () => $6059fb10c92a19b7$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $6059fb10c92a19b7$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $6059fb10c92a19b7$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $6059fb10c92a19b7$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $6059fb10c92a19b7$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $6059fb10c92a19b7$export$ffe0c436e29512cf.DEBUG && logLevel <= $6059fb10c92a19b7$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $6059fb10c92a19b7$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($6059fb10c92a19b7$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($6059fb10c92a19b7$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($6059fb10c92a19b7$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($6059fb10c92a19b7$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("frbv6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fc039b092bbc8fc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $19joB = parcelRequire("19joB");

var $3M9Z8 = parcelRequire("3M9Z8");
function $1fc039b092bbc8fc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).navigation,
        processEvent: (0, $19joB.default)
    });
}
$1fc039b092bbc8fc$export$2e2bcd8739ae039.displayName = "NavigationListener";

});
parcelRegister("19joB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4516262e24e99965$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $hExZX = parcelRequire("hExZX");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $4516262e24e99965$var$NAVIGATION_TAG = 'navigation';
const $4516262e24e99965$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4516262e24e99965$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $hExZX.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $hExZX.NAVIGATION_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $hExZX.NAVIGATION_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $hExZX.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $hExZX.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4516262e24e99965$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4516262e24e99965$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("kPLqc", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $4dab45e86d3d0cbd$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $cEx4r = parcelRequire("cEx4r");
const $4dab45e86d3d0cbd$export$4e811121b221213b = (event, contextName)=>(0, $cEx4r.extractFromEventContext)([
        'component',
        'componentName'
    ], event, false, contextName);

});
parcelRegister("cEx4r", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $1aa1c0381f28efd5$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $1aa1c0381f28efd5$export$9b947b4502cd2705 = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);

});


parcelRegister("eLSB0", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $6893c7215870d27d$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $6Fltw = parcelRequire("6Fltw");

var $cEx4r = parcelRequire("cEx4r");
const $6893c7215870d27d$export$67c3590839ebecdd = (event, contextName)=>(0, $cEx4r.extractFromEventContext)([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraAttributes), {});

});

parcelRegister("ljIqB", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $a1506466dcb6d29a$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $a1506466dcb6d29a$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);

});

parcelRegister("6a89q", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $0da814eb5a37d809$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $cEx4r = parcelRequire("cEx4r");
const $0da814eb5a37d809$export$5f9bc633b116660f = (event, contextName)=>(0, $cEx4r.extractFromEventContext)([
        'source'
    ], event, false, contextName);

});



parcelRegister("DCds6", function(module, exports) {
$parcel$export(module.exports, "default", () => $afbc28709e4c5dae$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $3iNaw = parcelRequire("3iNaw");

var $3M9Z8 = parcelRequire("3M9Z8");
function $afbc28709e4c5dae$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).media,
        processEvent: (0, $3iNaw.processEvent)
    });
}
$afbc28709e4c5dae$export$2e2bcd8739ae039.displayName = "MediaAnalyticsListener";

});
parcelRegister("3iNaw", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $258d0ae908940207$export$22af68e3614bf024);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");

var $lJvjd = parcelRequire("lJvjd");

var $2GJNK = parcelRequire("2GJNK");

var $886kc = parcelRequire("886kc");

var $1erCl = parcelRequire("1erCl");

var $9nhVb = parcelRequire("9nhVb");

var $bntcD = parcelRequire("bntcD");
const $258d0ae908940207$var$listenerVersion = "0.0.0-use.local";
function $258d0ae908940207$var$getMediaContexts(event) {
    return (0, $lJvjd.extractFromEventContext)((0, $c4e639dc1b853f95$export$70df29c238ba7306), event);
}
function $258d0ae908940207$var$getMediaRegion() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $258d0ae908940207$export$22af68e3614bf024(event) {
    const sources = (0, $bntcD.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $9nhVb.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $886kc.getExtraAttributes)(event);
    const mediaContexts = $258d0ae908940207$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $2GJNK.getComponents)(event);
    const mediaRegion = $258d0ae908940207$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $1erCl.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $258d0ae908940207$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("9KRIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6983316959bcbfd9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $6TFzU = parcelRequire("6TFzU");

var $3M9Z8 = parcelRequire("3M9Z8");
function $6983316959bcbfd9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).peopleTeams,
        processEvent: (0, $6TFzU.default)
    });
}
$6983316959bcbfd9$export$2e2bcd8739ae039.displayName = "PeopleTeamsAnalyticsListener";

});
parcelRegister("6TFzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6811d587754076f4$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $7MmBF = parcelRequire("7MmBF");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $6811d587754076f4$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $6811d587754076f4$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $6811d587754076f4$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $7MmBF.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $7MmBF.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $7MmBF.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $7MmBF.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $7MmBF.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $6811d587754076f4$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($6811d587754076f4$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("7c2Di", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab7c69e2788b44f$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $2COW0 = parcelRequire("2COW0");

var $3M9Z8 = parcelRequire("3M9Z8");
function $cab7c69e2788b44f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).notifications,
        processEvent: (0, $2COW0.default)
    });
}
$cab7c69e2788b44f$export$2e2bcd8739ae039.displayName = "NotificationsAnalyticsListener";

});
parcelRegister("2COW0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1ee89d4cb78b952$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $4QdkY = parcelRequire("4QdkY");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");

var $8GASP = parcelRequire("8GASP");
const $c1ee89d4cb78b952$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c1ee89d4cb78b952$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $4QdkY.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $4QdkY.NOTIFICATIONS_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $4QdkY.NOTIFICATIONS_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $4QdkY.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $4QdkY.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c1ee89d4cb78b952$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $8GASP.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("laHn3", function(module, exports) {
$parcel$export(module.exports, "default", () => $3834a840479ef78a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $jwhUB = parcelRequire("jwhUB");

var $3M9Z8 = parcelRequire("3M9Z8");
function $3834a840479ef78a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).recentWork,
        processEvent: (0, $jwhUB.default)
    });
}
$3834a840479ef78a$export$2e2bcd8739ae039.displayName = "RecentWorkAnalyticsListener";

});
parcelRegister("jwhUB", function(module, exports) {
$parcel$export(module.exports, "default", () => $96775c0154f8277d$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $c5bMY = parcelRequire("c5bMY");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");

var $8GASP = parcelRequire("8GASP");
const $96775c0154f8277d$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $96775c0154f8277d$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $c5bMY.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $c5bMY.RECENT_WORK_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $c5bMY.RECENT_WORK_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $c5bMY.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $c5bMY.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $96775c0154f8277d$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $8GASP.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9zYuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $573dfff06011aa36$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $lDX3W = parcelRequire("lDX3W");

var $3M9Z8 = parcelRequire("3M9Z8");
function $573dfff06011aa36$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).atlas,
        processEvent: (0, $lDX3W.default)
    });
}
$573dfff06011aa36$export$2e2bcd8739ae039.displayName = "AtlasAnalyticsListener";

});
parcelRegister("lDX3W", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e814b74a3db833$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $cRhez = parcelRequire("cRhez");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $55e814b74a3db833$var$ATLAS_TAG = 'atlas';
const $55e814b74a3db833$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $55e814b74a3db833$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $cRhez.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $cRhez.ATLAS_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $cRhez.ATLAS_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $cRhez.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $cRhez.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $55e814b74a3db833$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($55e814b74a3db833$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("5VXFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b0d9f4d9c0df53b$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $kJraC = parcelRequire("kJraC");

var $3M9Z8 = parcelRequire("3M9Z8");
function $0b0d9f4d9c0df53b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).crossFlow,
        processEvent: (0, $kJraC.default)
    });
}
$0b0d9f4d9c0df53b$export$2e2bcd8739ae039.displayName = "CrossFlowAnalyticsListener";

});
parcelRegister("kJraC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ac22a265bb5de0f$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

parcelRequire("5ySJg");
var $hExZX = parcelRequire("hExZX");

var $886kc = parcelRequire("886kc");

var $bntcD = parcelRequire("bntcD");

var $eLSB0 = parcelRequire("eLSB0");
const $1ac22a265bb5de0f$var$CROSS_FLOW_TAG = 'crossFlow';
var $1ac22a265bb5de0f$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $bntcD.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $886kc.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $eLSB0.getExtraAttributes)(event, (0, $hExZX.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($1ac22a265bb5de0f$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kPQd0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0676dd02e828cffc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $inUtC = parcelRequire("inUtC");

var $8GASP = parcelRequire("8GASP");

var $3M9Z8 = parcelRequire("3M9Z8");
function $0676dd02e828cffc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).linkingPlatform,
        processEvent: (0, $inUtC.default)
    });
}
$0676dd02e828cffc$export$2e2bcd8739ae039.displayName = "LinkingPlatformAnalyticsListener";

});
parcelRegister("inUtC", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb085bb48dc5b126$export$2e2bcd8739ae039);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $kabGl = parcelRequire("kabGl");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");

var $8GASP = parcelRequire("8GASP");
const $fb085bb48dc5b126$var$listenerVersion = "0.0.0-use.local";
var $fb085bb48dc5b126$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $kabGl.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $kabGl.LINKING_PLATFORM_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $kabGl.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $kabGl.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $8GASP.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $fb085bb48dc5b126$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("hrWfZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $48260677a85d29df$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $eyDa2 = parcelRequire("eyDa2");

var $3M9Z8 = parcelRequire("3M9Z8");
function $48260677a85d29df$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).postOffice,
        processEvent: (0, $eyDa2.default)
    });
}
$48260677a85d29df$export$2e2bcd8739ae039.displayName = "PostOfficeAnalyticsListener";

});
parcelRegister("eyDa2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4559c8082ad86b5f$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $2J2dU = parcelRequire("2J2dU");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");

var $8GASP = parcelRequire("8GASP");
const $4559c8082ad86b5f$var$POST_OFFICE_TAG = (0, $8GASP.FabricChannel).postOffice;
const $4559c8082ad86b5f$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4559c8082ad86b5f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $2J2dU.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $2J2dU.POST_OFFICE_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $2J2dU.POST_OFFICE_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $2J2dU.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $2J2dU.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4559c8082ad86b5f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4559c8082ad86b5f$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("7bGZo", function(module, exports) {
$parcel$export(module.exports, "default", () => $434df45e57d0de50$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $lSbId = parcelRequire("lSbId");

var $3M9Z8 = parcelRequire("3M9Z8");
function $434df45e57d0de50$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).aiMate,
        processEvent: (0, $lSbId.default)
    });
}
$434df45e57d0de50$export$2e2bcd8739ae039.displayName = "AIMateAnalyticsListener";

});
parcelRegister("lSbId", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0c1bcb4f8010f6d$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $ja81e = parcelRequire("ja81e");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $c0c1bcb4f8010f6d$var$AI_MATE_TAG = 'aiMate';
const $c0c1bcb4f8010f6d$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c0c1bcb4f8010f6d$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $ja81e.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $ja81e.AI_MATE_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $ja81e.AI_MATE_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $ja81e.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $ja81e.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $c0c1bcb4f8010f6d$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c0c1bcb4f8010f6d$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("a7zJy", function(module, exports) {
$parcel$export(module.exports, "default", () => $384ab96706e7f950$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $ijnwM = parcelRequire("ijnwM");

var $3M9Z8 = parcelRequire("3M9Z8");
function $384ab96706e7f950$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).avp,
        processEvent: (0, $ijnwM.default)
    });
}
$384ab96706e7f950$export$2e2bcd8739ae039.displayName = "AVPAnalyticsListener";

});
parcelRegister("ijnwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c72233c946477a50$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $rdwEA = parcelRequire("rdwEA");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $c72233c946477a50$var$AVP_TAG = 'avp';
const $c72233c946477a50$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c72233c946477a50$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $rdwEA.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $rdwEA.AVP_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $rdwEA.AVP_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $rdwEA.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $rdwEA.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c72233c946477a50$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c72233c946477a50$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("8BzOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $183975e875fcd408$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $1vxMr = parcelRequire("1vxMr");

var $3M9Z8 = parcelRequire("3M9Z8");
function $183975e875fcd408$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).growth,
        processEvent: (0, $1vxMr.default)
    });
}
$183975e875fcd408$export$2e2bcd8739ae039.displayName = "GrowthAnalyticsListener";

});
parcelRegister("1vxMr", function(module, exports) {
$parcel$export(module.exports, "default", () => $30fc68e3db90fad8$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $78a5e = parcelRequire("78a5e");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $30fc68e3db90fad8$var$GROWTH_TAG = 'growth';
const $30fc68e3db90fad8$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $30fc68e3db90fad8$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $78a5e.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $78a5e.GROWTH_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $78a5e.GROWTH_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $78a5e.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $78a5e.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $30fc68e3db90fad8$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($30fc68e3db90fad8$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("48PBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a1501e4829b97bb$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $5JGbW = parcelRequire("5JGbW");

var $3M9Z8 = parcelRequire("3M9Z8");
const $9a1501e4829b97bb$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).omniChannel,
        processEvent: (0, $5JGbW.default)
    });
};
$9a1501e4829b97bb$var$OmniChannelAnalyticsListener.displayName = "OmniChannelAnalyticsListener";
var $9a1501e4829b97bb$export$2e2bcd8739ae039 = $9a1501e4829b97bb$var$OmniChannelAnalyticsListener;

});
parcelRegister("5JGbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d809458c40fd6093$export$2e2bcd8739ae039);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $lX9Wi = parcelRequire("lX9Wi");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");

var $8GASP = parcelRequire("8GASP");
const $d809458c40fd6093$var$listenerVersion = "0.0.0-use.local";
var $d809458c40fd6093$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $lX9Wi.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $lX9Wi.OMNI_CHANNEL_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $lX9Wi.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $lX9Wi.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $lX9Wi.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d809458c40fd6093$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $8GASP.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("igNBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ce4d99546ac089$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $bVNaR = parcelRequire("bVNaR");

var $3M9Z8 = parcelRequire("3M9Z8");
function $c4ce4d99546ac089$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).townsquareHome,
        processEvent: (0, $bVNaR.default)
    });
}
$c4ce4d99546ac089$export$2e2bcd8739ae039.displayName = "TownsquareHomeAnalyticsListener";

});
parcelRegister("bVNaR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d253292d956b6f4e$export$2e2bcd8739ae039);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $1NVGR = parcelRequire("1NVGR");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $d253292d956b6f4e$var$TOWNSQUARE_TAG = 'townsquare';
const $d253292d956b6f4e$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $d253292d956b6f4e$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $d253292d956b6f4e$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $1NVGR.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $1NVGR.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $1NVGR.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $1NVGR.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $1NVGR.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d253292d956b6f4e$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($d253292d956b6f4e$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($d253292d956b6f4e$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("4SkJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc365437416331fa$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $fcT7X = parcelRequire("fcT7X");

var $3M9Z8 = parcelRequire("3M9Z8");
function $dc365437416331fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).rovoExtension,
        processEvent: (0, $fcT7X.default)
    });
}
$dc365437416331fa$export$2e2bcd8739ae039.displayName = "RovoExtensionAnalyticsListener";

});
parcelRegister("fcT7X", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b8dc33c66fb4859$export$2e2bcd8739ae039);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

parcelRequire("5ySJg");
var $a4B2I = parcelRequire("a4B2I");

var $kPLqc = parcelRequire("kPLqc");

var $eLSB0 = parcelRequire("eLSB0");

var $ljIqB = parcelRequire("ljIqB");

var $6a89q = parcelRequire("6a89q");
const $9b8dc33c66fb4859$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $9b8dc33c66fb4859$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $9b8dc33c66fb4859$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $6a89q.getSources)(event, (0, $a4B2I.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c);
    const extraAttributes = (0, $eLSB0.getExtraAttributes)(event, (0, $a4B2I.ROVO_EXTENSION_CONTEXT));
    const components = (0, $kPLqc.getComponents)(event, (0, $a4B2I.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $ljIqB.getPackageInfo)(event, (0, $a4B2I.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $ljIqB.getPackageInfo)(event, (0, $a4B2I.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $6d4033511f75ada1$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9b8dc33c66fb4859$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($9b8dc33c66fb4859$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $6d4033511f75ada1$export$a1562d08625f5d7e:
        case 0, $6d4033511f75ada1$export$12346a674644c156:
        case 0, $6d4033511f75ada1$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $6d4033511f75ada1$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("5ZtJc", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc9e72902689eaea$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8GASP = parcelRequire("8GASP");

var $O8NeS = parcelRequire("O8NeS");

var $3M9Z8 = parcelRequire("3M9Z8");
function $cc9e72902689eaea$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3M9Z8.default), {
        ...props,
        channel: (0, $8GASP.FabricChannel).teamworkGraph,
        processEvent: (0, $O8NeS.processEvent)
    });
}
$cc9e72902689eaea$export$2e2bcd8739ae039.displayName = "TeamworkGraphAnalyticsListener";

});
parcelRegister("O8NeS", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $50652ef9465ee4c3$export$22af68e3614bf024);

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");


var $2GJNK = parcelRequire("2GJNK");

var $886kc = parcelRequire("886kc");

var $1erCl = parcelRequire("1erCl");

var $9nhVb = parcelRequire("9nhVb");

var $bntcD = parcelRequire("bntcD");
const $50652ef9465ee4c3$var$listenerVersion = "0.0.0-use.local";
function $50652ef9465ee4c3$export$22af68e3614bf024(event) {
    const sources = (0, $bntcD.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $9nhVb.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $886kc.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, $2GJNK.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources) || (0, $6d4033511f75ada1$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $1erCl.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $50652ef9465ee4c3$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});




parcelRegister("ku3pl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("f1Spj")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("63XI1")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("8RTvC")).default);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("cSvIR")).FlagsProvider);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("32hW2")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("4pQjk")).withFlagsProvider);

var $f1Spj = parcelRequire("f1Spj");

var $63XI1 = parcelRequire("63XI1");

var $8RTvC = parcelRequire("8RTvC");

var $cSvIR = parcelRequire("cSvIR");

var $32hW2 = parcelRequire("32hW2");

var $4pQjk = parcelRequire("4pQjk");

});
parcelRegister("f1Spj", function(module, exports) {
$parcel$export(module.exports, "default", () => $35d3bed9bf40a688$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $1MNmN = parcelRequire("1MNmN");

var $2oRWW = parcelRequire("2oRWW");

var $2iotI = parcelRequire("2iotI");

var $iqfTZ = parcelRequire("iqfTZ");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $apUrw = parcelRequire("apUrw");


var $5cy7m = parcelRequire("5cy7m");

var $6Stx9 = parcelRequire("6Stx9");

var $9Ivbx = parcelRequire("9Ivbx");

var $5knms = parcelRequire("5knms");

var $34X4G = parcelRequire("34X4G");

var $4jRI4 = parcelRequire("4jRI4");

var $9yw2G = parcelRequire("9yw2G");

var $jjk9b = parcelRequire("jjk9b");

var $6QQ0s = parcelRequire("6QQ0s");
const $35d3bed9bf40a688$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
const $35d3bed9bf40a688$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $35d3bed9bf40a688$var$descriptionStyles = null;
const $35d3bed9bf40a688$var$flagWrapperStyles = null;
const $35d3bed9bf40a688$var$iconWrapperStyles = null;
const $35d3bed9bf40a688$var$transitionStyles = null;
const $35d3bed9bf40a688$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; /**
    * __Flag__
    *
    * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
    * often displayed using a flag group.
    *
    * - [Examples](https://atlassian.design/components/flag/examples)
    * - [Code](https://atlassian.design/components/flag/code)
    * - [Usage](https://atlassian.design/components/flag/usage)
    */ 
const $35d3bed9bf40a688$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $9eab319dcc173e7e$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $2oRWW.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $2oRWW.default), onDismissed: onDismissedProp = (0, $2oRWW.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $euxye.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6QQ0s.useFlagGroup)();
    const onDismissed = (0, $euxye.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $euxye.useState)(false);
    const onDismissedAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$35d3bed9bf40a688$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $9eab319dcc173e7e$export$d6830277b06edd6);
    const toggleExpand = (0, $euxye.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $euxye.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $euxye.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$35d3bed9bf40a688$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$35d3bed9bf40a688$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $34X4G.flagTextColor)[appearance];
    const iconColor = (0, $9Ivbx.flagIconColor)[appearance];
    const iconGlyph = (0, $5knms.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $apUrw.default), {
        children: [
            title,
            description
        ]
    }) : undefined; // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $4jQY2.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
            padding: "space.200",
            backgroundColor: (0, $6Stx9.flagBackgroundColor)[appearance],
            xcss: (0, $1MNmN.cx)($35d3bed9bf40a688$var$styles.flag, (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && $35d3bed9bf40a688$var$styles.flagT26Shape),
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$35d3bed9bf40a688$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $4jQY2.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            "_v5641hdc _1ul9idpf _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $35d3bed9bf40a688$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)("span" /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ , {
                                                    "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9yw2G.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jjk9b.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $4jRI4.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $4jQY2.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5cy7m.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
$35d3bed9bf40a688$var$Flag.displayName = "Flag";
var $35d3bed9bf40a688$export$2e2bcd8739ae039 = $35d3bed9bf40a688$var$Flag;

});
parcelRegister("aZBDA", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $12402404b670f970$export$a4687b0234b40e28);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $7v5Xl = parcelRequire("7v5Xl");
function $12402404b670f970$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $7v5Xl.useTrackedRef)(analyticsData);
    const fnRef = (0, $7v5Xl.useTrackedRef)(fn);
    const handler = (0, $euxye.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("inMxE", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $53d8ab496896371b$export$5bf35293e545f20c);

var $g0QMA = parcelRequire("g0QMA");

var $9xulT = parcelRequire("9xulT");

var $9BThh = parcelRequire("9BThh");
function $53d8ab496896371b$export$5bf35293e545f20c() {
    const analyticsContext = (0, $9BThh.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $g0QMA.useCallbackOne)((payload)=>{
        return new (0, $9xulT.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("g0QMA", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $ba8596f9beedbe37$export$33752cf3ee811995);

var $euxye = parcelRequire("euxye");
function $ba8596f9beedbe37$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $ba8596f9beedbe37$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $euxye.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var committed = (0, $euxye.useRef)(initial);
    var isInputMatch = Boolean(inputs && committed.current.inputs && $ba8596f9beedbe37$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = isInputMatch ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $euxye.useEffect)(function() {
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $ba8596f9beedbe37$export$33752cf3ee811995(callback, inputs) {
    return $ba8596f9beedbe37$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $ba8596f9beedbe37$export$1538c33de8887b59 = $ba8596f9beedbe37$export$b6feb8998cd9b342;
var $ba8596f9beedbe37$export$35808ee640e87ca7 = $ba8596f9beedbe37$export$33752cf3ee811995;

});

parcelRegister("9xulT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f373b2d6675cdba6$export$2e2bcd8739ae039);
/// <reference types="node" />

var $iqfTZ = parcelRequire("iqfTZ");

var $bEzCm = parcelRequire("bEzCm");
class $f373b2d6675cdba6$export$2e2bcd8739ae039 extends (0, $bEzCm.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $f373b2d6675cdba6$var$clonePayload(this.payload);
            return new $f373b2d6675cdba6$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $f373b2d6675cdba6$var$clonePayload = (payload)=>{
    if ((0, $iqfTZ.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
    /**
	 * A hacky "deep clone" of the object. This is limited in that it wont
	 * support functions, regexs, Maps, Sets, etc, but none of those need to
	 * be represented in our payload.
	 */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("bEzCm", function(module, exports) {
$parcel$export(module.exports, "default", () => $471a8d2633a9512d$export$2e2bcd8739ae039);
class $471a8d2633a9512d$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $471a8d2633a9512d$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});




parcelRegister("1MNmN", function(module, exports) {
$parcel$export(module.exports, "cx", () => $77f8c05b7b8a6804$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ parcelRequire("euxye");

var $7rN3V = parcelRequire("7rN3V");
const $77f8c05b7b8a6804$var$strictApi = (0, $7rN3V.createStrictAPI)();
const $77f8c05b7b8a6804$export$dbf350e5966cf602 = $77f8c05b7b8a6804$var$strictApi.css;
const $77f8c05b7b8a6804$export$eb1ecd84a24ee424 = $77f8c05b7b8a6804$var$strictApi.cssMap;
$77f8c05b7b8a6804$var$strictApi.cssMap;
const $77f8c05b7b8a6804$export$a274e22fb40f762e = $77f8c05b7b8a6804$var$strictApi.cx;
const $77f8c05b7b8a6804$var$XCSSProp = $77f8c05b7b8a6804$var$strictApi.XCSSProp;

});

parcelRegister("2oRWW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdce4f81a056b344$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $cdce4f81a056b344$export$2e2bcd8739ae039() {}

});

parcelRegister("2iotI", function(module, exports) {
$parcel$export(module.exports, "default", () => $740e1e086a803f6e$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $cyjKA = parcelRequire("cyjKA");

var $2Xrjb = parcelRequire("2Xrjb");

var $hh7Bb = parcelRequire("hh7Bb");

var $gIMgJ = parcelRequire("gIMgJ");
const $740e1e086a803f6e$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $740e1e086a803f6e$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $740e1e086a803f6e$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $740e1e086a803f6e$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $740e1e086a803f6e$var$useColor = (colorProp)=>{
    const surface = (0, $2Xrjb.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $cyjKA.inverseColorMap).hasOwnProperty(surface)) return (0, $cyjKA.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $740e1e086a803f6e$var$Heading = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $gIMgJ;
    const [hLevel, inferredElement] = (0, $hh7Bb.useHeading)($740e1e086a803f6e$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $740e1e086a803f6e$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $4jQY2.default)([
            $740e1e086a803f6e$var$styles.reset,
            $740e1e086a803f6e$var$headingSizeStyles[size],
            $740e1e086a803f6e$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $740e1e086a803f6e$export$2e2bcd8739ae039 = $740e1e086a803f6e$var$Heading;

});
parcelRegister("cyjKA", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $387d023252c1b89e$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::828feee5f551f4f72139928d095ef0f9>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $387d023252c1b89e$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("2Xrjb", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $e918d00ba06b77aa$export$1aeb4f6b93c4540d);

var $euxye = parcelRequire("euxye");

var $142Tc = parcelRequire("142Tc");
const $e918d00ba06b77aa$export$1aeb4f6b93c4540d = ()=>{
    return (0, $euxye.useContext)((0, $142Tc.SurfaceContext));
};
(0, $142Tc.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("142Tc", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $2022c9f0694b477b$export$1ca2a26fecb070ae);

var $euxye = parcelRequire("euxye");
const $2022c9f0694b477b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $euxye.createContext)('elevation.surface');

});


parcelRegister("hh7Bb", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $df31916a0c972e18$export$97a37b1befbbf9b1);

var $jZMJE = parcelRequire("jZMJE");
const $df31916a0c972e18$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $jZMJE.useHeadingLevel)();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("jZMJE", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $7e4eb55ed6b622f2$export$6a64a1e2d0bbbf75);

var $euxye = parcelRequire("euxye");

var $5LifH = parcelRequire("5LifH");
const $7e4eb55ed6b622f2$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $euxye.useContext)((0, $5LifH.HeadingLevelContext));
};

});
parcelRegister("5LifH", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $3755329956a521dd$export$d1fa8a19e192bc63);

var $euxye = parcelRequire("euxye");
const $3755329956a521dd$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $euxye.createContext)(0);

});




parcelRegister("ihEDU", function(module, exports) {
$parcel$export(module.exports, "Box", () => $325116577c80556f$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $142Tc = parcelRequire("142Tc");
const $325116577c80556f$var$baseStyles = null;
const $325116577c80556f$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $325116577c80556f$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $325116577c80556f$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $325116577c80556f$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $325116577c80556f$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $325116577c80556f$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $325116577c80556f$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
const $325116577c80556f$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $4jQY2.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $325116577c80556f$var$backgroundColorMap[backgroundColor],
            backgroundColor && $325116577c80556f$var$isSurfaceToken(backgroundColor) && $325116577c80556f$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $325116577c80556f$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $325116577c80556f$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $325116577c80556f$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $325116577c80556f$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $142Tc.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
function $325116577c80556f$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $325116577c80556f$var$setSurfaceTokenMap;
}

});

parcelRegister("defJG", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $5b1f5d1326f5d486$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1MNmN = parcelRequire("1MNmN");

var $2XXtG = parcelRequire("2XXtG");
const $5b1f5d1326f5d486$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $5b1f5d1326f5d486$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $5b1f5d1326f5d486$var$styles.separator
        ]),
        children: children
    });
$5b1f5d1326f5d486$var$Separator.displayName = "Separator";
const $5b1f5d1326f5d486$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $e79Pd.jsx)($5b1f5d1326f5d486$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $euxye.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $1MNmN.cx)(grow === 'hug' && $5b1f5d1326f5d486$var$styles.hug, grow === 'fill' && $5b1f5d1326f5d486$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$5b1f5d1326f5d486$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("2XXtG", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $3bc4e1ed9b6a0f6e$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $3bc4e1ed9b6a0f6e$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3bc4e1ed9b6a0f6e$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3bc4e1ed9b6a0f6e$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3bc4e1ed9b6a0f6e$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $3bc4e1ed9b6a0f6e$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $3bc4e1ed9b6a0f6e$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3bc4e1ed9b6a0f6e$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
const $3bc4e1ed9b6a0f6e$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $4jQY2.default)([
            $3bc4e1ed9b6a0f6e$var$styles.root,
            gap && $3bc4e1ed9b6a0f6e$var$columnGapMap[gap],
            columnGap && $3bc4e1ed9b6a0f6e$var$columnGapMap[columnGap],
            gap && $3bc4e1ed9b6a0f6e$var$rowGapMap[gap],
            rowGap && $3bc4e1ed9b6a0f6e$var$rowGapMap[rowGap],
            alignItems && $3bc4e1ed9b6a0f6e$var$alignItemsMap[alignItems],
            direction && $3bc4e1ed9b6a0f6e$var$flexDirectionMap[direction],
            justifyContent && $3bc4e1ed9b6a0f6e$var$justifyContentMap[justifyContent],
            wrap && $3bc4e1ed9b6a0f6e$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3bc4e1ed9b6a0f6e$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("3PC9r", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $4cf8881a0637bfea$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $2XXtG = parcelRequire("2XXtG");
const $4cf8881a0637bfea$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $4cf8881a0637bfea$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $1MNmN.cx)(grow === 'hug' && $4cf8881a0637bfea$var$styles.hug, grow === 'fill' && $4cf8881a0637bfea$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$4cf8881a0637bfea$export$694e0d28c7ffc90c.displayName = 'Stack';

});

parcelRegister("apUrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7b8e384bdf67c07$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $a7b8e384bdf67c07$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $a7b8e384bdf67c07$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$a7b8e384bdf67c07$var$VisuallyHidden.displayName = "VisuallyHidden";
$a7b8e384bdf67c07$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $a7b8e384bdf67c07$export$2e2bcd8739ae039 = $a7b8e384bdf67c07$var$VisuallyHidden;

});

const $9eab319dcc173e7e$export$d6830277b06edd6 = 'normal';
const $9eab319dcc173e7e$export$1eee5ddc4f6d41c5 = 400;

parcelRegister("5cy7m", function(module, exports) {
$parcel$export(module.exports, "default", () => $19cef96093a366e1$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4YhY5 = parcelRequire("4YhY5");

var $iqfTZ = parcelRequire("iqfTZ");

var $defJG = parcelRequire("defJG");

var $gNOwU = parcelRequire("gNOwU");


var $apFpq = parcelRequire("apFpq");
const $19cef96093a366e1$var$buttonStylesOld = null;
const $19cef96093a366e1$var$buttonStyles = null;
const $19cef96093a366e1$var$fontStyles = null;
const $19cef96093a366e1$var$appearanceNormalButtonStyles = null;
const $19cef96093a366e1$var$appearanceBoldButtonStyles = null;
const $19cef96093a366e1$var$appearanceNormalActionsContainerStyles = null;
const $19cef96093a366e1$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $9eab319dcc173e7e$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $9eab319dcc173e7e$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>(0, $iqfTZ.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4YhY5.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $gNOwU.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $apFpq.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $apFpq.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $apFpq.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $4jQY2.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4YhY5.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $gNOwU.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $apFpq.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $apFpq.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $apFpq.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $4jQY2.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
$19cef96093a366e1$var$FlagActions.displayName = "FlagActions";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19cef96093a366e1$export$2e2bcd8739ae039 = $19cef96093a366e1$var$FlagActions;

});
parcelRegister("4YhY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e3b56936135f9c9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $d0GZJ = parcelRequire("d0GZJ");

var $b3FBM = parcelRequire("b3FBM");

var $jK1pi = parcelRequire("jK1pi");

var $gIrl0 = parcelRequire("gIrl0");

var $dfGTB = parcelRequire("dfGTB");

var $guxry = parcelRequire("guxry");

var $fIDws = parcelRequire("fIDws");
function $7e3b56936135f9c9$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $7e3b56936135f9c9$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $7e3b56936135f9c9$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $dfGTB.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $euxye.useState)($7e3b56936135f9c9$var$initial);
    const onMouseEnter = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $euxye.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fIDws.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0GZJ))).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $fIDws.default).Consumer, {
                    mode: mode,
                    state: $7e3b56936135f9c9$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $jK1pi.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $b3FBM.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gIrl0.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $guxry.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$7e3b56936135f9c9$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $7e3b56936135f9c9$export$2e2bcd8739ae039 = $7e3b56936135f9c9$var$CustomThemeButton;

});
parcelRegister("b3FBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5332341eaf9abd0e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");

var $4jiTv = parcelRequire("4jiTv");

var $2ZiFh = parcelRequire("2ZiFh");

var $Cs8MU = parcelRequire("Cs8MU");

var $9Izez = parcelRequire("9Izez");

var $icHof = parcelRequire("icHof");

var $1yetE = parcelRequire("1yetE");

var $gFg8y = parcelRequire("gFg8y");

var $9BJHQ = parcelRequire("9BJHQ");

var $bqPxZ = parcelRequire("bqPxZ");
function $5332341eaf9abd0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $5332341eaf9abd0e$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $5332341eaf9abd0e$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $5332341eaf9abd0e$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $5332341eaf9abd0e$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $9BJHQ.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $5332341eaf9abd0e$var$getChildren = (children, childrenStyles)=>{
    if ((0, $9BJHQ.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $5332341eaf9abd0e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $2oRWW.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $2oRWW.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $euxye.useRef)();
    const setRef = (0, $euxye.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $4jiTv.default)(ourRef, autoFocus);
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $euxye.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $euxye.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $hStPE.css)((0, $1yetE.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $2ZiFh.default), null, /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5332341eaf9abd0e$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $9Izez.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gFg8y.getIconStyle)({
                spacing: spacing
            }),
            $5332341eaf9abd0e$var$getSpacingFix(children, $5332341eaf9abd0e$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $5332341eaf9abd0e$var$getChildren(children, [
        fadeStyles,
        (0, $icHof.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gFg8y.getIconStyle)({
                spacing: spacing
            }),
            $5332341eaf9abd0e$var$getSpacingFix(children, $5332341eaf9abd0e$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: [
            (0, $bqPxZ.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5332341eaf9abd0e$export$2e2bcd8739ae039 = $5332341eaf9abd0e$var$ButtonBase;

});
parcelRegister("4jiTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d53d594e8fbad3b3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $d53d594e8fbad3b3$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $euxye.useRef)(true);
    (0, $euxye.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("2ZiFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $da71fd749807dd79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");
const $da71fd749807dd79$var$BORDER_WIDTH = 2;
const $da71fd749807dd79$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $hStPE.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $da71fd749807dd79$var$BORDER_WIDTH
});
const $da71fd749807dd79$var$baseInsetStyles = /*#__PURE__*/ (0, $hStPE.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$da71fd749807dd79$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $da71fd749807dd79$var$focusRingStyles = /*#__PURE__*/ (0, $hStPE.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $da71fd749807dd79$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $da71fd749807dd79$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $da71fd749807dd79$var$insetFocusRingStyles = /*#__PURE__*/ (0, $hStPE.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $da71fd749807dd79$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $da71fd749807dd79$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $da71fd749807dd79$var$FocusRing = /*#__PURE__*/ (0, $euxye.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $da71fd749807dd79$var$baseInsetStyles : $da71fd749807dd79$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $da71fd749807dd79$var$insetFocusRingStyles : $da71fd749807dd79$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $hStPE.ClassNames), null, ({ css: css, cx: cx })=>(0, $euxye.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $euxye.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$da71fd749807dd79$var$FocusRing.displayName = 'FocusRing';
var $da71fd749807dd79$export$2e2bcd8739ae039 = $da71fd749807dd79$var$FocusRing;

});

parcelRegister("9Izez", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c938e79560f5d5$export$2e2bcd8739ae039);
function $25c938e79560f5d5$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $25c938e79560f5d5$var$tabKeyCode = 9;
function $25c938e79560f5d5$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $25c938e79560f5d5$var$tabKeyCode) return;
    $25c938e79560f5d5$var$abort(event);
}
const $25c938e79560f5d5$var$block = {
    onMouseDownCapture: $25c938e79560f5d5$var$abort,
    onMouseUpCapture: $25c938e79560f5d5$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $25c938e79560f5d5$var$onKey,
    onKeyUpCapture: $25c938e79560f5d5$var$onKey,
    onTouchStartCapture: $25c938e79560f5d5$var$abort,
    onTouchEndCapture: $25c938e79560f5d5$var$abort,
    onPointerDownCapture: $25c938e79560f5d5$var$abort,
    onPointerUpCapture: $25c938e79560f5d5$var$abort,
    onClickCapture: $25c938e79560f5d5$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $25c938e79560f5d5$var$abort
};
const $25c938e79560f5d5$var$doNotBlock = {};
function $25c938e79560f5d5$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $25c938e79560f5d5$var$doNotBlock : $25c938e79560f5d5$var$block;
}

});

parcelRegister("icHof", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $9713c739a007abd3$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");
function $9713c739a007abd3$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $hStPE.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("1yetE", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $4af5c831f3d1967e$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");
function $4af5c831f3d1967e$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $hStPE.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("gFg8y", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $2204328ebf3d9806$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");
function $2204328ebf3d9806$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $hStPE.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("9BJHQ", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $1a0dfec91369581b$export$20bbd2efb0d734c4);

var $euxye = parcelRequire("euxye");

var $apUrw = parcelRequire("apUrw");
const $1a0dfec91369581b$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $euxye.isValidElement)(children) && children.type === (0, $apUrw.default);
};

});

parcelRegister("bqPxZ", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $10310a058ebb48e4$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $10310a058ebb48e4$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("jK1pi", function(module, exports) {
$parcel$export(module.exports, "default", () => $084e4a3de1f821f3$export$2e2bcd8739ae039);

var $9BJHQ = parcelRequire("9BJHQ");
function $084e4a3de1f821f3$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $9BJHQ.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("gIrl0", function(module, exports) {
$parcel$export(module.exports, "default", () => $efdb5e5464cd8724$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $abhF2 = parcelRequire("abhF2");
function $efdb5e5464cd8724$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $efdb5e5464cd8724$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
        size: size,
        label: ", Loading",
        appearance: $efdb5e5464cd8724$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}
$efdb5e5464cd8724$export$2e2bcd8739ae039.displayName = "LoadingSpinner";

});
parcelRegister("abhF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b83d94c33aeca6c$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");

var $2ysKb = parcelRequire("2ysKb");
/**
 * Returns the appropriate circle stroke color.
 */ function $4b83d94c33aeca6c$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $4b83d94c33aeca6c$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $4b83d94c33aeca6c$var$loadIn = null;
const $4b83d94c33aeca6c$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $4b83d94c33aeca6c$var$useLayoutEffect = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $4b83d94c33aeca6c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $2ysKb.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $4b83d94c33aeca6c$var$getStrokeColor(appearance);
    const context = (0, $euxye.useContext)((0, $Cs8MU.default));
    $4b83d94c33aeca6c$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $4jQY2.default)([
            $4b83d94c33aeca6c$var$styles.wrapperStyles,
            $4b83d94c33aeca6c$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $4jQY2.default)([
                $4b83d94c33aeca6c$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $4jQY2.default)([
                    $4b83d94c33aeca6c$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $4b83d94c33aeca6c$export$2e2bcd8739ae039 = $4b83d94c33aeca6c$var$Spinner;

});
parcelRegister("2ysKb", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $9e3bdc4297c8785f$export$4e9f1640bbe7a1a8);
const $9e3bdc4297c8785f$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("dfGTB", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $d78134626081ea11$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $d78134626081ea11$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("guxry", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $34620a14447a0806$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $34620a14447a0806$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("fIDws", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e22fb58f086fc7c$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $d0GZJ = parcelRequire("d0GZJ");

var $c6OmI = parcelRequire("c6OmI");
const $1e22fb58f086fc7c$var$Theme = (0, $d0GZJ.createTheme)((themeProps)=>({
        buttonStyles: (0, $c6OmI.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1e22fb58f086fc7c$export$2e2bcd8739ae039 = $1e22fb58f086fc7c$var$Theme;

});
parcelRegister("c6OmI", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $c6b3772bc614c42a$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bCPR2 = parcelRequire("bCPR2");
const $c6b3772bc614c42a$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $c6b3772bc614c42a$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $bCPR2.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $c6b3772bc614c42a$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});
parcelRegister("bCPR2", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $4c770f60df3f709c$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iqfTZ = parcelRequire("iqfTZ");
const $4c770f60df3f709c$var$gridSize = 8;
const $4c770f60df3f709c$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $4c770f60df3f709c$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $4c770f60df3f709c$var$lineHeights = {
    default: $4c770f60df3f709c$var$heights.default,
    compact: $4c770f60df3f709c$var$heights.compact,
    none: 'inherit'
};
const $4c770f60df3f709c$var$padding = {
    // 10px gutter
    default: `0 ${$4c770f60df3f709c$var$gridSize + $4c770f60df3f709c$var$gridSize / 4}px`,
    compact: `0 ${$4c770f60df3f709c$var$gridSize + $4c770f60df3f709c$var$gridSize / 4}px`,
    none: '0'
};
const $4c770f60df3f709c$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$4c770f60df3f709c$var$gridSize / 4}px`,
    default: `0 ${$4c770f60df3f709c$var$gridSize / 4}px`,
    none: '0'
};
const $4c770f60df3f709c$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $4c770f60df3f709c$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $4c770f60df3f709c$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$4c770f60df3f709c$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $4c770f60df3f709c$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $4c770f60df3f709c$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $4c770f60df3f709c$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $4c770f60df3f709c$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $4c770f60df3f709c$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $4c770f60df3f709c$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $4c770f60df3f709c$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$4c770f60df3f709c$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ const $4c770f60df3f709c$var$defaultWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$defaultStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$4c770f60df3f709c$var$defaultStyles['&:hover'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$4c770f60df3f709c$var$defaultStyles['&:active'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }
};
const $4c770f60df3f709c$var$primaryWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$primaryStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$4c770f60df3f709c$var$primaryStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$4c770f60df3f709c$var$primaryStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $4c770f60df3f709c$var$linkWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$linkStyles,
    textDecoration: 'none'
};
const $4c770f60df3f709c$var$subtleWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$subtleStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$4c770f60df3f709c$var$subtleStyles['&:hover'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$4c770f60df3f709c$var$subtleStyles['&:active'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }
};
const $4c770f60df3f709c$var$subtleLinkWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$subtleLinkStyles,
    textDecoration: 'none'
};
const $4c770f60df3f709c$var$warningWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$warningStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$4c770f60df3f709c$var$warningStyles['&:hover'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$4c770f60df3f709c$var$warningStyles['&:active'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }
};
const $4c770f60df3f709c$var$dangerWithAnchorTextColorStyles = {
    ...$4c770f60df3f709c$var$dangerStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$4c770f60df3f709c$var$dangerStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$4c770f60df3f709c$var$dangerStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $4c770f60df3f709c$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $4c770f60df3f709c$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const appearanceStyles = (0, $iqfTZ.fg)('platform-dst-legacy-button-anchor-text-color') ? {
        ...appearance === 'default' && $4c770f60df3f709c$var$defaultWithAnchorTextColorStyles,
        ...appearance === 'primary' && $4c770f60df3f709c$var$primaryWithAnchorTextColorStyles,
        ...appearance === 'link' && $4c770f60df3f709c$var$linkWithAnchorTextColorStyles,
        ...appearance === 'subtle' && $4c770f60df3f709c$var$subtleWithAnchorTextColorStyles,
        ...appearance === 'subtle-link' && $4c770f60df3f709c$var$subtleLinkWithAnchorTextColorStyles,
        ...appearance === 'warning' && $4c770f60df3f709c$var$warningWithAnchorTextColorStyles,
        ...appearance === 'danger' && $4c770f60df3f709c$var$dangerWithAnchorTextColorStyles
    } : {
        ...appearance === 'default' && $4c770f60df3f709c$var$defaultStyles,
        ...appearance === 'primary' && $4c770f60df3f709c$var$primaryStyles,
        ...appearance === 'link' && $4c770f60df3f709c$var$linkStyles,
        ...appearance === 'subtle' && $4c770f60df3f709c$var$subtleStyles,
        ...appearance === 'subtle-link' && $4c770f60df3f709c$var$subtleLinkStyles,
        ...appearance === 'warning' && $4c770f60df3f709c$var$warningStyles,
        ...appearance === 'danger' && $4c770f60df3f709c$var$dangerStyles
    };
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $iqfTZ.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') ? `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)` : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $4c770f60df3f709c$var$heights[spacing],
        lineHeight: $4c770f60df3f709c$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $4c770f60df3f709c$var$singleIconPadding[spacing] : $4c770f60df3f709c$var$padding[spacing],
        verticalAlign: $4c770f60df3f709c$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $4c770f60df3f709c$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $4c770f60df3f709c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $4c770f60df3f709c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $4c770f60df3f709c$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$4c770f60df3f709c$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});




parcelRegister("gNOwU", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $ab32d6a63161061c$export$7bcfe3cca4dd78b6);
const $ab32d6a63161061c$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("apFpq", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $30e12c99d3911865$export$81ba6b63eedb299f);






const $30e12c99d3911865$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("6Stx9", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $566d528b870b15ee$export$59e42969c95d314);
const $566d528b870b15ee$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("9Ivbx", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $bcfa3feb1e676e9d$export$7f70afe2167f8235);
const $bcfa3feb1e676e9d$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("5knms", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $4e1fab0f0af68824$export$73f08aee70487cd4);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ah9qo = parcelRequire("ah9qo");

var $bgJDP = parcelRequire("bgJDP");

var $8Qvei = parcelRequire("8Qvei");

var $8QmUu = parcelRequire("8QmUu");
const $4e1fab0f0af68824$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgJDP))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8QmUu))), {
        label: ""
    })
};

});

parcelRegister("34X4G", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $1d673ca6cc929840$export$f50075b2584087f);
const $1d673ca6cc929840$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("4jRI4", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $a4bc5d1bfceac63e$export$13b42cd9d596bfe0);
const $a4bc5d1bfceac63e$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("9yw2G", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ee1ddc45b8a3f30$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $i68tN = parcelRequire("i68tN");

var $4jRI4 = parcelRequire("4jRI4");
const $3ee1ddc45b8a3f30$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($i68tN)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($aFpts))) : (0, (/*@__PURE__*/$parcel$interopDefault($ld25x)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $4jRI4.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
$3ee1ddc45b8a3f30$var$DismissButtonComponent.displayName = "DismissButtonComponent";
const $3ee1ddc45b8a3f30$var$DismissButton = /*#__PURE__*/ (0, $euxye.memo)($3ee1ddc45b8a3f30$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3ee1ddc45b8a3f30$export$2e2bcd8739ae039 = $3ee1ddc45b8a3f30$var$DismissButton;

});
parcelRegister("m9iwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0161789adb5e2f84$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $hZDXn = parcelRequire("hZDXn");

var $apUrw = parcelRequire("apUrw");

var $lTw6o = parcelRequire("lTw6o");

var $9Yy3v = parcelRequire("9Yy3v");

var $fYjvD = parcelRequire("fYjvD");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $0161789adb5e2f84$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lTw6o.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9Yy3v.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $lTw6o.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $ljVHR.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9Yy3v.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$0161789adb5e2f84$var$IconButton.displayName = 'IconButton';
var $0161789adb5e2f84$export$2e2bcd8739ae039 = $0161789adb5e2f84$var$IconButton;

});
parcelRegister("ljVHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $91a7f5b7f7a72a9f$export$2e2bcd8739ae039);
function $91a7f5b7f7a72a9f$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("hZDXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9454642269c6ba83$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $7iH0N = parcelRequire("7iH0N");

var $2oRWW = parcelRequire("2oRWW");

var $2UFk8 = parcelRequire("2UFk8");

var $dZr3Z = parcelRequire("dZr3Z");

var $9fOPQ = parcelRequire("9fOPQ");

var $8L2z6 = parcelRequire("8L2z6");
var $eCdE8 = parcelRequire("eCdE8");

var $iqfTZ = parcelRequire("iqfTZ");

var $1DTca = parcelRequire("1DTca");

var $5PG2M = parcelRequire("5PG2M");

var $akMu8 = parcelRequire("akMu8");

var $gkWVj = parcelRequire("gkWVj");

var $Yce2Z = parcelRequire("Yce2Z");

var $fEJPe = parcelRequire("fEJPe");

var $3C8J6 = parcelRequire("3C8J6");

var $2dZh0 = parcelRequire("2dZh0");

var $hqGhB = parcelRequire("hqGhB");

var $4OIN9 = parcelRequire("4OIN9");

var $khcLx = parcelRequire("khcLx");

var $gznsT = parcelRequire("gznsT");

var $1FucB = parcelRequire("1FucB");
const $9454642269c6ba83$var$tooltipZIndex = (0, $akMu8.layers).tooltip();
const $9454642269c6ba83$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; // Inverts motion direction
const $9454642269c6ba83$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
}; /**
              * Converts a Popper placement to it's general direction.
              *
              * @param placement - Popper Placement value, e.g. 'top-start'
              * @returns Popper Direction, e.g. 'top'
              */ 
const $9454642269c6ba83$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
function $9454642269c6ba83$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $1FucB.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $2oRWW.default), onHide: onHide = (0, $2oRWW.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, $7iH0N.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$9454642269c6ba83$var$analyticsAttributes
    });
    const onHideHandler = (0, $7iH0N.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$9454642269c6ba83$var$analyticsAttributes
    });
    const apiRef = (0, $euxye.useRef)(null);
    const [state, setState] = (0, $euxye.useState)('hide');
    const targetRef = (0, $euxye.useRef)(null);
    const containerRef = (0, $euxye.useRef)(null); // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    }; // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $euxye.useCallback)((node)=>{
        targetRef.current = node;
    }, []); // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $dZr3Z.default)(state); // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $dZr3Z.default)(onShowHandler);
    const onHideHandlerStable = (0, $dZr3Z.default)(onHideHandler);
    const delayStable = (0, $dZr3Z.default)(delay);
    const canAppearStable = (0, $dZr3Z.default)(canAppear);
    const hasCalledShowHandler = (0, $euxye.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $dZr3Z.default)(shouldAlwaysFadeIn);
    const start = (0, $euxye.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $euxye.useCallback)(()=>{
        if (!apiRef.current) return;
         // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false; // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $euxye.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort(); // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $euxye.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        return (0, $2dZh0.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $euxye.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
         // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
         // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        } /**
       * Check if tooltip is allowed to show.
       *
       * Once a tooltip has started, or has scheduled to start
       * we won't be checking `canAppear` again.
       *
       * - We don't want tooltips to disappear once they are shown
       * - For consistency, we start after a single positive `canAppear`.
       *   Otherwise the amount of times we ask consumers would depend on
       *   how many times we get a "mousemove", which _could_ lead to situations
       *   where moving the mouse could result in a different outcome to if
       *   the mouse was not moved.
       */ 
        if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $iqfTZ.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $khcLx.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $euxye.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]); // When using top-layer, popover="auto" handles Escape natively
    (0, $2UFk8.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $iqfTZ.fg)('platform-dst-top-layer-tooltip')
    }); // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $euxye.useCallback)(()=>{
        apiRef.current?.finishHideAnimation();
    }, []);
    (0, $euxye.useEffect)(()=>{
        if (state === 'hide') return 0, $2oRWW.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $euxye.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $euxye.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $euxye.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $euxye.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $euxye.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $euxye.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {} // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $euxye.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $euxye.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]); // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $euxye.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []); // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $iqfTZ.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $4OIN9.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $gznsT.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }; // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $euxye.useEffect)(()=>{
        if (isChildrenAFunction) return;
         // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $euxye.Fragment) : $9454642269c6ba83$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : // @ts-ignore
    /*#__PURE__*/ (0, $e79Pd.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $iqfTZ.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $e79Pd.jsx)($9454642269c6ba83$var$TopLayerTooltipPopup, {
                targetRef: targetRef,
                tooltipPosition: tooltipPosition,
                mousePos: apiRef.current?.mousePos ?? undefined,
                position: position,
                onMouseOut: onMouseOut,
                onMouseOverTooltip: onMouseOverTooltip,
                ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                truncate: truncate,
                testId: testId,
                shortcut: shortcut,
                content: content,
                Container: Container,
                onClose: ()=>apiRef.current?.requestHide({
                        isImmediate: true
                    }),
                onExitFinish: handleExitFinish,
                isOpen: state !== 'hide' && state !== 'top-layer-exit'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $e79Pd.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1DTca.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $9454642269c6ba83$var$invertedDirection[$9454642269c6ba83$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Container, {
                                        ref: ref,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$9454642269c6ba83$var$Tooltip.displayName = "Tooltip";
var $9454642269c6ba83$export$2e2bcd8739ae039 = $9454642269c6ba83$var$Tooltip;
const $9454642269c6ba83$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
        zIndex: $9454642269c6ba83$var$tooltipZIndex,
        children: children
    });
};
$9454642269c6ba83$var$TooltipPortal.displayName = "TooltipPortal";
const $9454642269c6ba83$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
}; /**
    * Top-layer tooltip popup component.
    *
    * Composes `Popover` (top-layer visibility + animation) with one of two
    * positioning hooks:
    *
    *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
    *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
    *     available (i.e. the popup was activated by a pointer). Positions
    *     the popover relative to a hidden synthetic anchor that follows
    *     the cursor according to the `position` / `mousePosition`
    *     semantics. The synthetic anchor element is rendered as a sibling
    *     of the popover.
    *   - `useAnchorPosition` directly — for non-cursor positions, AND
    *     for cursor positions activated via keyboard focus (where there
    *     is no cursor to track). Anchoring directly to the trigger keeps
    *     keyboard-activated tooltips correctly placed next to the target
    *     instead of rendering in the top-left of the viewport.
    *
    * Exactly one positioning strategy is active at a time: `useAnchorPosition`
    * is wired to the trigger only when the mouse strategy is inactive, and
    * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
    * anchor strategy is active. The other hook is still called (Rules of
    * Hooks) but does no work.
    *
    * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
    * transitions to `false`, the primitive calls `hidePopover()` internally and
    * the CSS exit animation plays via `allow-discrete`. No glue code needed.
    */ 
function $9454642269c6ba83$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen }) {
    const popoverRef = (0, $euxye.useRef)(null); // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    const placement = (0, $gkWVj.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos); // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    }); // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $3C8J6.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $hqGhB.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $9454642269c6ba83$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $9454642269c6ba83$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Container // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
        , {
            className: "Tooltip",
            style: ignoreTooltipPointerEvents ? {
                pointerEvents: 'none'
            } : undefined,
            truncate: truncate,
            placement: tooltipPosition,
            testId: testId,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOverTooltip,
            shortcut: shortcut,
            role: "presentation",
            children: typeof content === 'function' ? content({
                update: (0, $2oRWW.default)
            }) : content
        })
    });
}
$9454642269c6ba83$var$TopLayerTooltipPopup.displayName = "TopLayerTooltipPopup";

});
parcelRegister("7iH0N", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $176708b32d77164e$export$1a04351537078b55);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $7v5Xl = parcelRequire("7v5Xl");
function $176708b32d77164e$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $7v5Xl.useTrackedRef)(analyticsData);
    const fnRef = (0, $7v5Xl.useTrackedRef)(fn);
    const handler = (0, $euxye.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("2UFk8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffe6221ebebfe331$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

function $ffe6221ebebfe331$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $euxye.useRef)(false);
    const onKeyDown = (0, $euxye.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $48dedd10700aff3c$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $euxye.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $euxye.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $glbdM.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';


parcelRegister("dZr3Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $953a32540a92c142$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $953a32540a92c142$export$2e2bcd8739ae039(value) {
    const ref = (0, $euxye.useRef)(value);
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("9fOPQ", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $610ccd5d72ac4b4b$export$469bb693f11edc7f);

var $euxye = parcelRequire("euxye");

var $jAinK = parcelRequire("jAinK");

var $1xyNg = parcelRequire("1xyNg");
function $610ccd5d72ac4b4b$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $euxye.useContext)((0, $jAinK.OpenLayerObserverContext));
    const namespace = (0, $1xyNg.useOpenLayerObserverNamespace)();
    (0, $euxye.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("jAinK", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $6375e30540826c8f$export$5fbf4d7fae6cdc00);

var $euxye = parcelRequire("euxye");
const $6375e30540826c8f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("1xyNg", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $0f22654eea63eb56$export$1d57e79091cc3046);

var $euxye = parcelRequire("euxye");

var $9vDkH = parcelRequire("9vDkH");
function $0f22654eea63eb56$export$1d57e79091cc3046() {
    const namespace = (0, $euxye.useContext)((0, $9vDkH.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("9vDkH", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $e150d808c7a169a9$export$644a49f3b8c50fcd);

var $euxye = parcelRequire("euxye");
const $e150d808c7a169a9$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $euxye.createContext)(null);

});



parcelRegister("8L2z6", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $cd8bf6f02fc72a5c$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $cd8bf6f02fc72a5c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");
// We define empty context here so the object doesn't change.
const $cd8bf6f02fc72a5c$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $cd8bf6f02fc72a5c$var$ExitingContext = /*#__PURE__*/ (0, $euxye.createContext)($cd8bf6f02fc72a5c$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $cd8bf6f02fc72a5c$var$wrapChildWithContextProvider = (child, value = $cd8bf6f02fc72a5c$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($cd8bf6f02fc72a5c$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $cd8bf6f02fc72a5c$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $euxye.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $cd8bf6f02fc72a5c$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $cd8bf6f02fc72a5c$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $cd8bf6f02fc72a5c$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $cd8bf6f02fc72a5c$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $cd8bf6f02fc72a5c$var$ExitingPersistence = /*#__PURE__*/ (0, $euxye.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $euxye.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $euxye.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $euxye.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $euxye.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
	 * useState is mocked to return a boolean value.
	 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $cd8bf6f02fc72a5c$var$childrenToArray(previousChildren);
    const current = $cd8bf6f02fc72a5c$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const nextChildren = currentChildren !== children ? $cd8bf6f02fc72a5c$var$childrenToArray(children) : current;
    const missingKeys = $cd8bf6f02fc72a5c$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $cd8bf6f02fc72a5c$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $iqfTZ.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $cd8bf6f02fc72a5c$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$cd8bf6f02fc72a5c$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $cd8bf6f02fc72a5c$export$3b6f38abbdcbd000 = ()=>{
    return (0, $euxye.useContext)($cd8bf6f02fc72a5c$var$ExitingContext);
};
$cd8bf6f02fc72a5c$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$cd8bf6f02fc72a5c$export$2e2bcd8739ae039 = $cd8bf6f02fc72a5c$var$ExitingPersistence;

});

parcelRegister("eCdE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $03fa4eada0a9fbf8$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1g8lh = parcelRequire("1g8lh");
const $03fa4eada0a9fbf8$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $03fa4eada0a9fbf8$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $03fa4eada0a9fbf8$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1g8lh.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
$03fa4eada0a9fbf8$var$FadeIn.displayName = "FadeIn";
var $03fa4eada0a9fbf8$export$2e2bcd8739ae039 = $03fa4eada0a9fbf8$var$FadeIn;

});
parcelRegister("1g8lh", function(module, exports) {
$parcel$export(module.exports, "default", () => $90080e5b849ef2fa$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9VFAH = parcelRequire("9VFAH");

var $9KPLW = parcelRequire("9KPLW");

var $bG844 = parcelRequire("bG844");

var $3bcsJ = parcelRequire("3bcsJ");

var $8L2z6 = parcelRequire("8L2z6");

var $lmGdq = parcelRequire("lmGdq");
const $90080e5b849ef2fa$var$zoomIn = null;
const $90080e5b849ef2fa$var$zoomOut = null;
const $90080e5b849ef2fa$var$fadeIn = null;
const $90080e5b849ef2fa$var$fadeOut = null;
const $90080e5b849ef2fa$var$fadeInFromTop = null;
const $90080e5b849ef2fa$var$fadeOutFromTop = null;
const $90080e5b849ef2fa$var$fadeInFromLeft = null;
const $90080e5b849ef2fa$var$fadeOutFromLeft = null;
const $90080e5b849ef2fa$var$fadeInFromBottom = null;
const $90080e5b849ef2fa$var$fadeOutFromBottom = null;
const $90080e5b849ef2fa$var$fadeInFromRight = null;
const $90080e5b849ef2fa$var$fadeOutFromRight = null;
const $90080e5b849ef2fa$var$fadeInFromTopConstant = null;
const $90080e5b849ef2fa$var$fadeOutFromTopConstant = null;
const $90080e5b849ef2fa$var$fadeInFromLeftConstant = null;
const $90080e5b849ef2fa$var$fadeOutFromLeftConstant = null;
const $90080e5b849ef2fa$var$fadeInFromBottomConstant = null;
const $90080e5b849ef2fa$var$fadeOutFromBottomConstant = null;
const $90080e5b849ef2fa$var$fadeInFromRightConstant = null;
const $90080e5b849ef2fa$var$fadeOutFromRightConstant = null;
const $90080e5b849ef2fa$var$slideInFromTop = null;
const $90080e5b849ef2fa$var$slideOutFromTop = null;
const $90080e5b849ef2fa$var$slideInFromRight = null;
const $90080e5b849ef2fa$var$slideOutFromRight = null;
const $90080e5b849ef2fa$var$slideInFromBottom = null;
const $90080e5b849ef2fa$var$slideOutFromBottom = null;
const $90080e5b849ef2fa$var$slideInFromLeft = null;
const $90080e5b849ef2fa$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $90080e5b849ef2fa$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $lmGdq.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8L2z6.useExitingPersistence)();
    const setTimeout = (0, $3bcsJ.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $euxye.useState)(appear);
    (0, $euxye.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $bG844.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $9KPLW.exitingDurations)[duration] : (0, $9VFAH.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $4jQY2.default)([
            (0, $4jQY2.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $4jQY2.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $4jQY2.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $4jQY2.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $4jQY2.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $4jQY2.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $4jQY2.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $4jQY2.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $4jQY2.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $4jQY2.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $4jQY2.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $4jQY2.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $4jQY2.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $4jQY2.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $4jQY2.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $4jQY2.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $4jQY2.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $4jQY2.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $4jQY2.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $4jQY2.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $4jQY2.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $4jQY2.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $4jQY2.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $4jQY2.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $4jQY2.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $4jQY2.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $4jQY2.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $4jQY2.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $4jQY2.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $4jQY2.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $4jQY2.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $4jQY2.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $4jQY2.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $4jQY2.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $4jQY2.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $4jQY2.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $4jQY2.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $4jQY2.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $4jQY2.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $4jQY2.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $4jQY2.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $4jQY2.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $4jQY2.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $4jQY2.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $4jQY2.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $4jQY2.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $4jQY2.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $4jQY2.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $4jQY2.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $4jQY2.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $4jQY2.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
$90080e5b849ef2fa$var$EnteringMotion.displayName = "EnteringMotion";
var $90080e5b849ef2fa$export$2e2bcd8739ae039 = $90080e5b849ef2fa$var$EnteringMotion;

});
parcelRegister("9VFAH", function(module, exports) {
$parcel$export(module.exports, "durations", () => $0ccb11168f9043b8$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $0ccb11168f9043b8$export$368bacef0dacbe05 = 25;
const $0ccb11168f9043b8$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("9KPLW", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $5bc6f1a9ea758028$export$30fa1a2e62ae150c);

var $9VFAH = parcelRequire("9VFAH");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $5bc6f1a9ea758028$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $5bc6f1a9ea758028$export$30fa1a2e62ae150c = {
    none: (0, $9VFAH.durations).none,
    small: (0, $9VFAH.durations).small * $5bc6f1a9ea758028$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $9VFAH.durations).medium * $5bc6f1a9ea758028$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $9VFAH.durations).large * $5bc6f1a9ea758028$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("bG844", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $c35696750aa010ea$export$b7baf7667a68d87c);

var $9h1kl = parcelRequire("9h1kl");
const $c35696750aa010ea$export$b7baf7667a68d87c = ()=>{
    if (!(0, $9h1kl.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("9h1kl", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $46c8d1b3e6776c38$export$c5406bd59b374abd);
const $46c8d1b3e6776c38$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("3bcsJ", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $76f4bbbf685b2b9b$export$4f34107a2b00f39c);

var $euxye = parcelRequire("euxye");
const $76f4bbbf685b2b9b$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $76f4bbbf685b2b9b$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $euxye.useRef)([]);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $76f4bbbf685b2b9b$var$getHookDeps(opts));
    return (0, $euxye.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("lmGdq", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $29662e4bfb282b62$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $29662e4bfb282b62$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $dxDNV = parcelRequire("dxDNV");

var $6r3YJ = parcelRequire("6r3YJ");
const $29662e4bfb282b62$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $euxye.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $2oRWW.default)
    }));
const $29662e4bfb282b62$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $6r3YJ.useUniqueId)();
    const context = (0, $euxye.useContext)($29662e4bfb282b62$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $29662e4bfb282b62$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $euxye.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $euxye.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $dxDNV.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($29662e4bfb282b62$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
$29662e4bfb282b62$var$StaggeredEntrance.displayName = "StaggeredEntrance";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$29662e4bfb282b62$export$2e2bcd8739ae039 = $29662e4bfb282b62$var$StaggeredEntrance;

});
parcelRegister("dxDNV", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $5da397a86936e017$export$e5c5a5f917a5871c);

var $euxye = parcelRequire("euxye");
const $5da397a86936e017$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);

});

parcelRegister("6r3YJ", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $37b8c20919e81a96$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $euxye = parcelRequire("euxye");
function $37b8c20919e81a96$export$c485849f2e393253() {
    const identifier = (0, $euxye.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("1DTca", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $88f505eb6968e91d$export$badac9ada3a0bdf9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $k17rf = parcelRequire("k17rf");

var $iqfTZ = parcelRequire("iqfTZ");

var $fj9q8 = parcelRequire("fj9q8");

var $5AqzA = parcelRequire("5AqzA");

var $cFt1H = parcelRequire("cFt1H");
const $88f505eb6968e91d$var$viewportPadding = 5;
const $88f505eb6968e91d$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $88f505eb6968e91d$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $88f505eb6968e91d$var$defaultChildrenFn() {
    return null;
}
const $88f505eb6968e91d$var$defaultOffset = [
    0,
    8
];
function $88f505eb6968e91d$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5AqzA.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($88f505eb6968e91d$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
$88f505eb6968e91d$export$badac9ada3a0bdf9.displayName = "Popper";
function $88f505eb6968e91d$var$LegacyPopper({ children: children = $88f505eb6968e91d$var$defaultChildrenFn, offset: offset = $88f505eb6968e91d$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $euxye.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $88f505eb6968e91d$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $fj9q8.getMaxSizeModifiers)({
            viewportPadding: $88f505eb6968e91d$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$88f505eb6968e91d$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $euxye.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k17rf.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}
$88f505eb6968e91d$var$LegacyPopper.displayName = "LegacyPopper";

});
parcelRegister("k17rf", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $e929abc1f5a27cb9$export$badac9ada3a0bdf9);

var $euxye = parcelRequire("euxye");

var $8vYl3 = parcelRequire("8vYl3");

var $bdIPt = parcelRequire("bdIPt");

var $4BRm1 = parcelRequire("4BRm1");
var $e929abc1f5a27cb9$var$NOOP = function NOOP() {
    return void 0;
};
var $e929abc1f5a27cb9$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $e929abc1f5a27cb9$var$EMPTY_MODIFIERS = [];
function $e929abc1f5a27cb9$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $e929abc1f5a27cb9$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $euxye.useContext((0, $8vYl3.ManagerReferenceNodeContext));
    var _React$useState = $euxye.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $euxye.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $euxye.useEffect(function() {
        (0, $bdIPt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $euxye.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $4BRm1.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $euxye.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $e929abc1f5a27cb9$var$NOOP,
            update: update || $e929abc1f5a27cb9$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $bdIPt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("8vYl3", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $633005fae2ce297d$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $633005fae2ce297d$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $633005fae2ce297d$export$d0d38e7dec7a1a61);

var $euxye = parcelRequire("euxye");
var $633005fae2ce297d$export$3dbd3405086fec7b = $euxye.createContext();
var $633005fae2ce297d$export$cbabb21c2529b130 = $euxye.createContext();
function $633005fae2ce297d$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $euxye.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $euxye.useRef(false);
    $euxye.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $euxye.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $euxye.createElement($633005fae2ce297d$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $euxye.createElement($633005fae2ce297d$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("bdIPt", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $82b3aec11761f615$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $82b3aec11761f615$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $82b3aec11761f615$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $82b3aec11761f615$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $82b3aec11761f615$export$700979bc83e7db82);

var $euxye = parcelRequire("euxye");
var $82b3aec11761f615$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $82b3aec11761f615$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $82b3aec11761f615$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $82b3aec11761f615$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $82b3aec11761f615$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $82b3aec11761f615$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $euxye.useLayoutEffect : $euxye.useEffect;

});

parcelRegister("4BRm1", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $35b4012240a8b42a$export$f4d5bf230a36dd6e);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $f9qgX = parcelRequire("f9qgX");

var $6BUH0 = parcelRequire("6BUH0");

var $bdIPt = parcelRequire("bdIPt");
var $35b4012240a8b42a$var$EMPTY_MODIFIERS = [];
var $35b4012240a8b42a$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $euxye.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $35b4012240a8b42a$var$EMPTY_MODIFIERS
    };
    var _React$useState = $euxye.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $euxye.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $85XPu.flushSync(function() {
                    setState({
                        styles: (0, $bdIPt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $bdIPt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $euxye.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6BUH0)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $euxye.useRef();
    (0, $bdIPt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $bdIPt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $f9qgX.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("f9qgX", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $b07c13741d80af49$export$8f7491d57c8f97a9);

var $5tRYq = parcelRequire("5tRYq");

var $8OZci = parcelRequire("8OZci");

var $77PgT = parcelRequire("77PgT");

var $lwztu = parcelRequire("lwztu");

var $bCHvs = parcelRequire("bCHvs");

var $lcgaD = parcelRequire("lcgaD");

var $5rWFm = parcelRequire("5rWFm");

var $nFdiM = parcelRequire("nFdiM");

var $jboUq = parcelRequire("jboUq");

var $iph4n = parcelRequire("iph4n");


var $b07c13741d80af49$export$d34966752335dd47 = [
    (0, $8OZci.default),
    (0, $77PgT.default),
    (0, $lwztu.default),
    (0, $bCHvs.default),
    (0, $lcgaD.default),
    (0, $5rWFm.default),
    (0, $nFdiM.default),
    (0, $jboUq.default),
    (0, $iph4n.default)
];
var $b07c13741d80af49$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5tRYq.popperGenerator)({
    defaultModifiers: $b07c13741d80af49$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5tRYq", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $3fd987375cb91c98$export$ed5e13716264f202);

var $iJUem = parcelRequire("iJUem");

var $8cY02 = parcelRequire("8cY02");

var $eDGrL = parcelRequire("eDGrL");

var $1jryu = parcelRequire("1jryu");

var $fw50l = parcelRequire("fw50l");

var $3kM9T = parcelRequire("3kM9T");

var $4qXX0 = parcelRequire("4qXX0");


var $5JH8y = parcelRequire("5JH8y");
var $3fd987375cb91c98$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $3fd987375cb91c98$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $3fd987375cb91c98$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $3fd987375cb91c98$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $3fd987375cb91c98$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5JH8y.isElement)(reference) ? (0, $eDGrL.default)(reference) : reference.contextElement ? (0, $eDGrL.default)(reference.contextElement) : [],
                    popper: (0, $eDGrL.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $fw50l.default)((0, $4qXX0.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$3fd987375cb91c98$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $iJUem.default)(reference, (0, $1jryu.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $8cY02.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3kM9T.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$3fd987375cb91c98$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $3fd987375cb91c98$export$8f7491d57c8f97a9 = /*#__PURE__*/ $3fd987375cb91c98$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("iJUem", function(module, exports) {
$parcel$export(module.exports, "default", () => $da480c3411b584c1$export$2e2bcd8739ae039);

var $53lGC = parcelRequire("53lGC");

var $fAzTg = parcelRequire("fAzTg");

var $5EoAP = parcelRequire("5EoAP");

var $5JH8y = parcelRequire("5JH8y");

var $9RoFn = parcelRequire("9RoFn");

var $lq4uP = parcelRequire("lq4uP");

var $jzkVn = parcelRequire("jzkVn");

var $lOpAp = parcelRequire("lOpAp");
function $da480c3411b584c1$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lOpAp.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lOpAp.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $da480c3411b584c1$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5JH8y.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $5JH8y.isHTMLElement)(offsetParent) && $da480c3411b584c1$var$isElementScaled(offsetParent);
    var documentElement = (0, $lq4uP.default)(offsetParent);
    var rect = (0, $53lGC.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5EoAP.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $jzkVn.default)(documentElement)) scroll = (0, $fAzTg.default)(offsetParent);
        if ((0, $5JH8y.isHTMLElement)(offsetParent)) {
            offsets = (0, $53lGC.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9RoFn.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("53lGC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ade0e06a2e1941a$export$2e2bcd8739ae039);

var $5JH8y = parcelRequire("5JH8y");

var $lOpAp = parcelRequire("lOpAp");

var $e2Aph = parcelRequire("e2Aph");

var $1IGS1 = parcelRequire("1IGS1");
function $3ade0e06a2e1941a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $5JH8y.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $lOpAp.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $lOpAp.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $5JH8y.isElement)(element) ? (0, $e2Aph.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $1IGS1.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("5JH8y", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $42d29dd3d8a340d3$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $42d29dd3d8a340d3$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $42d29dd3d8a340d3$export$af51f0f06c0f328a);

var $e2Aph = parcelRequire("e2Aph");
function $42d29dd3d8a340d3$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e2Aph.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $42d29dd3d8a340d3$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e2Aph.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $42d29dd3d8a340d3$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e2Aph.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("e2Aph", function(module, exports) {
$parcel$export(module.exports, "default", () => $a38d7e30b14d3ebc$export$2e2bcd8739ae039);
function $a38d7e30b14d3ebc$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lOpAp", function(module, exports) {
$parcel$export(module.exports, "max", () => $fe121d6098b48e44$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $fe121d6098b48e44$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $fe121d6098b48e44$export$2077e0241d6afd3c);
var $fe121d6098b48e44$export$8960430cfd85939f = Math.max;
var $fe121d6098b48e44$export$96ec731ed4dcb222 = Math.min;
var $fe121d6098b48e44$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("1IGS1", function(module, exports) {
$parcel$export(module.exports, "default", () => $140b27a75c0e99b5$export$2e2bcd8739ae039);

var $3DFqi = parcelRequire("3DFqi");
function $140b27a75c0e99b5$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $3DFqi.default)());
}

});
parcelRegister("3DFqi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a65256465b31532$export$2e2bcd8739ae039);
function $2a65256465b31532$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("fAzTg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5960edf363dbf70$export$2e2bcd8739ae039);

var $dEHaO = parcelRequire("dEHaO");

var $e2Aph = parcelRequire("e2Aph");

var $5JH8y = parcelRequire("5JH8y");

var $9TpZg = parcelRequire("9TpZg");
function $b5960edf363dbf70$export$2e2bcd8739ae039(node) {
    if (node === (0, $e2Aph.default)(node) || !(0, $5JH8y.isHTMLElement)(node)) return (0, $dEHaO.default)(node);
    else return (0, $9TpZg.default)(node);
}

});
parcelRegister("dEHaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f10801f34486a24$export$2e2bcd8739ae039);

var $e2Aph = parcelRequire("e2Aph");
function $9f10801f34486a24$export$2e2bcd8739ae039(node) {
    var win = (0, $e2Aph.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("9TpZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $733d68a2c02f4bcd$export$2e2bcd8739ae039);
function $733d68a2c02f4bcd$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("5EoAP", function(module, exports) {
$parcel$export(module.exports, "default", () => $41d3c3d518484d9e$export$2e2bcd8739ae039);
function $41d3c3d518484d9e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("9RoFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $72dc328ae41136e0$export$2e2bcd8739ae039);

var $53lGC = parcelRequire("53lGC");

var $lq4uP = parcelRequire("lq4uP");

var $dEHaO = parcelRequire("dEHaO");
function $72dc328ae41136e0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $53lGC.default)((0, $lq4uP.default)(element)).left + (0, $dEHaO.default)(element).scrollLeft;
}

});
parcelRegister("lq4uP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f97f83844e790f42$export$2e2bcd8739ae039);

var $5JH8y = parcelRequire("5JH8y");
function $f97f83844e790f42$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5JH8y.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("jzkVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3f18456716fe7a3$export$2e2bcd8739ae039);

var $3ls3z = parcelRequire("3ls3z");
function $e3f18456716fe7a3$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3ls3z.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("3ls3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $26f918ba76a8edaf$export$2e2bcd8739ae039);

var $e2Aph = parcelRequire("e2Aph");
function $26f918ba76a8edaf$export$2e2bcd8739ae039(element) {
    return (0, $e2Aph.default)(element).getComputedStyle(element);
}

});



parcelRegister("8cY02", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f9dfc60b5ecb722$export$2e2bcd8739ae039);

var $53lGC = parcelRequire("53lGC");
function $5f9dfc60b5ecb722$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $53lGC.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("eDGrL", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa85a2459760d906$export$2e2bcd8739ae039);

var $3X7yF = parcelRequire("3X7yF");

var $ljNUz = parcelRequire("ljNUz");

var $e2Aph = parcelRequire("e2Aph");

var $jzkVn = parcelRequire("jzkVn");
function $aa85a2459760d906$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3X7yF.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e2Aph.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $jzkVn.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($aa85a2459760d906$export$2e2bcd8739ae039((0, $ljNUz.default)(target)));
}

});
parcelRegister("3X7yF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e0cbea84fdced2a$export$2e2bcd8739ae039);

var $ljNUz = parcelRequire("ljNUz");

var $jzkVn = parcelRequire("jzkVn");

var $5EoAP = parcelRequire("5EoAP");

var $5JH8y = parcelRequire("5JH8y");
function $2e0cbea84fdced2a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $5EoAP.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5JH8y.isHTMLElement)(node) && (0, $jzkVn.default)(node)) return node;
    return $2e0cbea84fdced2a$export$2e2bcd8739ae039((0, $ljNUz.default)(node));
}

});
parcelRegister("ljNUz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f85216b3a40ddb6c$export$2e2bcd8739ae039);

var $5EoAP = parcelRequire("5EoAP");

var $lq4uP = parcelRequire("lq4uP");

var $5JH8y = parcelRequire("5JH8y");
function $f85216b3a40ddb6c$export$2e2bcd8739ae039(element) {
    if ((0, $5EoAP.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5JH8y.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $lq4uP.default)(element) // fallback
    );
}

});



parcelRegister("1jryu", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f4cf0b565282ab9$export$2e2bcd8739ae039);

var $e2Aph = parcelRequire("e2Aph");

var $5EoAP = parcelRequire("5EoAP");

var $3ls3z = parcelRequire("3ls3z");

var $5JH8y = parcelRequire("5JH8y");

var $ayX6j = parcelRequire("ayX6j");

var $ljNUz = parcelRequire("ljNUz");

var $3DFqi = parcelRequire("3DFqi");
function $0f4cf0b565282ab9$var$getTrueOffsetParent(element) {
    if (!(0, $5JH8y.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3ls3z.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $0f4cf0b565282ab9$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $3DFqi.default)());
    var isIE = /Trident/i.test((0, $3DFqi.default)());
    if (isIE && (0, $5JH8y.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3ls3z.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ljNUz.default)(element);
    if ((0, $5JH8y.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $5JH8y.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $5EoAP.default)(currentNode)) < 0){
        var css = (0, $3ls3z.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $0f4cf0b565282ab9$export$2e2bcd8739ae039(element) {
    var window = (0, $e2Aph.default)(element);
    var offsetParent = $0f4cf0b565282ab9$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $ayX6j.default)(offsetParent) && (0, $3ls3z.default)(offsetParent).position === 'static')offsetParent = $0f4cf0b565282ab9$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $5EoAP.default)(offsetParent) === 'html' || (0, $5EoAP.default)(offsetParent) === 'body' && (0, $3ls3z.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $0f4cf0b565282ab9$var$getContainingBlock(element) || window;
}

});
parcelRegister("ayX6j", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b0aec92b0ad0dac$export$2e2bcd8739ae039);

var $5EoAP = parcelRequire("5EoAP");
function $7b0aec92b0ad0dac$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $5EoAP.default)(element)) >= 0;
}

});


parcelRegister("fw50l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4bdb9f695be2d25$export$2e2bcd8739ae039);

var $cFt1H = parcelRequire("cFt1H");
function $b4bdb9f695be2d25$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $b4bdb9f695be2d25$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $b4bdb9f695be2d25$var$order(modifiers); // order based on phase
    return (0, $cFt1H.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cFt1H", function(module, exports) {
$parcel$export(module.exports, "top", () => $938fd465944415b2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $938fd465944415b2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $938fd465944415b2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $938fd465944415b2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $938fd465944415b2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $938fd465944415b2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $938fd465944415b2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $938fd465944415b2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $938fd465944415b2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $938fd465944415b2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $938fd465944415b2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $938fd465944415b2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $938fd465944415b2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $938fd465944415b2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $938fd465944415b2$export$d087d3878fdf71d5);
var $938fd465944415b2$export$1e95b668f3b82d = 'top';
var $938fd465944415b2$export$40e543e69a8b3fbb = 'bottom';
var $938fd465944415b2$export$79ffe56a765070d2 = 'right';
var $938fd465944415b2$export$eabcd2c8791e7bf4 = 'left';
var $938fd465944415b2$export$dfb5619354ba860 = 'auto';
var $938fd465944415b2$export$aec2ce47c367b8c3 = [
    $938fd465944415b2$export$1e95b668f3b82d,
    $938fd465944415b2$export$40e543e69a8b3fbb,
    $938fd465944415b2$export$79ffe56a765070d2,
    $938fd465944415b2$export$eabcd2c8791e7bf4
];
var $938fd465944415b2$export$b3571188c770cc5a = 'start';
var $938fd465944415b2$export$bd5df0f255a350f8 = 'end';
var $938fd465944415b2$export$390fd549c5303b4d = 'clippingParents';
var $938fd465944415b2$export$d7b7311ec04a3e8f = 'viewport';
var $938fd465944415b2$export$ae5ab1c730825774 = 'popper';
var $938fd465944415b2$export$ca50aac9f3ba507f = 'reference';
var $938fd465944415b2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $938fd465944415b2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $938fd465944415b2$export$b3571188c770cc5a,
        placement + "-" + $938fd465944415b2$export$bd5df0f255a350f8
    ]);
}, []);
var $938fd465944415b2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($938fd465944415b2$export$aec2ce47c367b8c3, [
    $938fd465944415b2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $938fd465944415b2$export$b3571188c770cc5a,
        placement + "-" + $938fd465944415b2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $938fd465944415b2$export$421679a7c3d56e = 'beforeRead';
var $938fd465944415b2$export$aafa59e2e03f2942 = 'read';
var $938fd465944415b2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $938fd465944415b2$export$c65e99957a05207c = 'beforeMain';
var $938fd465944415b2$export$f22da7240b7add18 = 'main';
var $938fd465944415b2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $938fd465944415b2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $938fd465944415b2$export$68d8715fc104d294 = 'write';
var $938fd465944415b2$export$70a6e5159acce2e6 = 'afterWrite';
var $938fd465944415b2$export$d087d3878fdf71d5 = [
    $938fd465944415b2$export$421679a7c3d56e,
    $938fd465944415b2$export$aafa59e2e03f2942,
    $938fd465944415b2$export$6964f6c886723980,
    $938fd465944415b2$export$c65e99957a05207c,
    $938fd465944415b2$export$f22da7240b7add18,
    $938fd465944415b2$export$bab79516f2d662fe,
    $938fd465944415b2$export$8d4d2d70e7d46032,
    $938fd465944415b2$export$68d8715fc104d294,
    $938fd465944415b2$export$70a6e5159acce2e6
];

});


parcelRegister("3kM9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $26d898a61d7aa913$export$2e2bcd8739ae039);
function $26d898a61d7aa913$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4qXX0", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a818190fbbacae$export$2e2bcd8739ae039);
function $33a818190fbbacae$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("8OZci", function(module, exports) {
$parcel$export(module.exports, "default", () => $66c276c670fa7c7e$export$2e2bcd8739ae039);

var $e2Aph = parcelRequire("e2Aph");
var $66c276c670fa7c7e$var$passive = {
    passive: true
};
function $66c276c670fa7c7e$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e2Aph.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $66c276c670fa7c7e$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $66c276c670fa7c7e$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $66c276c670fa7c7e$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $66c276c670fa7c7e$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $66c276c670fa7c7e$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $66c276c670fa7c7e$var$effect,
    data: {}
};

});

parcelRegister("77PgT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5300f54982083c43$export$2e2bcd8739ae039);

var $4gvLk = parcelRequire("4gvLk");
function $5300f54982083c43$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4gvLk.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5300f54982083c43$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $5300f54982083c43$var$popperOffsets,
    data: {}
};

});
parcelRegister("4gvLk", function(module, exports) {
$parcel$export(module.exports, "default", () => $31b14b61e3735a17$export$2e2bcd8739ae039);

var $hZXZ6 = parcelRequire("hZXZ6");

var $caGQx = parcelRequire("caGQx");

var $3l0Oc = parcelRequire("3l0Oc");

var $cFt1H = parcelRequire("cFt1H");
function $31b14b61e3735a17$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hZXZ6.default)(placement) : null;
    var variation = placement ? (0, $caGQx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cFt1H.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cFt1H.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cFt1H.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cFt1H.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3l0Oc.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cFt1H.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cFt1H.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hZXZ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1a6a9d8c8c296b6$export$2e2bcd8739ae039);

function $d1a6a9d8c8c296b6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("caGQx", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dc7a7986919e693$export$2e2bcd8739ae039);
function $8dc7a7986919e693$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("3l0Oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $26e3f5dc8072379e$export$2e2bcd8739ae039);
function $26e3f5dc8072379e$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("lwztu", function(module, exports) {
$parcel$export(module.exports, "default", () => $fab81aae34992f9e$export$2e2bcd8739ae039);

var $cFt1H = parcelRequire("cFt1H");

var $1jryu = parcelRequire("1jryu");

var $e2Aph = parcelRequire("e2Aph");

var $lq4uP = parcelRequire("lq4uP");

var $3ls3z = parcelRequire("3ls3z");

var $hZXZ6 = parcelRequire("hZXZ6");

var $caGQx = parcelRequire("caGQx");

var $lOpAp = parcelRequire("lOpAp");
var $fab81aae34992f9e$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $fab81aae34992f9e$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lOpAp.round)(x * dpr) / dpr || 0,
        y: (0, $lOpAp.round)(y * dpr) / dpr || 0
    };
}
function $fab81aae34992f9e$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cFt1H.left);
    var sideY = (0, $cFt1H.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1jryu.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e2Aph.default)(popper)) {
            offsetParent = (0, $lq4uP.default)(popper);
            if ((0, $3ls3z.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cFt1H.top) || (placement === (0, $cFt1H.left) || placement === (0, $cFt1H.right)) && variation === (0, $cFt1H.end)) {
            sideY = (0, $cFt1H.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cFt1H.left) || (placement === (0, $cFt1H.top) || placement === (0, $cFt1H.bottom)) && variation === (0, $cFt1H.end)) {
            sideX = (0, $cFt1H.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $fab81aae34992f9e$var$unsetSides);
    var _ref4 = roundOffsets === true ? $fab81aae34992f9e$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e2Aph.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $fab81aae34992f9e$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $hZXZ6.default)(state.placement),
        variation: (0, $caGQx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $fab81aae34992f9e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $fab81aae34992f9e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fab81aae34992f9e$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $fab81aae34992f9e$var$computeStyles,
    data: {}
};

});

parcelRegister("bCHvs", function(module, exports) {
$parcel$export(module.exports, "default", () => $8764fdca6cd04153$export$2e2bcd8739ae039);

var $5EoAP = parcelRequire("5EoAP");

var $5JH8y = parcelRequire("5JH8y");
// and applies them to the HTMLElements such as popper and arrow
function $8764fdca6cd04153$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $5JH8y.isHTMLElement)(element) || !(0, $5EoAP.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $8764fdca6cd04153$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $5JH8y.isHTMLElement)(element) || !(0, $5EoAP.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $8764fdca6cd04153$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $8764fdca6cd04153$var$applyStyles,
    effect: $8764fdca6cd04153$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lcgaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6e7431618437bc8$export$2e2bcd8739ae039);

var $hZXZ6 = parcelRequire("hZXZ6");

var $cFt1H = parcelRequire("cFt1H");
function $f6e7431618437bc8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hZXZ6.default)(placement);
    var invertDistance = [
        (0, $cFt1H.left),
        (0, $cFt1H.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cFt1H.left),
        (0, $cFt1H.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f6e7431618437bc8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cFt1H.placements).reduce(function(acc, placement) {
        acc[placement] = $f6e7431618437bc8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6e7431618437bc8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f6e7431618437bc8$var$offset
};

});

parcelRegister("5rWFm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f7cfb3c84479fcd$export$2e2bcd8739ae039);

var $iC6VZ = parcelRequire("iC6VZ");

var $hZXZ6 = parcelRequire("hZXZ6");

var $6aUBj = parcelRequire("6aUBj");

var $q1jkN = parcelRequire("q1jkN");

var $k41wb = parcelRequire("k41wb");

var $cFt1H = parcelRequire("cFt1H");

var $caGQx = parcelRequire("caGQx");
function $3f7cfb3c84479fcd$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hZXZ6.default)(placement) === (0, $cFt1H.auto)) return [];
    var oppositePlacement = (0, $iC6VZ.default)(placement);
    return [
        (0, $6aUBj.default)(placement),
        oppositePlacement,
        (0, $6aUBj.default)(oppositePlacement)
    ];
}
function $3f7cfb3c84479fcd$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hZXZ6.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $iC6VZ.default)(preferredPlacement)
    ] : $3f7cfb3c84479fcd$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hZXZ6.default)(placement) === (0, $cFt1H.auto) ? (0, $k41wb.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hZXZ6.default)(placement);
        var isStartVariation = (0, $caGQx.default)(placement) === (0, $cFt1H.start);
        var isVertical = [
            (0, $cFt1H.top),
            (0, $cFt1H.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $q1jkN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cFt1H.right) : (0, $cFt1H.left) : isStartVariation ? (0, $cFt1H.bottom) : (0, $cFt1H.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $iC6VZ.default)(mainVariationSide);
        var altVariationSide = (0, $iC6VZ.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $3f7cfb3c84479fcd$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $3f7cfb3c84479fcd$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("iC6VZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8d1279bec131665$export$2e2bcd8739ae039);
var $d8d1279bec131665$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d8d1279bec131665$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d8d1279bec131665$var$hash[matched];
    });
}

});

parcelRegister("6aUBj", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ef950434b64c1b$export$2e2bcd8739ae039);
var $47ef950434b64c1b$var$hash = {
    start: 'end',
    end: 'start'
};
function $47ef950434b64c1b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47ef950434b64c1b$var$hash[matched];
    });
}

});

parcelRegister("q1jkN", function(module, exports) {
$parcel$export(module.exports, "default", () => $04e37221138b20e1$export$2e2bcd8739ae039);

var $jGGPE = parcelRequire("jGGPE");

var $lq4uP = parcelRequire("lq4uP");

var $53lGC = parcelRequire("53lGC");

var $4gvLk = parcelRequire("4gvLk");

var $kNvfV = parcelRequire("kNvfV");

var $cFt1H = parcelRequire("cFt1H");

var $5JH8y = parcelRequire("5JH8y");

var $cHDno = parcelRequire("cHDno");

var $8k1oY = parcelRequire("8k1oY");
function $04e37221138b20e1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cFt1H.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cFt1H.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cFt1H.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cHDno.default)(typeof padding !== 'number' ? padding : (0, $8k1oY.default)(padding, (0, $cFt1H.basePlacements)));
    var altContext = elementContext === (0, $cFt1H.popper) ? (0, $cFt1H.reference) : (0, $cFt1H.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jGGPE.default)((0, $5JH8y.isElement)(element) ? element : element.contextElement || (0, $lq4uP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $53lGC.default)(state.elements.reference);
    var popperOffsets = (0, $4gvLk.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $kNvfV.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cFt1H.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cFt1H.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cFt1H.right),
                (0, $cFt1H.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cFt1H.top),
                (0, $cFt1H.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jGGPE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5532a222a4561b4$export$2e2bcd8739ae039);

var $cFt1H = parcelRequire("cFt1H");

var $dABfc = parcelRequire("dABfc");

var $cEKR2 = parcelRequire("cEKR2");

var $eDGrL = parcelRequire("eDGrL");

var $1jryu = parcelRequire("1jryu");

var $lq4uP = parcelRequire("lq4uP");

var $3ls3z = parcelRequire("3ls3z");

var $5JH8y = parcelRequire("5JH8y");

var $53lGC = parcelRequire("53lGC");

var $ljNUz = parcelRequire("ljNUz");

var $4TV78 = parcelRequire("4TV78");

var $5EoAP = parcelRequire("5EoAP");

var $kNvfV = parcelRequire("kNvfV");

var $lOpAp = parcelRequire("lOpAp");
function $e5532a222a4561b4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $53lGC.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e5532a222a4561b4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cFt1H.viewport) ? (0, $kNvfV.default)((0, $dABfc.default)(element, strategy)) : (0, $5JH8y.isElement)(clippingParent) ? $e5532a222a4561b4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $kNvfV.default)((0, $cEKR2.default)((0, $lq4uP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e5532a222a4561b4$var$getClippingParents(element) {
    var clippingParents = (0, $eDGrL.default)((0, $ljNUz.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3ls3z.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $5JH8y.isHTMLElement)(element) ? (0, $1jryu.default)(element) : element;
    if (!(0, $5JH8y.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $5JH8y.isElement)(clippingParent) && (0, $4TV78.default)(clippingParent, clipperElement) && (0, $5EoAP.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e5532a222a4561b4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $e5532a222a4561b4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e5532a222a4561b4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $lOpAp.max)(rect.top, accRect.top);
        accRect.right = (0, $lOpAp.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lOpAp.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lOpAp.max)(rect.left, accRect.left);
        return accRect;
    }, $e5532a222a4561b4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("dABfc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e4b870f4c5ad520$export$2e2bcd8739ae039);

var $e2Aph = parcelRequire("e2Aph");

var $lq4uP = parcelRequire("lq4uP");

var $9RoFn = parcelRequire("9RoFn");

var $1IGS1 = parcelRequire("1IGS1");
function $9e4b870f4c5ad520$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e2Aph.default)(element);
    var html = (0, $lq4uP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $1IGS1.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9RoFn.default)(element),
        y: y
    };
}

});

parcelRegister("cEKR2", function(module, exports) {
$parcel$export(module.exports, "default", () => $936d90c4764f69e2$export$2e2bcd8739ae039);

var $lq4uP = parcelRequire("lq4uP");

var $3ls3z = parcelRequire("3ls3z");

var $9RoFn = parcelRequire("9RoFn");

var $dEHaO = parcelRequire("dEHaO");

var $lOpAp = parcelRequire("lOpAp");
function $936d90c4764f69e2$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $lq4uP.default)(element);
    var winScroll = (0, $dEHaO.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lOpAp.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lOpAp.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9RoFn.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3ls3z.default)(body || html).direction === 'rtl') x += (0, $lOpAp.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4TV78", function(module, exports) {
$parcel$export(module.exports, "default", () => $39189a203aa52ba9$export$2e2bcd8739ae039);

var $5JH8y = parcelRequire("5JH8y");
function $39189a203aa52ba9$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $5JH8y.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("kNvfV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f240a0fdc80b58a1$export$2e2bcd8739ae039);
function $f240a0fdc80b58a1$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cHDno", function(module, exports) {
$parcel$export(module.exports, "default", () => $93f80b81018390f0$export$2e2bcd8739ae039);

var $3z7l5 = parcelRequire("3z7l5");
function $93f80b81018390f0$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $3z7l5.default)(), paddingObject);
}

});
parcelRegister("3z7l5", function(module, exports) {
$parcel$export(module.exports, "default", () => $298a555e8f48edbd$export$2e2bcd8739ae039);
function $298a555e8f48edbd$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("8k1oY", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f14760ecadf549$export$2e2bcd8739ae039);
function $60f14760ecadf549$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("k41wb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9b55bd11a21177b$export$2e2bcd8739ae039);

var $caGQx = parcelRequire("caGQx");

var $cFt1H = parcelRequire("cFt1H");

var $q1jkN = parcelRequire("q1jkN");

var $hZXZ6 = parcelRequire("hZXZ6");
function $e9b55bd11a21177b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cFt1H.placements) : _options$allowedAutoP;
    var variation = (0, $caGQx.default)(placement);
    var placements = variation ? flipVariations ? (0, $cFt1H.variationPlacements) : (0, $cFt1H.variationPlacements).filter(function(placement) {
        return (0, $caGQx.default)(placement) === variation;
    }) : (0, $cFt1H.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $q1jkN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hZXZ6.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("nFdiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $04721e3fb7aafe04$export$2e2bcd8739ae039);

var $cFt1H = parcelRequire("cFt1H");

var $hZXZ6 = parcelRequire("hZXZ6");

var $3l0Oc = parcelRequire("3l0Oc");

var $iC69k = parcelRequire("iC69k");

var $9jP0y = parcelRequire("9jP0y");

var $8cY02 = parcelRequire("8cY02");

var $1jryu = parcelRequire("1jryu");

var $q1jkN = parcelRequire("q1jkN");

var $caGQx = parcelRequire("caGQx");

var $3z7l5 = parcelRequire("3z7l5");

var $lOpAp = parcelRequire("lOpAp");
function $04721e3fb7aafe04$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $q1jkN.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hZXZ6.default)(state.placement);
    var variation = (0, $caGQx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3l0Oc.default)(basePlacement);
    var altAxis = (0, $iC69k.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cFt1H.top) : (0, $cFt1H.left);
        var altSide = mainAxis === 'y' ? (0, $cFt1H.bottom) : (0, $cFt1H.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cFt1H.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cFt1H.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8cY02.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $3z7l5.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9jP0y.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1jryu.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9jP0y.within)(tether ? (0, $lOpAp.min)(min, tetherMin) : min, offset, tether ? (0, $lOpAp.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cFt1H.top) : (0, $cFt1H.left);
        var _altSide = mainAxis === 'x' ? (0, $cFt1H.bottom) : (0, $cFt1H.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cFt1H.top),
            (0, $cFt1H.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9jP0y.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $9jP0y.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $04721e3fb7aafe04$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $04721e3fb7aafe04$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("iC69k", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8d08bc50ef78ba1$export$2e2bcd8739ae039);
function $d8d08bc50ef78ba1$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("9jP0y", function(module, exports) {
$parcel$export(module.exports, "within", () => $6c8d748413128e3b$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $6c8d748413128e3b$export$86c8af6d3ef0b4a);

var $lOpAp = parcelRequire("lOpAp");
function $6c8d748413128e3b$export$f28d906d67a997f3(min, value, max) {
    return (0, $lOpAp.max)(min, (0, $lOpAp.min)(value, max));
}
function $6c8d748413128e3b$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $6c8d748413128e3b$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("jboUq", function(module, exports) {
$parcel$export(module.exports, "default", () => $df725dcf9a48cb54$export$2e2bcd8739ae039);

var $hZXZ6 = parcelRequire("hZXZ6");

var $8cY02 = parcelRequire("8cY02");

var $4TV78 = parcelRequire("4TV78");

var $1jryu = parcelRequire("1jryu");

var $3l0Oc = parcelRequire("3l0Oc");

var $9jP0y = parcelRequire("9jP0y");

var $cHDno = parcelRequire("cHDno");

var $8k1oY = parcelRequire("8k1oY");

var $cFt1H = parcelRequire("cFt1H");
var $df725dcf9a48cb54$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cHDno.default)(typeof padding !== 'number' ? padding : (0, $8k1oY.default)(padding, (0, $cFt1H.basePlacements)));
};
function $df725dcf9a48cb54$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hZXZ6.default)(state.placement);
    var axis = (0, $3l0Oc.default)(basePlacement);
    var isVertical = [
        (0, $cFt1H.left),
        (0, $cFt1H.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $df725dcf9a48cb54$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8cY02.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cFt1H.top) : (0, $cFt1H.left);
    var maxProp = axis === 'y' ? (0, $cFt1H.bottom) : (0, $cFt1H.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1jryu.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9jP0y.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $df725dcf9a48cb54$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4TV78.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $df725dcf9a48cb54$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $df725dcf9a48cb54$var$arrow,
    effect: $df725dcf9a48cb54$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("iph4n", function(module, exports) {
$parcel$export(module.exports, "default", () => $d667cd790857678b$export$2e2bcd8739ae039);

var $cFt1H = parcelRequire("cFt1H");

var $q1jkN = parcelRequire("q1jkN");
function $d667cd790857678b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d667cd790857678b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cFt1H.top),
        (0, $cFt1H.right),
        (0, $cFt1H.bottom),
        (0, $cFt1H.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d667cd790857678b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $q1jkN.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $q1jkN.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d667cd790857678b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d667cd790857678b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d667cd790857678b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d667cd790857678b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d667cd790857678b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d667cd790857678b$var$hide
};

});




parcelRegister("fj9q8", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $28c70c52917f8522$export$6d8c2b45c99d6e3f);
function $28c70c52917f8522$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("5AqzA", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $93aab9a91f1cb9c8$export$9802f50720ab826e);
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $gkWVj = parcelRequire("gkWVj");

var $Yce2Z = parcelRequire("Yce2Z");

var $fEJPe = parcelRequire("fEJPe");

var $3C8J6 = parcelRequire("3C8J6");

var $kUmcP = parcelRequire("kUmcP");

var $jNSP2 = parcelRequire("jNSP2");

var $6QwyO = parcelRequire("6QwyO");

var $9s3MN = parcelRequire("9s3MN");

var $cd4fb = parcelRequire("cd4fb");

var $64NRn = parcelRequire("64NRn");

var $764C7 = parcelRequire("764C7");

var $9eQQl = parcelRequire("9eQQl");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $93aab9a91f1cb9c8$var$noopStyle = {};
const $93aab9a91f1cb9c8$var$noopSetRef = (0, $2oRWW.default);
const $93aab9a91f1cb9c8$var$noopUpdate = ()=>Promise.resolve(null);
const $93aab9a91f1cb9c8$var$noopForceUpdate = ()=>({});
const $93aab9a91f1cb9c8$var$noopArrowProps = {
    ref: $93aab9a91f1cb9c8$var$noopSetRef,
    style: $93aab9a91f1cb9c8$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $93aab9a91f1cb9c8$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $93aab9a91f1cb9c8$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
function $93aab9a91f1cb9c8$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $764C7.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    const htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    const htmlAnchorRef = (0, $euxye.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $euxye.useRef)(null);
    const popoverId = (0, $kUmcP.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $euxye.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $euxye.useMemo)(()=>{
        return (0, $gkWVj.fromLegacyPlacement)({
            legacy: (0, $cd4fb.toLegacyPlacement)(placement),
            offset: $93aab9a91f1cb9c8$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    const virtualReferenceRef = (0, $euxye.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $euxye.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    const isVirtualEnabled = virtualReference != null;
    (0, $3C8J6.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $9s3MN.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $6QwyO.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $9eQQl.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $jNSP2.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    const resolvedOffset = $93aab9a91f1cb9c8$var$popperToTopLayerOffset(offset);
    const fitGap = resolvedOffset ? `${resolvedOffset[1]}px` : "var(--ds-space-100, 8px)";
    const placementAxis = $93aab9a91f1cb9c8$var$getPlacementAxis(placement);
    (0, $64NRn.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $93aab9a91f1cb9c8$var$noopSetRef,
        style: $93aab9a91f1cb9c8$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $93aab9a91f1cb9c8$var$noopUpdate,
        forceUpdate: $93aab9a91f1cb9c8$var$noopForceUpdate,
        arrowProps: $93aab9a91f1cb9c8$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}
$93aab9a91f1cb9c8$export$9802f50720ab826e.displayName = "PopperTopLayer";

});
parcelRegister("gkWVj", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $80766a76570689ae$export$69e99ed50b2534c9);

var $4d5QI = parcelRequire("4d5QI");
function $80766a76570689ae$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $4d5QI.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("4d5QI", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $d551a96418d6f0d6$export$27df359c528b7120);
const $d551a96418d6f0d6$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("Yce2Z", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $9797aa8ef3e59fc7$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $glbdM = parcelRequire("glbdM");

var $ljVHR = parcelRequire("ljVHR");

var $10stC = parcelRequire("10stC");

var $9fOPQ = parcelRequire("9fOPQ");

var $3QaPb = parcelRequire("3QaPb");

var $6F88w = parcelRequire("6F88w");

var $3xxAB = parcelRequire("3xxAB");

var $64jrG = parcelRequire("64jrG");

var $3aVyC = parcelRequire("3aVyC");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $9797aa8ef3e59fc7$var$supportsPopoverHint = (0, $10stC.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited text-layout properties (e.g.
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
const $9797aa8ef3e59fc7$var$surfaceResetStyles = {
    root: "_o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
const $9797aa8ef3e59fc7$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk18uv _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $9797aa8ef3e59fc7$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ const $9797aa8ef3e59fc7$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
const $9797aa8ef3e59fc7$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $euxye.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $euxye.useId)();
    const ownRef = (0, $euxye.useRef)(null);
    const combinedRef = (0, $ljVHR.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    const { phase: phase } = (0, $3xxAB.useAnimatedVisibility)({
        isOpen: isOpen,
        animationKind: 'popover',
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $64jrG.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $3aVyC.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    const handleObserverClose = (0, $euxye.useCallback)(()=>{
        onClose?.({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        type: role && $9797aa8ef3e59fc7$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$9797aa8ef3e59fc7$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $euxye.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $3QaPb.resolvePlacement)({
            placement: placement
        });
        return $9797aa8ef3e59fc7$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    const programmaticCloseRef = (0, $euxye.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    const closeReasonRef = (0, $euxye.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    const previouslyFocusedElementRef = (0, $euxye.useRef)(null);
    const handleBeforeToggle = (0, $euxye.useCallback)((event)=>{
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        const active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    const handleToggle = (0, $euxye.useCallback)((event)=>{
        const element = ownRef.current;
        if (event.newState === 'open') return;
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                const previouslyFocused = previouslyFocusedElementRef.current;
                const reason = closeReasonRef.current;
                const isProgrammatic = programmaticCloseRef.current;
                const shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $6F88w.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            const reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose?.({
                reason: reason
            });
        }
    }, [
        onClose,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $euxye.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $glbdM.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $glbdM.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        const unbindBeforeToggle = (0, $glbdM.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $euxye.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $9797aa8ef3e59fc7$var$styles.root,
            $9797aa8ef3e59fc7$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $9797aa8ef3e59fc7$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $9797aa8ef3e59fc7$var$styles.exit,
            shouldAnimate && $9797aa8ef3e59fc7$var$styles.motion,
            (0, $9S1b6.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("10stC", function(module, exports) {
$parcel$export(module.exports, "default", () => $74fa41523388f13c$export$2e2bcd8739ae039);
function $74fa41523388f13c$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
		 * Intentionally not adding `.clear()` function property
		 *
		 * - We currently have no need for it
		 * - We don't want to add a `.clear()` to functions that should never be called twice,
		 *   for example: `cleanup` functions.
		 * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
		 *   need arises 🧘
		 */ return cache.value;
    };
}

});

parcelRegister("3QaPb", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $8bba109e0312817b$export$63044d21bc3d3fa2);

var $5OKCA = parcelRequire("5OKCA");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $8bba109e0312817b$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $8bba109e0312817b$export$63044d21bc3d3fa2({ placement: placement }) {
    const consumerGap = placement.offset?.gap;
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        offset: {
            gap: consumerGap === undefined ? $8bba109e0312817b$var$DEFAULT_GAP : (0, $5OKCA.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $5OKCA.toCssLengthString)({
                    value: placement.offset?.crossAxisShift?.value ?? 0
                }),
                direction: placement.offset?.crossAxisShift?.direction ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("5OKCA", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $be53893949475b8f$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $be53893949475b8f$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("6F88w", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $59bbb7817eb0a6bd$export$b12adccf56228c71);
/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $59bbb7817eb0a6bd$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $59bbb7817eb0a6bd$export$b12adccf56228c71({ role: role }) {
    if (!role) return false;
    return $59bbb7817eb0a6bd$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("3xxAB", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $c44327632a60c2e0$export$1bccb45daf07907f);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $6B3Qd = parcelRequire("6B3Qd");
/**
 * Using the recommended motion timings for safety net.
 *
 * Not setting these timings on the preset config because they're defined in the CSS,
 * so configuring it in the preset doesn't achieve anything except introduce a potential
 * source of drift.
 *
 * TODO: figure out a way to not need to redeclare these in the future,
 * and keep CSS and JS timings in sync always.
 */ const $c44327632a60c2e0$var$safetyNetMsMap = {
    dialog: {
        enter: 250,
        exit: 200
    },
    popover: {
        enter: 150,
        exit: 100
    }
};
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $c44327632a60c2e0$var$runOnTransitionEndOrTimeout({ element: element, safetyNetMs: safetyNetMs, onSettled: onSettled }) {
    const state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    const unbind = (0, $glbdM.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    const safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $c44327632a60c2e0$export$1bccb45daf07907f({ isOpen: isOpen, animationKind: animationKind, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $6B3Qd.prefersReducedMotion)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    const [phase, setPhase] = (0, $euxye.useState)(()=>{
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    });
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $euxye.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    const onExitFinishRef = (0, $euxye.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $euxye.useEffect)(()=>{
        if (phase !== 'entering') return;
        const element = elementRef.current;
        if (!element) return;
        return $c44327632a60c2e0$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $c44327632a60c2e0$var$safetyNetMsMap[animationKind].enter + 50,
            onSettled: ()=>{
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                onEnterFinishRef.current?.();
                setPhase((current)=>current === 'entering' ? 'open' : current);
            }
        });
    }, [
        phase,
        animationKind,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    const prevPhaseForEntryRef = (0, $euxye.useRef)('closed');
    (0, $euxye.useEffect)(()=>{
        const prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') onEnterFinishRef.current?.();
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $euxye.useEffect)(()=>{
        if (phase !== 'exiting' || !willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        return $c44327632a60c2e0$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $c44327632a60c2e0$var$safetyNetMsMap[animationKind].exit + 50,
            onSettled: ()=>{
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                onExitFinishRef.current?.();
                setPhase((current)=>current === 'exiting' ? 'closed' : current);
            }
        });
    }, [
        phase,
        willAnimate,
        animationKind,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $euxye.useLayoutEffect)(()=>{
        if (phase !== 'exiting' || willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase((current)=>current === 'exiting' ? 'closed' : current);
        }
        return (0, $glbdM.bindAll)(element, [
            {
                type: 'toggle',
                listener: (event)=>{
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    const prevPhaseForExitRef = (0, $euxye.useRef)('closed');
    (0, $euxye.useEffect)(()=>{
        const prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) onExitFinishRef.current?.();
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase
    };
}

});
parcelRegister("6B3Qd", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $2d5e7b9701c19f7a$export$ff7706047246b98b);

var $10stC = parcelRequire("10stC");
const $2d5e7b9701c19f7a$export$ff7706047246b98b = (0, $10stC.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("64jrG", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $414f26c68f497ad2$export$4f6462e86a70abe5);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $42lUo = parcelRequire("42lUo");

var $1ExBq = parcelRequire("1ExBq");

var $1it5j = parcelRequire("1it5j");

var $1vjUf = parcelRequire("1vjUf");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $414f26c68f497ad2$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $414f26c68f497ad2$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $euxye.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$414f26c68f497ad2$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $glbdM.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $1vjUf.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $1it5j.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $42lUo.getFirstFocusable)({
                    container: element
                }) : (0, $1ExBq.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("42lUo", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $51068d13a16e3d11$export$748138f04a69bf21);

var $6xbjd = parcelRequire("6xbjd");
function $51068d13a16e3d11$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $6xbjd.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("6xbjd", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $a8ab8e26e5c629aa$export$f6768025e418420e);

var $1XSPa = parcelRequire("1XSPa");

var $7ay9y = parcelRequire("7ay9y");
function $a8ab8e26e5c629aa$export$f6768025e418420e({ container: container, filter: filter }) {
    return Array.from(container.querySelectorAll((0, $7ay9y.selectors).focusable)).filter((element)=>element instanceof HTMLElement).filter((element)=>(0, $1XSPa.isInSameLayer)({
            element: element,
            container: container
        })).filter((element)=>!filter || filter(element, container));
}

});
parcelRegister("1XSPa", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $c244e95bbc099386$export$df8c72c64edc7260);
const $c244e95bbc099386$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $c244e95bbc099386$export$df8c72c64edc7260({ element: element, container: container }) {
    const elementLayer = element.closest($c244e95bbc099386$var$topLayerSelector);
    const containerLayer = container.closest($c244e95bbc099386$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}

});

parcelRegister("7ay9y", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $8ffc35d3dd95e893$export$e1252723db1c541);
const $8ffc35d3dd95e893$export$e1252723db1c541 = (()=>{
    // Common exclusion filter applied to every selector.
    const not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    const notDisabled = `:not([disabled])${not}`;
    const focusable = [
        `a[href]${not}`,
        `area[href]${not}`,
        `input${notDisabled}:not([type="hidden"])`,
        `select${notDisabled}`,
        `textarea${notDisabled}`,
        `button${notDisabled}`,
        `iframe${not}`,
        `audio[controls]${not}`,
        `video[controls]${not}`,
        `[contenteditable]:not([contenteditable="false"])${not}`,
        `[tabindex]${notDisabled}${not}`
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map((selector)=>`${selector}:focus`).join(',')
    };
})();

});



parcelRegister("1ExBq", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $b028b4be6e7b4e34$export$73e81fa65335a75b);

var $6xbjd = parcelRequire("6xbjd");
function $b028b4be6e7b4e34$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $6xbjd.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("1it5j", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $5cf2cabf052a6a01$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $6xbjd = parcelRequire("6xbjd");

var $7ay9y = parcelRequire("7ay9y");
function $5cf2cabf052a6a01$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $6xbjd.getFocusables)({
        container: container,
        filter: filter
    });
    const current = container.querySelector((0, $7ay9y.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    const index = all.indexOf(current);
    if (index === -1) return null;
    const nextIndex = (()=>{
        if (direction === 'forwards') return (index + 1) % all.length;
        const proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    })();
    return all[nextIndex] ?? null;
}

});

parcelRegister("1vjUf", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $2dc7184a7b7c1773$export$b9590fdfeb5f722f);

var $eIbOZ = parcelRequire("eIbOZ");

var $1XSPa = parcelRequire("1XSPa");
function $2dc7184a7b7c1773$export$b9590fdfeb5f722f({ container: container }) {
    const focused = (0, $eIbOZ.getDocument)()?.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $1XSPa.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("3aVyC", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $a2bb73e31d650443$export$e992c40175757a22);

var $euxye = parcelRequire("euxye");

var $42lUo = parcelRequire("42lUo");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $a2bb73e31d650443$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $a2bb73e31d650443$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $a2bb73e31d650443$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $a2bb73e31d650443$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$a2bb73e31d650443$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $a2bb73e31d650443$var$getInitialFocusTarget({ container: container, role: role }) {
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $42lUo.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($a2bb73e31d650443$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $42lUo.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($a2bb73e31d650443$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $42lUo.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $a2bb73e31d650443$export$e992c40175757a22({ elementRef: elementRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $euxye.useRef)('closed');
    (0, $euxye.useEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        $a2bb73e31d650443$var$getInitialFocusTarget({
            container: element,
            role: role
        })?.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("fEJPe", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $761bae4008240f12$export$56b02a1e583f953c);
/**
 * Anchor positioning for top-layer popovers. See
 * `notes/architecture/positioning.md` for the full model.
 *
 * Two runtime paths: CSS Anchor Positioning (modern browsers) and a JS
 * fallback that measures the trigger and writes `top`/`left`.
 *
 * Both paths honour `offset.gap` and `offset.crossAxisShift`. The
 * CSS path passes the values through as strings; the JS fallback resolves
 * them to pixels via a hidden DOM probe (see `resolveCssLengthToPixels`)
 * so tokens, `calc()`, `var()`, etc all work. The JS fallback hides the
 * popover with `opacity: 0` until the first measurement completes, so it
 * is never painted at the wrong location.
 */ 
var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $1qU3G = parcelRequire("1qU3G");

var $10stC = parcelRequire("10stC");

var $bPLs4 = parcelRequire("bPLs4");

var $4yA22 = parcelRequire("4yA22");

var $cduDp = parcelRequire("cduDp");

var $9awX3 = parcelRequire("9awX3");

var $9uIoc = parcelRequire("9uIoc");

var $3QaPb = parcelRequire("3QaPb");

var $6G4M2 = parcelRequire("6G4M2");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ const $761bae4008240f12$var$NoopResizeObserver = class {
    observe() {}
    unobserve() {}
    disconnect() {}
};
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $761bae4008240f12$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ const $761bae4008240f12$var$supportsAnchorPositioning = (0, $10stC.default)(()=>{
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $761bae4008240f12$var$edgeMargin({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    const value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $761bae4008240f12$var$crossAxisShiftMargin({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const { axis: axis, align: align } = placement;
    const directionSign = direction === 'forwards' ? 1 : -1;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const useEndSide = align === 'end';
    const side = useEndSide ? 'end' : 'start';
    const sideSign = useEndSide ? -1 : 1;
    const finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    const value = finalSign === 1 ? crossAxisShiftCssValue : `calc(-1 * ${crossAxisShiftCssValue})`;
    return {
        property: `margin-${crossAxis}-${side}`,
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $761bae4008240f12$var$useStablePlacement(placement) {
    const resolved = (0, $3QaPb.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $euxye.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $761bae4008240f12$export$56b02a1e583f953c({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement = {}, forceFallbackPositioning: forceFallbackPositioning = false, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const id = (0, $euxye.useId)();
    const stablePlacement = $761bae4008240f12$var$useStablePlacement(placement);
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        const gapCssValue = stablePlacement.offset.gap;
        const crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        const shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($761bae4008240f12$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            const anchorName = trigger.style.getPropertyValue('anchor-name') || `--anchor-${id.replace(/:/g, '')}`;
            const gap = $761bae4008240f12$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            const crossAxisShift = $761bae4008240f12$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            const popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $cduDp.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $9awX3.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            const crossAxisShiftActive = crossAxisShift;
            const customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            const crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
			 * **We are never cleaning up anchor names**
			 *
			 * _Rationale_
			 *
			 * - Multiple popovers can share the same anchor element.
			 * - Sometimes the `useAnchorPosition` hook and `Popover`
			 *   are not in the same component.
			 * - There can be times when, even with reference counting, we
			 *   could remove the anchor-name while it is still being used
			 *   by something else - especially with async react updates
			 *   which can cause tearing
			 *
			 * _More_
			 *
			 * See `notes/decisions/anchor-name-lifetime.md`
			 */ trigger.style.setProperty('anchor-name', anchorName);
            const undoPositioning = (0, $4yA22.combine)((0, $6G4M2.setStyle)({
                element: popover,
                styles: popoverStyles
            }));
            return undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        const cleanupBaseStyles = (0, $6G4M2.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        let undoPosition;
        let undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $6G4M2.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            undoHide?.();
            undoHide = undefined;
        }
        function restorePosition() {
            undoPosition?.();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            const triggerRect = trigger.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            const gapPx = (0, $9uIoc.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            const crossAxisShiftPx = (0, $9uIoc.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            const { top: top, left: left } = (0, $bPLs4.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            });
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $6G4M2.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        const scheduledUpdate = (0, $1qU3G.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        const ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $761bae4008240f12$var$NoopResizeObserver;
        const resizeObserver = new ResizeObserverImpl(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($761bae4008240f12$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        const undoPositioning = (0, $4yA22.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $glbdM.bind)(popover, {
            type: 'toggle',
            listener: (event)=>{
                const toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), ()=>resizeObserver.disconnect(), (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), ()=>{
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("bPLs4", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $df1f9df516d27d23$export$d5ef1dac02135664);
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $df1f9df516d27d23$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $df1f9df516d27d23$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $df1f9df516d27d23$var$applyCrossAxisShift({ position: position, axis: axis, align: align, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const sideSign = align === 'end' ? -1 : 1;
    const delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $df1f9df516d27d23$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $df1f9df516d27d23$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $df1f9df516d27d23$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $df1f9df516d27d23$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("4yA22", function(module, exports) {
$parcel$export(module.exports, "combine", () => $4d7708e19aa76ed2$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $4d7708e19aa76ed2$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback?.());
    };
}

});

parcelRegister("cduDp", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $5bbf06eed88523a4$export$de49b61f233ddeb9);

var $3QaPb = parcelRequire("3QaPb");
function $5bbf06eed88523a4$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = (0, $3QaPb.resolvePlacement)({
        placement: placement
    });
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("9awX3", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $91723d13fbeca1eb$export$c4e16947a95d61f1);

var $3QaPb = parcelRequire("3QaPb");
function $91723d13fbeca1eb$var$slideOnEdge({ align: align, edgeKey: edgeKey, crossAxis: crossAxis }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    const near = align === 'start' ? 'end' : 'start';
    const far = align === 'start' ? 'start' : 'end';
    return [
        `${edgeKey} span-${crossAxis}-${near}`,
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function $91723d13fbeca1eb$var$flipDiagonally({ axis: axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function $91723d13fbeca1eb$export$c4e16947a95d61f1({ placement: placement }) {
    /**
	 * **Build the fallback list**
	 *
	 * Each entry is a complete alternative position.
	 * The browser tries them _in order_ and uses the _first_ one that fits.
	 */ const resolved = (0, $3QaPb.resolvePlacement)({
        placement: placement
    });
    const { axis: axis, edge: edge, align: align } = resolved;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
	 * **Fallback algorithm**
	 *
	 * We have two things we can do to keep something visible:
	 *
	 * 1. _Slide_ along edges
	 * 2. _Flip_ to another edge
	 *
	 * _Centered popover_
	 *
	 * Desired: Sits in middle of main edge
	 *
	 * Fallbacks:
	 *  1: _Slide_ along main edge on the cross axis
	 *  2: _Flip_ on main axis to opposite edge (centered)
	 *  3: _Slide_ along opposite edge on the cross axis
	 *
	 * _Start or end aligned popover_
	 *
	 * Desired: Sits at start / end of main edge
	 *
	 * Fallbacks:
	 *  1: _Slide_ along main edge on the cross axis
	 *  2: _Flip_ on main axis to opposite edge
	 *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
	 *     opposite corner. For start / end alignment, this is the clean escape
	 *     when the popover would otherwise land offscreen on both axes (ie in a
	 *     corner). Rule 4 gets the job done, but a slide drops the gap
	 *     as named position-area values don't carry margins).
	 *     The diagonal flip keeps the gap and the alignment.
	 *  4: _Slide_ along opposite edge on the cross axis
	 */ return [
        $91723d13fbeca1eb$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $91723d13fbeca1eb$var$flipDiagonally({
            axis: axis
        }) : null,
        $91723d13fbeca1eb$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("9uIoc", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $86a531d749844399$export$98721546d2816d9e);
const $86a531d749844399$var$elementCaches = new WeakMap();
function $86a531d749844399$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $86a531d749844399$var$getCachedResolvedLength({ element: element, value: value }) {
    if (!$86a531d749844399$var$canCacheResolvedLength(value)) return null;
    const cacheForElement = $86a531d749844399$var$elementCaches.get(element);
    return cacheForElement?.get(value) ?? null;
}
function $86a531d749844399$var$cacheResolvedLength({ element: element, value: value, result: result }) {
    if (!$86a531d749844399$var$canCacheResolvedLength(value)) return;
    const cacheForElement = $86a531d749844399$var$elementCaches.get(element) ?? new Map();
    cacheForElement.set(value, result);
    $86a531d749844399$var$elementCaches.set(element, cacheForElement);
}
function $86a531d749844399$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    const cached = $86a531d749844399$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    const resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    const result = Number.isFinite(resolved) ? resolved : 0;
    $86a531d749844399$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("6G4M2", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $8bdd9169ce4e3dec$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $8bdd9169ce4e3dec$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("3C8J6", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", () => $8b200b3b90686828$export$6f230729189a5b8a);

var $euxye = parcelRequire("euxye");

var $fEJPe = parcelRequire("fEJPe");
/**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $8b200b3b90686828$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $8b200b3b90686828$export$6f230729189a5b8a({ popoverRef: popoverRef, placement: placement, getPoint: getPoint, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const syntheticAnchorRef = (0, $euxye.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    const getPointRef = (0, $euxye.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $8b200b3b90686828$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = `${point.y}px`;
        anchor.style.left = `${point.x}px`;
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $fEJPe.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("kUmcP", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $c948a3be77ddacb8$export$9198c6c168be2eeb);

var $gUxVT = parcelRequire("gUxVT");
function $c948a3be77ddacb8$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return `popover-${(0, $gUxVT.useId)()}`;
}

});
parcelRegister("gUxVT", function(module, exports) {
$parcel$export(module.exports, "useId", () => $9690deafe29a2917$export$f680877a34711e37);

var $euxye = parcelRequire("euxye");
function $9690deafe29a2917$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useId().replace(/[:«»]/g, '_');
}

});


parcelRegister("jNSP2", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $f378cf5191d59dfb$export$7071d791a7b131ed);

var $euxye = parcelRequire("euxye");

var $6G4M2 = parcelRequire("6G4M2");
function $f378cf5191d59dfb$export$7071d791a7b131ed({ mode: mode, popoverRef: popoverRef, anchorRef: anchorRef, isOpen: isOpen }) {
    (0, $euxye.useLayoutEffect)(()=>{
        const node = popoverRef.current;
        if (!node) return;
        // Feature-detect `anchor-size()` specifically (not just `anchor-name`)
        // so the JS fallback fires correctly in browsers that support anchor
        // positioning but not anchor sizing.
        const supportsAnchorSize = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('width', 'anchor-size(width)');
        if (mode === 'match-anchor') {
            // Set an exact width matching the anchor.
            // `min-inline-size` is intentionally NOT set here - it would override the
            // explicit width constraint, allowing the popover to grow past the anchor's width.
            if (supportsAnchorSize) return (0, $6G4M2.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            // JS fallback: one-off read of the anchor's width.
            const anchor = anchorRef.current;
            if (anchor) return (0, $6G4M2.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            return;
        }
        // For 'min-anchor' and 'none', apply `min-inline-size: max-content` to ensure
        // correct position-try-fallbacks behaviour (popover margin box overflows the
        // viewport when its span region is too narrow, rather than wrapping content).
        const minInlineSizeStyle = {
            property: 'min-inline-size',
            value: 'max-content'
        };
        if (mode === 'min-anchor') {
            // Set a minimum width matching the anchor. The popover can grow wider
            // if its content requires it.
            if (supportsAnchorSize) return (0, $6G4M2.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            const anchor = anchorRef.current;
            if (anchor) return (0, $6G4M2.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            // No anchor available in JS fallback - still apply min-inline-size.
            return (0, $6G4M2.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle
                ]
            });
        }
        // 'none' mode: no explicit width, but still apply `min-inline-size: max-content`.
        return (0, $6G4M2.setStyle)({
            element: node,
            styles: [
                minInlineSizeStyle
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("6QwyO", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $d98aca26c64e4cc9$export$175375e9a2b5515d);

var $eIbOZ = parcelRequire("eIbOZ");
function $d98aca26c64e4cc9$export$175375e9a2b5515d() {
    const document = (0, $eIbOZ.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("9s3MN", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $075ba22d38a035eb$export$b065aeb850c3e87f);
function $075ba22d38a035eb$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $075ba22d38a035eb$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $075ba22d38a035eb$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $075ba22d38a035eb$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $075ba22d38a035eb$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $075ba22d38a035eb$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $075ba22d38a035eb$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("cd4fb", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $70e5e162938ded56$export$e9a6fdb80170ffd);
function $70e5e162938ded56$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("64NRn", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", () => $4c95dee8ca2be486$export$f16d8ac7373995e1);

var $euxye = parcelRequire("euxye");

var $gTiQ7 = parcelRequire("gTiQ7");
const $4c95dee8ca2be486$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
const $4c95dee8ca2be486$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ const $4c95dee8ca2be486$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ const $4c95dee8ca2be486$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $4c95dee8ca2be486$export$f16d8ac7373995e1({ target: target, placementAxis: placementAxis, gap: gap, isEnabled: isEnabled, isOpen: isOpen }) {
    (0, $euxye.useLayoutEffect)(()=>{
        const element = target.current;
        if (!element || !isEnabled) return;
        const isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        const primaryAxisCap = `calc(100% - 5px - ${gap})`;
        const cleanupHost = (0, $gTiQ7.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $4c95dee8ca2be486$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $4c95dee8ca2be486$var$CROSS_BLOCK_CAP
                },
                // Park the reserved viewport padding on the non-anchor sides so a
                // capped popover keeps the legacy `viewportPadding` gap from the
                // viewport edge instead of sitting flush against it.
                ...$4c95dee8ca2be486$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map((property)=>({
                        property: property,
                        value: $4c95dee8ca2be486$var$VIEWPORT_PADDING
                    }))
            ]
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        const child = element.firstElementChild;
        const cleanupChild = child instanceof HTMLElement ? (0, $gTiQ7.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return ()=>{
            cleanupHost();
            cleanupChild?.();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("gTiQ7", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $41c6e3f425bb3bf8$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $41c6e3f425bb3bf8$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("764C7", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $5c8adba90ebf9ceb$export$941a7e8bf0b9eafd);

var $euxye = parcelRequire("euxye");

var $aG9bG = parcelRequire("aG9bG");
function $5c8adba90ebf9ceb$export$941a7e8bf0b9eafd() {
    return (0, $euxye.useContext)((0, $aG9bG.AnchorContext));
}

});
parcelRegister("aG9bG", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $5cfed1b9456f92d4$export$8f73317645bb7b8e);

var $euxye = parcelRequire("euxye");
const $5cfed1b9456f92d4$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $euxye.createContext)(null);

});


parcelRegister("9eQQl", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $a4f9c9eb96e46358$export$61d36e2b682e92f7);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $6FofL = parcelRequire("6FofL");
const $a4f9c9eb96e46358$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $a4f9c9eb96e46358$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $a4f9c9eb96e46358$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $a4f9c9eb96e46358$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $a4f9c9eb96e46358$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $a4f9c9eb96e46358$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $a4f9c9eb96e46358$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $euxye.useState)($a4f9c9eb96e46358$var$INITIAL);
    const measure = (0, $euxye.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $a4f9c9eb96e46358$var$INITIAL);
            return;
        }
        const viewport = (0, $6FofL.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $a4f9c9eb96e46358$var$isFullyOutsideViewport(anchorRect, viewport) || $a4f9c9eb96e46358$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $a4f9c9eb96e46358$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $glbdM.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $glbdM.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("6FofL", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $3223e7c49e7abaa1$export$64beed533e21f72d);
function $3223e7c49e7abaa1$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("5PG2M", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e367fa0dab17410$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $49xHv = parcelRequire("49xHv");

var $fkqbw = parcelRequire("fkqbw");

var $Ounuv = parcelRequire("Ounuv");

var $ddmiE = parcelRequire("ddmiE");
function $2e367fa0dab17410$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect', isClosed: isClosed = false }) {
    const isSubsequentRender = (0, $Ounuv.default)(mountStrategy);
    (0, $ddmiE.default)(zIndex);
    return !(0, $iqfTZ.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $49xHv.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    }) : null : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fkqbw.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    });
}
$2e367fa0dab17410$export$2e2bcd8739ae039.displayName = "Portal";

});
parcelRegister("49xHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8919c58dd0cd605$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $9fViR = parcelRequire("9fViR");
var $bV5W6 = parcelRequire("bV5W6");

var $3TXt5 = parcelRequire("3TXt5");

var $iqfTZ = parcelRequire("iqfTZ");

var $4jpym = parcelRequire("4jpym");

var $fOi0s = parcelRequire("fOi0s");

var $5k4kh = parcelRequire("5k4kh");
function $c8919c58dd0cd605$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed = false } = props;
    const container = (0, $euxye.useMemo)(()=>(0, $fOi0s.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $bV5W6.useColorMode)();
    const isInsideThemeProvider = (0, $3TXt5.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $4jpym.appendPortalContainerIfNotAppended)(container);
    (0, $euxye.useEffect)(()=>{
        if ((0, $iqfTZ.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $5k4kh.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            (0, $5k4kh.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $85XPu.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9fViR.ThemeProvider), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}
$c8919c58dd0cd605$export$2e2bcd8739ae039.displayName = "InternalPortal";

});
parcelRegister("9fViR", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $614818040c11d5ed$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $6er1G = parcelRequire("6er1G");

var $dVXXi = parcelRequire("dVXXi");

var $2lTuw = parcelRequire("2lTuw");

var $eF8Qg = parcelRequire("eF8Qg");

var $8DDUN = parcelRequire("8DDUN");

var $lUsrP = parcelRequire("lUsrP");

var $8Fg0Q = parcelRequire("8Fg0Q");

var $gctLG = parcelRequire("gctLG");

var $aOg1t = parcelRequire("aOg1t");

var $3TXt5 = parcelRequire("3TXt5");

var $3bTna = parcelRequire("3bTna");
const $614818040c11d5ed$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
const $614818040c11d5ed$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $614818040c11d5ed$var$prefersDarkModeMql = $614818040c11d5ed$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $614818040c11d5ed$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $614818040c11d5ed$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $614818040c11d5ed$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $614818040c11d5ed$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $euxye.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $euxye.useState)($614818040c11d5ed$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $euxye.useState)(()=>({
            ...$614818040c11d5ed$var$defaultThemeSettings,
            ...defaultTheme
        }));
    const setColorMode = (0, $euxye.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($614818040c11d5ed$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $euxye.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $euxye.useRef)(null);
    const isInsideAppProvider = (0, $8DDUN.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $eF8Qg.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $3TXt5.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $euxye.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $2lTuw.default)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $3bTna.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!$614818040c11d5ed$var$prefersDarkModeMql) return;
        const unbindListener = (0, $glbdM.bind)($614818040c11d5ed$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $dVXXi.default)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $6er1G.SUBTREE_THEME_ATTRIBUTE)]: true
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Fg0Q.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lUsrP.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gctLG.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aOg1t.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aOg1t.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                            ...attrs,
                            className: (0, $4jQY2.default)([
                                $614818040c11d5ed$var$contentStyles.body
                            ]),
                            children: children
                        }) : children
                    })
                })
            })
        })
    });
}
$614818040c11d5ed$export$d8964aec282183a3.displayName = "ThemeProvider";

});
parcelRegister("6er1G", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $c577f6a402797347$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $c577f6a402797347$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $c577f6a402797347$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $c577f6a402797347$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $c577f6a402797347$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $c577f6a402797347$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $c577f6a402797347$export$9d7b58831ae93caa);
const $c577f6a402797347$export$4ef52930e33717cd = 'data-theme';
const $c577f6a402797347$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $c577f6a402797347$export$a00eac3f8684bcd0 = 'data-color-mode';
const $c577f6a402797347$export$2112803007239c61 = 'data-contrast-mode';
const $c577f6a402797347$export$352e418ed5b6193a = 'data-custom-theme';
const $c577f6a402797347$export$6f0c6fb8c80fcc92 = 'ds';
const $c577f6a402797347$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $c577f6a402797347$export$dddac1532e822863 = `--${$c577f6a402797347$export$6f0c6fb8c80fcc92}-token-not-found`;
const $c577f6a402797347$export$9d7b58831ae93caa = `--${$c577f6a402797347$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("dVXXi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff738dfffe977e85$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $6er1G = parcelRequire("6er1G");

var $98Ebb = parcelRequire("98Ebb");

var $eqG5e = parcelRequire("eqG5e");

var $3PnK8 = parcelRequire("3PnK8");

var $9JjCe = parcelRequire("9JjCe");
const $ff738dfffe977e85$var$defaultColorMode = 'light';
const $ff738dfffe977e85$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $ff738dfffe977e85$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $98Ebb.themeStateDefaults)['colorMode'], dark: dark = (0, $98Ebb.themeStateDefaults)['dark'], light: light = (0, $98Ebb.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $98Ebb.themeStateDefaults)['contrastMode'], motion: motion = (0, $98Ebb.themeStateDefaults)['motion'](), shape: shape = (0, $98Ebb.themeStateDefaults)['shape'](), spacing: spacing = (0, $98Ebb.themeStateDefaults)['spacing'], typography: typography = (0, $98Ebb.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $98Ebb.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $eqG5e.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $6er1G.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $6er1G.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $ff738dfffe977e85$var$defaultColorMode : colorMode
    };
    if ((0, $iqfTZ.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $6er1G.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $ff738dfffe977e85$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $9JjCe.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $3PnK8.hash)(optionString);
        result[0, $6er1G.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $ff738dfffe977e85$export$2e2bcd8739ae039 = $ff738dfffe977e85$var$getThemeHtmlAttrs;

});
parcelRegister("98Ebb", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $978db59aad76348c$export$9aedcfa7336a207);

var $iqfTZ = parcelRequire("iqfTZ");
function $978db59aad76348c$var$getShapeDefault() {
    if ((0, $iqfTZ.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $978db59aad76348c$var$getMotionDefault() {
    return 'motion';
}
const $978db59aad76348c$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $978db59aad76348c$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $978db59aad76348c$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("eqG5e", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $3e4dfdf1d02fa884$export$62c37ab81302621a);

var $gjeLM = parcelRequire("gjeLM");

var $7NEwP = parcelRequire("7NEwP");

var $1sh1G = parcelRequire("1sh1G");
const $3e4dfdf1d02fa884$var$customThemeOptions = 'UNSAFE_themeOptions';
const $3e4dfdf1d02fa884$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $gjeLM.isColorMode)(id) || // custom theme state
        kind === $3e4dfdf1d02fa884$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $1sh1G.isThemeKind)(kind) && typeof id === 'string' && (0, $7NEwP.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("gjeLM", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $75898915be4da459$export$4a14e169b1de4ee7);
const $75898915be4da459$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("7NEwP", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $e5abbf9214f9ceab$export$ea35b8958c39dd07);

var $aUuHv = parcelRequire("aUuHv");
const $e5abbf9214f9ceab$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $aUuHv.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("aUuHv", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $9b46976b675a0680$export$7d43e72a58e3283f);
const $9b46976b675a0680$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("1sh1G", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $b4b9cb2909348f2a$export$958fa026be3a263e);
const $b4b9cb2909348f2a$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $b4b9cb2909348f2a$export$958fa026be3a263e = (themeKind)=>{
    return $b4b9cb2909348f2a$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("3PnK8", function(module, exports) {
$parcel$export(module.exports, "hash", () => $560821c078f252af$export$d6af199866bfb566);
const $560821c078f252af$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("9JjCe", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $83f8fa5eecf61267$export$53031ac1ecb71f44);
const $83f8fa5eecf61267$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("2lTuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9c1aadf257ff6ed$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $3CpXJ = parcelRequire("3CpXJ");

var $98Ebb = parcelRequire("98Ebb");

var $bI0n9 = parcelRequire("bI0n9");

var $guVzD = parcelRequire("guVzD");

var $9iI4H = parcelRequire("9iI4H");

var $bdbur = parcelRequire("bdbur");

var $9JjCe = parcelRequire("9JjCe");

var $cDku3 = parcelRequire("cDku3");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $a9c1aadf257ff6ed$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $98Ebb.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $98Ebb.themeStateDefaults)['contrastMode'], dark: dark = (0, $98Ebb.themeStateDefaults)['dark'], light: light = (0, $98Ebb.themeStateDefaults)['light'], shape: shape = (0, $98Ebb.themeStateDefaults)['shape'](), spacing: spacing = (0, $98Ebb.themeStateDefaults)['spacing'], typography: typography = (0, $98Ebb.themeStateDefaults)['typography'], motion: motion = (0, $98Ebb.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $98Ebb.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $98Ebb.themeStateDefaults),
        typography: (0, $98Ebb.themeStateDefaults)['typography'],
        shape: (0, $98Ebb.themeStateDefaults)['shape'](),
        motion: (0, $98Ebb.themeStateDefaults)['motion'](),
        ...(0, $3CpXJ.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $iqfTZ.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $bdbur.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $cDku3.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $9JjCe.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $98Ebb.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $guVzD.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("1BPNn"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $9iI4H.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $bI0n9.default)(themeState);
    return autoUnbind;
};
var $a9c1aadf257ff6ed$export$2e2bcd8739ae039 = $a9c1aadf257ff6ed$var$setGlobalTheme;

});
parcelRegister("3CpXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a24168108c24bfd$export$2e2bcd8739ae039);

var $6er1G = parcelRequire("6er1G");

var $fzKYJ = parcelRequire("fzKYJ");

var $fCKGX = parcelRequire("fCKGX");
const $2a24168108c24bfd$var$isThemeColorMode = (colorMode)=>{
    return (0, $fzKYJ.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $2a24168108c24bfd$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $6er1G.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $6er1G.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $fCKGX.themeStringToObject)(theme),
        ...$2a24168108c24bfd$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $2a24168108c24bfd$export$2e2bcd8739ae039 = $2a24168108c24bfd$var$getGlobalTheme;

});
parcelRegister("fzKYJ", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $342fbe0c38a1b9e1$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $342fbe0c38a1b9e1$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});

parcelRegister("fCKGX", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $edcacff20fac0075$export$f19b488f7c0547ee);

var $gjeLM = parcelRequire("gjeLM");

var $7NEwP = parcelRequire("7NEwP");

var $1sh1G = parcelRequire("1sh1G");
const $edcacff20fac0075$var$customThemeOptions = 'UNSAFE_themeOptions';
const $edcacff20fac0075$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $gjeLM.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $1sh1G.isThemeKind)(kind) && (0, $7NEwP.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $edcacff20fac0075$var$customThemeOptions) try {
            themeObject[$edcacff20fac0075$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("bI0n9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5f1b7cdabae3a04$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $dVXXi = parcelRequire("dVXXi");

var $84pPR = parcelRequire("84pPR");

var $7nY6E = parcelRequire("7nY6E");
function $c5f1b7cdabae3a04$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $84pPR.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $84pPR.default).bind();
    } else (0, $84pPR.default).unbind();
    if ((0, $iqfTZ.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $7nY6E.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $7nY6E.default).bind();
        } else (0, $7nY6E.default).unbind();
    }
    const themeAttributes = (0, $dVXXi.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $84pPR.default).unbind();
        if ((0, $iqfTZ.fg)('platform_increased-contrast-themes')) (0, $7nY6E.default).unbind();
    };
}

});
parcelRegister("84pPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac1aff14ca0ae7c8$export$2e2bcd8739ae039);

var $glbdM = parcelRequire("glbdM");

var $6er1G = parcelRequire("6er1G");

var $cDku3 = parcelRequire("cDku3");
const $ac1aff14ca0ae7c8$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $ac1aff14ca0ae7c8$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $6er1G.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $ac1aff14ca0ae7c8$var$darkModeMql = $ac1aff14ca0ae7c8$var$isMatchMediaAvailable && window.matchMedia((0, $cDku3.darkModeMediaQuery));
class $ac1aff14ca0ae7c8$var$ColorModeObserver {
    getColorMode() {
        if (!$ac1aff14ca0ae7c8$var$darkModeMql) return 'light';
        return $ac1aff14ca0ae7c8$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($ac1aff14ca0ae7c8$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $glbdM.bind)($ac1aff14ca0ae7c8$var$darkModeMql, {
            type: 'change',
            listener: $ac1aff14ca0ae7c8$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
$ac1aff14ca0ae7c8$var$ColorModeObserver.displayName = "ColorModeObserver";
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $ac1aff14ca0ae7c8$var$SingletonColorModeObserver = new $ac1aff14ca0ae7c8$var$ColorModeObserver();
var $ac1aff14ca0ae7c8$export$2e2bcd8739ae039 = $ac1aff14ca0ae7c8$var$SingletonColorModeObserver;

});
parcelRegister("cDku3", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $c7eb2edbd0da17eb$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $c7eb2edbd0da17eb$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $c7eb2edbd0da17eb$export$8662df6937d86fcb);

var $6er1G = parcelRequire("6er1G");

var $3RNvl = parcelRequire("3RNvl");
const $c7eb2edbd0da17eb$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $6er1G.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $6er1G.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await (0, $3RNvl.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $c7eb2edbd0da17eb$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $c7eb2edbd0da17eb$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("3RNvl", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $97f1f30fce1d64a9$export$8a48286ed7df6720);

var $4HMm0 = parcelRequire("4HMm0");
const $97f1f30fce1d64a9$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $4HMm0.default)[themeId]();
    return themeCss;
};

});
parcelRegister("4HMm0", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cdde0d40034b646$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









const $2cdde0d40034b646$var$themeImportsMap = {
    'light': ()=>(parcelRequire("9FHj6")),
    'light-future': ()=>(parcelRequire("22B1x")),
    'light-increased-contrast': ()=>(parcelRequire("g2tUA")),
    'dark': ()=>(parcelRequire("f6sUE")),
    'dark-future': ()=>(parcelRequire("1pJSB")),
    'dark-increased-contrast': ()=>(parcelRequire("cWAAT")),
    'spacing': ()=>(parcelRequire("1JGE5")),
    'typography': ()=>(parcelRequire("5S1jQ")),
    'shape': ()=>(parcelRequire("3pndA")),
    'motion': ()=>(parcelRequire("gf5Nb"))
};
var $2cdde0d40034b646$export$2e2bcd8739ae039 = $2cdde0d40034b646$var$themeImportsMap;

});
parcelRegister("9FHj6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gxkzP").then(()=>parcelRequire('86yda'));

});
parcelRegister("4cvLQ", function(module, exports) {
"use strict";

function $30f0ed6275c09e08$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("96thM")).resolve(id));
}
module.exports = $30f0ed6275c09e08$var$load;

});
parcelRegister("96thM", function(module, exports) {
$parcel$export(module.exports, "register", () => $6a0b641ff72a0641$export$6503ec6e8aabbaf, (v) => $6a0b641ff72a0641$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $6a0b641ff72a0641$export$f7ad0328861e2f03, (v) => $6a0b641ff72a0641$export$f7ad0328861e2f03 = v);
var $6a0b641ff72a0641$export$6503ec6e8aabbaf;
var $6a0b641ff72a0641$export$f7ad0328861e2f03;
"use strict";
var $6a0b641ff72a0641$var$mapping = new Map();
function $6a0b641ff72a0641$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6a0b641ff72a0641$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6a0b641ff72a0641$var$resolve(id) {
    var resolved = $6a0b641ff72a0641$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6a0b641ff72a0641$export$6503ec6e8aabbaf = $6a0b641ff72a0641$var$register;
$6a0b641ff72a0641$export$f7ad0328861e2f03 = $6a0b641ff72a0641$var$resolve;

});



parcelRegister("22B1x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1iA27").then(()=>parcelRequire('ias3B'));

});

parcelRegister("g2tUA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("g6cbr").then(()=>parcelRequire('bFDb8'));

});

parcelRegister("f6sUE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2R8PN").then(()=>parcelRequire('5tgod'));

});

parcelRegister("1pJSB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9kTLs").then(()=>parcelRequire('6ekRU'));

});

parcelRegister("cWAAT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4kpWq").then(()=>parcelRequire('9ybgn'));

});

parcelRegister("1JGE5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("23mVD").then(()=>parcelRequire('5WofZ'));

});

parcelRegister("5S1jQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cbJQk").then(()=>parcelRequire('8MR3P'));

});

parcelRegister("3pndA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bRpga").then(()=>parcelRequire('gh0R9'));

});

parcelRegister("gf5Nb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gY0Bm").then(()=>parcelRequire('jw0DO'));

});





parcelRegister("7nY6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57ce0224d1b5ff2$export$2e2bcd8739ae039);

var $glbdM = parcelRequire("glbdM");

var $6er1G = parcelRequire("6er1G");

var $cDku3 = parcelRequire("cDku3");
const $a57ce0224d1b5ff2$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $a57ce0224d1b5ff2$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $6er1G.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $a57ce0224d1b5ff2$var$contrastModeMql = $a57ce0224d1b5ff2$var$isMatchMediaAvailable && window.matchMedia((0, $cDku3.moreContrastMediaQuery));
class $a57ce0224d1b5ff2$var$ContrastModeObserver {
    getContrastMode() {
        if (!$a57ce0224d1b5ff2$var$contrastModeMql) return 'no-preference';
        return $a57ce0224d1b5ff2$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($a57ce0224d1b5ff2$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $glbdM.bind)($a57ce0224d1b5ff2$var$contrastModeMql, {
            type: 'change',
            listener: $a57ce0224d1b5ff2$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
$a57ce0224d1b5ff2$var$ContrastModeObserver.displayName = "ContrastModeObserver";
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $a57ce0224d1b5ff2$var$SingletonContrastModeObserver = new $a57ce0224d1b5ff2$var$ContrastModeObserver();
var $a57ce0224d1b5ff2$export$2e2bcd8739ae039 = $a57ce0224d1b5ff2$var$SingletonContrastModeObserver;

});


parcelRegister("guVzD", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $ac119e3a72a670ca$export$bd1ac9300b0e885a);

var $6er1G = parcelRequire("6er1G");

var $3PnK8 = parcelRequire("3PnK8");
function $ac119e3a72a670ca$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $3PnK8.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $6er1G.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $6er1G.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("9iI4H", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $21edc07cfce7f511$export$5d76d7014f4a5d08);
const $21edc07cfce7f511$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});

parcelRegister("bdbur", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $a09da5cd29001462$export$dd6aeb7c823fc03d);

var $iqfTZ = parcelRequire("iqfTZ");

var $5arrt = parcelRequire("5arrt");

const $a09da5cd29001462$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $iqfTZ.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $5arrt.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $iqfTZ.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $5arrt.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});
parcelRegister("5arrt", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c8ea78b7d1c1641$export$2e2bcd8739ae039);

var $aDhdf = parcelRequire("aDhdf");
function $5c8ea78b7d1c1641$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $aDhdf.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});
parcelRegister("aDhdf", function(module, exports) {
$parcel$export(module.exports, "themeIdsWithOverrides", () => $3a5f0de669648966$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $3a5f0de669648966$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $aUuHv = parcelRequire("aUuHv");


var $98Ebb = parcelRequire("98Ebb");
/**
 * Contrast preferences: The system contrast preference
 */ const $3a5f0de669648966$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $3a5f0de669648966$var$themeOverrideIds = [];
const $3a5f0de669648966$export$92ba366331403db2 = [
    ...(0, $aUuHv.themeIds),
    ...$3a5f0de669648966$var$themeOverrideIds
];
const $3a5f0de669648966$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3a5f0de669648966$export$2e2bcd8739ae039 = $3a5f0de669648966$var$themeConfig;

});



parcelRegister("1BPNn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("bSjqE")
]).then(()=>parcelRequire('dyQWV'));

});


parcelRegister("eF8Qg", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $8eb1e6a50ed65a45$export$a782702263f77544);

var $euxye = parcelRequire("euxye");

var $kfYCc = parcelRequire("kfYCc");
const $8eb1e6a50ed65a45$export$a782702263f77544 = ()=>{
    return (0, $euxye.useContext)((0, $kfYCc.AppProviderThemingEnabledContext));
};

});
parcelRegister("kfYCc", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $25e0289e79e3b90e$export$d2def9838ca456c0);

var $euxye = parcelRequire("euxye");
const $25e0289e79e3b90e$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("8DDUN", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $b112408d5a1f0c59$export$26aa23367bfbab0e);

var $euxye = parcelRequire("euxye");

var $6m9Nx = parcelRequire("6m9Nx");
const $b112408d5a1f0c59$export$26aa23367bfbab0e = ()=>{
    return (0, $euxye.useContext)((0, $6m9Nx.InsideAppProviderContext));
};

});
parcelRegister("6m9Nx", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $7416b8358b6700b5$export$7981b2444296e410);

var $euxye = parcelRequire("euxye");
const $7416b8358b6700b5$export$7981b2444296e410 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("lUsrP", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $6ce555aef1631061$export$49ddd74a6729fdb0);

var $euxye = parcelRequire("euxye");
const $6ce555aef1631061$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("8Fg0Q", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $84d9ba249f6abec1$export$332347eeb335453c);

var $euxye = parcelRequire("euxye");
const $84d9ba249f6abec1$export$332347eeb335453c = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("gctLG", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $13d36a8a51f105ef$export$b06130bad0bbc70f);

var $euxye = parcelRequire("euxye");
const $13d36a8a51f105ef$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("aOg1t", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $80b7fa023d242bf8$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $80b7fa023d242bf8$export$f7a97b47760e2a13);

var $euxye = parcelRequire("euxye");
const $80b7fa023d242bf8$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $80b7fa023d242bf8$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("3TXt5", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $054e590467a72d52$export$7ca11437599d653d);

var $euxye = parcelRequire("euxye");

var $8Fg0Q = parcelRequire("8Fg0Q");
const $054e590467a72d52$export$7ca11437599d653d = ()=>{
    return (0, $euxye.useContext)((0, $8Fg0Q.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("3bTna", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $af57bc68a5bbb862$export$7d4a7e812d176b24);

var $eIbOZ = parcelRequire("eIbOZ");

var $4HMm0 = parcelRequire("4HMm0");

var $axyvZ = parcelRequire("axyvZ");
const $af57bc68a5bbb862$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $axyvZ.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $4HMm0.default)[themeId]();
    return themeCss;
};
const $af57bc68a5bbb862$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $eIbOZ.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $axyvZ.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $af57bc68a5bbb862$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $af57bc68a5bbb862$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $af57bc68a5bbb862$var$mountThemeCss(themeCss, themeId);
};
const $af57bc68a5bbb862$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($af57bc68a5bbb862$var$loadAndMountThemeCss);
};

});
parcelRegister("axyvZ", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $8785760c0d9dc389$export$835a0dc855d02822);

var $eIbOZ = parcelRequire("eIbOZ");

var $6er1G = parcelRequire("6er1G");
function $8785760c0d9dc389$export$835a0dc855d02822(themeId) {
    const doc = (0, $eIbOZ.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $6er1G.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("bV5W6", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $4ca47176359d8912$export$20f3076712c8dfa);

var $euxye = parcelRequire("euxye");

var $3CpXJ = parcelRequire("3CpXJ");

var $izxUu = parcelRequire("izxUu");

var $lUsrP = parcelRequire("lUsrP");
function $4ca47176359d8912$export$20f3076712c8dfa() {
    const value = (0, $euxye.useContext)((0, $lUsrP.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $3CpXJ.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $euxye.useState)(theme?.colorMode || 'light');
    (0, $euxye.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $izxUu.default)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("izxUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $18149496c507282b$export$2e2bcd8739ae039);

var $6er1G = parcelRequire("6er1G");

var $3CpXJ = parcelRequire("3CpXJ");
class $18149496c507282b$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $18149496c507282b$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$18149496c507282b$export$2e2bcd8739ae039.observer) {
            $18149496c507282b$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $3CpXJ.default)();
                $18149496c507282b$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $18149496c507282b$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $6er1G.THEME_DATA_ATTRIBUTE),
                    (0, $6er1G.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $18149496c507282b$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($18149496c507282b$export$2e2bcd8739ae039.callbacks.size === 0 && $18149496c507282b$export$2e2bcd8739ae039.observer) {
            $18149496c507282b$export$2e2bcd8739ae039.observer.disconnect();
            $18149496c507282b$export$2e2bcd8739ae039.observer = null;
        }
    }
}
$18149496c507282b$export$2e2bcd8739ae039.displayName = "ThemeMutationObserver";

});


parcelRegister("4jpym", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $dd25f2bf52cd8df3$export$c582005add11e141);


var $72OT3 = parcelRequire("72OT3");
const $dd25f2bf52cd8df3$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $f12a3c5938f2e39b$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $f12a3c5938f2e39b$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $72OT3.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $dd25f2bf52cd8df3$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $dd25f2bf52cd8df3$var$getPortalParent().appendChild(container);
};

});
const $f12a3c5938f2e39b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $f12a3c5938f2e39b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $f12a3c5938f2e39b$export$13f57c02915787b3 = 'atlaskit-portal';

parcelRegister("72OT3", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $190cf18c6c159007$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $190cf18c6c159007$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("fOi0s", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $a052cdd07c731ab4$export$26ae5ca175b4ec5a);

const $a052cdd07c731ab4$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $f12a3c5938f2e39b$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("5k4kh", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $85c828e91d630897$export$da99f98bf3fe55b3);


var $72OT3 = parcelRequire("72OT3");
const $85c828e91d630897$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $f12a3c5938f2e39b$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $f12a3c5938f2e39b$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $72OT3.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $85c828e91d630897$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $85c828e91d630897$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("fkqbw", function(module, exports) {
$parcel$export(module.exports, "default", () => $00552d683e1a295a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $9fViR = parcelRequire("9fViR");
var $bV5W6 = parcelRequire("bV5W6");

var $3TXt5 = parcelRequire("3TXt5");

var $iqfTZ = parcelRequire("iqfTZ");

var $d2T3M = parcelRequire("d2T3M");

var $e7Ygq = parcelRequire("e7Ygq");

var $4gxci = parcelRequire("4gxci");

var $lpq24 = parcelRequire("lpq24");
function $00552d683e1a295a$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $euxye.useState)(null);
    const colorMode = (0, $bV5W6.useColorMode)();
    const isInsideThemeProvider = (0, $3TXt5.useIsInsideThemeProvider)();
    (0, $d2T3M.useIsomorphicLayoutEffect)(()=>{
        if ((0, $iqfTZ.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                let tempPortalContainer = (0, $e7Ygq.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                const portalParent = (0, $4gxci.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return ()=>{
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $lpq24.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            const tempPortalContainer = (0, $e7Ygq.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer);
            const portalParent = (0, $4gxci.createPortalParent)();
            if (!tempPortalContainer || !portalParent) return;
            portalParent.appendChild(tempPortalContainer);
            return ()=>{
                if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $iqfTZ.fg)
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
        fallback: null,
        children: isInsideThemeProvider ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9fViR.ThemeProvider), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $85XPu.createPortal)(suspendedChildren, atlaskitPortal) : null;
}
$00552d683e1a295a$export$2e2bcd8739ae039.displayName = "InternalPortalNew";

});
parcelRegister("d2T3M", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $bc2fcf95b0b5871c$export$700979bc83e7db82);

var $euxye = parcelRequire("euxye");
const $bc2fcf95b0b5871c$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $euxye.useLayoutEffect) : (0, $euxye.useEffect);

});

parcelRegister("e7Ygq", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $4a7949cbae4d29b2$export$fef014d7cef9e543);

const $4a7949cbae4d29b2$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $4a7949cbae4d29b2$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($4a7949cbae4d29b2$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $f12a3c5938f2e39b$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("4gxci", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $f623ecc9afb05a3e$export$95029ca7aca2989e);


var $72OT3 = parcelRequire("72OT3");
const $f623ecc9afb05a3e$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $f623ecc9afb05a3e$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($f623ecc9afb05a3e$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $f12a3c5938f2e39b$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $f12a3c5938f2e39b$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (0, $72OT3.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("lpq24", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", () => $03d5c23666013d8a$export$7b20876b2769b301);

var $72OT3 = parcelRequire("72OT3");
const $03d5c23666013d8a$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $03d5c23666013d8a$export$7b20876b2769b301 = (parentElement)=>{
    if ($03d5c23666013d8a$var$isDocumentDefined()) {
        if (parentElement) (0, $72OT3.getBody)()?.removeChild(parentElement);
    }
};

});


parcelRegister("Ounuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f2fa9ee149f8109$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $d2T3M = parcelRequire("d2T3M");
const $2f2fa9ee149f8109$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $euxye.useState)(false);
    const [useMountEffect] = (0, $euxye.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $d2T3M.useIsomorphicLayoutEffect) : (0, $euxye.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2f2fa9ee149f8109$export$2e2bcd8739ae039 = $2f2fa9ee149f8109$var$useIsSubsequentRender;

});

parcelRegister("ddmiE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0ddc5147ea21ea2$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");


var $B1Gym = parcelRequire("B1Gym");
const $b0ddc5147ea21ea2$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $euxye.useEffect)(()=>{
        (0, $B1Gym.default)((0, $607cd8ed0bd97f9c$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $B1Gym.default)((0, $607cd8ed0bd97f9c$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $b0ddc5147ea21ea2$export$2e2bcd8739ae039 = $b0ddc5147ea21ea2$var$useFirePortalEvent;

});
const $607cd8ed0bd97f9c$export$ed5835cc67e87f72 = 'akPortalMount';
const $607cd8ed0bd97f9c$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("B1Gym", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd405a3c167d881$export$2e2bcd8739ae039);
const $bcd405a3c167d881$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $bcd405a3c167d881$var$getLayerName = (zIndex)=>{
    return $bcd405a3c167d881$var$zIndexToName.hasOwnProperty(zIndex) ? $bcd405a3c167d881$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $bcd405a3c167d881$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $bcd405a3c167d881$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $bcd405a3c167d881$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $bcd405a3c167d881$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("2dZh0", function(module, exports) {
$parcel$export(module.exports, "register", () => $63d07c49666b3b48$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $glbdM = parcelRequire("glbdM");
const $63d07c49666b3b48$var$registrations = new Set();
let $63d07c49666b3b48$var$cleanupEndEventListeners = null;
function $63d07c49666b3b48$var$onDragStart() {
    if ($63d07c49666b3b48$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $63d07c49666b3b48$var$cleanupEndEventListeners = (0, $glbdM.bindAll)(window, [
        {
            type: 'dragend',
            listener: $63d07c49666b3b48$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $63d07c49666b3b48$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $63d07c49666b3b48$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($63d07c49666b3b48$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $63d07c49666b3b48$var$onDragEnd() {
    $63d07c49666b3b48$var$cleanupEndEventListeners?.();
    $63d07c49666b3b48$var$cleanupEndEventListeners = null;
    const clone = Array.from($63d07c49666b3b48$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $63d07c49666b3b48$var$bindStartEvents() {
    return (0, $glbdM.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $63d07c49666b3b48$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $63d07c49666b3b48$var$onDragStart
        }
    ]);
}
let $63d07c49666b3b48$var$cleanupStartEventListeners = null;
function $63d07c49666b3b48$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$63d07c49666b3b48$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $63d07c49666b3b48$var$cleanupStartEventListeners = $63d07c49666b3b48$var$bindStartEvents();
    $63d07c49666b3b48$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $63d07c49666b3b48$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $63d07c49666b3b48$var$registrations.delete(registration);
        if ($63d07c49666b3b48$var$registrations.size === 0) {
            $63d07c49666b3b48$var$cleanupStartEventListeners?.();
            $63d07c49666b3b48$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hqGhB", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $e55b9a96c27d5c78$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $e55b9a96c27d5c78$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $e55b9a96c27d5c78$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $e55b9a96c27d5c78$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $e55b9a96c27d5c78$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $e55b9a96c27d5c78$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("4OIN9", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $b1230d74e78da1a4$export$2e68479e0a5d8746);
function $b1230d74e78da1a4$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("khcLx", function(module, exports) {
$parcel$export(module.exports, "show", () => $139d67ab1696c7bd$export$57bf213be019eeb0);

var $iqfTZ = parcelRequire("iqfTZ");
let $139d67ab1696c7bd$var$delayId = null;
function $139d67ab1696c7bd$var$clearScheduled() {
    if ($139d67ab1696c7bd$var$delayId != null) {
        window.clearTimeout($139d67ab1696c7bd$var$delayId);
        $139d67ab1696c7bd$var$delayId = null;
    }
}
function $139d67ab1696c7bd$var$scheduleTimeout(fn, delay) {
    $139d67ab1696c7bd$var$clearScheduled();
    $139d67ab1696c7bd$var$delayId = window.setTimeout(()=>{
        $139d67ab1696c7bd$var$delayId = null;
        fn();
    }, delay);
}
let $139d67ab1696c7bd$var$active = null;
function $139d67ab1696c7bd$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($139d67ab1696c7bd$var$active && $139d67ab1696c7bd$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $139d67ab1696c7bd$var$clearScheduled();
            $139d67ab1696c7bd$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $139d67ab1696c7bd$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $139d67ab1696c7bd$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $iqfTZ.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $139d67ab1696c7bd$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($139d67ab1696c7bd$var$active && $139d67ab1696c7bd$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($139d67ab1696c7bd$var$active) {
            $139d67ab1696c7bd$var$clearScheduled();
            $139d67ab1696c7bd$var$active.entry.hide({
                isImmediate: true
            });
            $139d67ab1696c7bd$var$active.entry.done();
            $139d67ab1696c7bd$var$active = null;
        }
        // this tooltip is now the active tooltip
        $139d67ab1696c7bd$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $139d67ab1696c7bd$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("gznsT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d5e016596f3b11$export$2e2bcd8739ae039);

var $3Sbar = parcelRequire("3Sbar");
function $b1d5e016596f3b11$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $3Sbar.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("3Sbar", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $c30fd5f934ffa9ac$export$6ee17796e3d70de2);

var $gUxVT = parcelRequire("gUxVT");
function $c30fd5f934ffa9ac$export$6ee17796e3d70de2() {
    const uid = (0, $gUxVT.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("1FucB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d14812ebab94361$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8qjTI = parcelRequire("8qjTI");
const $6d14812ebab94361$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $6d14812ebab94361$var$TooltipContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qjTI.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            $6d14812ebab94361$var$styles.base,
            truncate && $6d14812ebab94361$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$6d14812ebab94361$var$TooltipContainer.displayName = 'TooltipContainer';
var $6d14812ebab94361$export$2e2bcd8739ae039 = $6d14812ebab94361$var$TooltipContainer;

});
parcelRegister("8qjTI", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aa87629c446df64$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $7X1hK = parcelRequire("7X1hK");
const $6aa87629c446df64$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $6aa87629c446df64$var$TooltipPrimitive = /*#__PURE__*/ (0, $euxye.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role = 'tooltip' }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            role: role,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $4jQY2.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7X1hK.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$6aa87629c446df64$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $6aa87629c446df64$export$2e2bcd8739ae039 = $6aa87629c446df64$var$TooltipPrimitive;

});
parcelRegister("7X1hK", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $bde74996a50fd44b$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $bde74996a50fd44b$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $bde74996a50fd44b$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $bde74996a50fd44b$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)("kbd", {
                className: (0, $4jQY2.default)([
                    $bde74996a50fd44b$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};
$bde74996a50fd44b$export$5bcbc43c84236222.displayName = "TooltipShortcut";

});




parcelRegister("lTw6o", function(module, exports) {
$parcel$export(module.exports, "default", () => $11306a620cbe4224$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $4jiTv = parcelRequire("4jiTv");

var $gUxVT = parcelRequire("gUxVT");

var $iqfTZ = parcelRequire("iqfTZ");

var $6mEZn = parcelRequire("6mEZn");

var $apUrw = parcelRequire("apUrw");

var $1WOZN = parcelRequire("1WOZN");

var $gd2Ko = parcelRequire("gd2Ko");

var $6oc9v = parcelRequire("6oc9v");

var $d5WY2 = parcelRequire("d5WY2");
const $11306a620cbe4224$var$LOADING_LABEL = ', Loading';
const $11306a620cbe4224$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $11306a620cbe4224$var$defaultStyles = {
    root: "_bfhk1w7a _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $11306a620cbe4224$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $11306a620cbe4224$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $11306a620cbe4224$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $11306a620cbe4224$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $11306a620cbe4224$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $11306a620cbe4224$var$subtleStyles = {
    root: "_bfhk1w7a _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk18uv _8l3mbk0g _irr318uv _1di618uv"
};
const $11306a620cbe4224$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $11306a620cbe4224$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $euxye.useRef)(null);
    const splitButtonContext = (0, $gd2Ko.useSplitButtonContext)();
    const loadingLabelId = (0, $gUxVT.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $4jiTv.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $ljVHR.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1MNmN.cx)($11306a620cbe4224$var$styles.base, (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && $11306a620cbe4224$var$styles.baseT26Shape, isInteractive && (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $11306a620cbe4224$var$styles.interactiveMotion, appearance === 'default' && $11306a620cbe4224$var$defaultStyles.root, appearance === 'default' && isInteractive && $11306a620cbe4224$var$defaultStyles.interactive, appearance === 'primary' && $11306a620cbe4224$var$primaryStyles.root, appearance === 'primary' && isInteractive && $11306a620cbe4224$var$primaryStyles.interactive, appearance === 'rovo' && $11306a620cbe4224$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $11306a620cbe4224$var$rovoStyles.interactive, appearance === 'warning' && $11306a620cbe4224$var$warningStyles.root, appearance === 'warning' && isInteractive && $11306a620cbe4224$var$warningStyles.interactive, appearance === 'danger' && $11306a620cbe4224$var$dangerStyles.root, appearance === 'danger' && isInteractive && $11306a620cbe4224$var$dangerStyles.interactive, appearance === 'discovery' && $11306a620cbe4224$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $11306a620cbe4224$var$discoveryStyles.interactive, appearance === 'subtle' && $11306a620cbe4224$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $11306a620cbe4224$var$subtleStyles.interactive, $11306a620cbe4224$var$styles.linkDecorationUnset, isSelected && $11306a620cbe4224$var$selectedStyles.root, isSelected && isSplitButton && $11306a620cbe4224$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $11306a620cbe4224$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $11306a620cbe4224$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $11306a620cbe4224$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $11306a620cbe4224$var$selectedStyles.discovery, isDisabled && $11306a620cbe4224$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $11306a620cbe4224$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $11306a620cbe4224$var$defaultStyles.disabled, spacing === 'compact' && $11306a620cbe4224$var$styles.spacingCompact, spacing === 'compact' && (0, $iqfTZ.fg)('platform-dst-shape-theme-default') && $11306a620cbe4224$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $11306a620cbe4224$var$styles.circle, shouldFitContainer && $11306a620cbe4224$var$styles.fullWidth, hasIconBefore && $11306a620cbe4224$var$styles.buttonIconBefore, hasIconAfter && $11306a620cbe4224$var$styles.buttonIconAfter, isIconButton && $11306a620cbe4224$var$styles.iconButton, isIconButton && spacing === 'compact' && $11306a620cbe4224$var$styles.iconButtonCompact, isLoading && $11306a620cbe4224$var$styles.loading, isSplitButton && $11306a620cbe4224$var$styles.splitButton, isNavigationSplitButton && $11306a620cbe4224$var$styles.navigationSplitButton),
        isDisabled: (0, $iqfTZ.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $iqfTZ.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $iqfTZ.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$11306a620cbe4224$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $6oc9v.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $1WOZN.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    className: (0, $4jQY2.default)([
                        $11306a620cbe4224$var$styles.loadingOverlay
                    ]),
                    children: (0, $d5WY2.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                    id: loadingLabelId,
                    children: $11306a620cbe4224$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $11306a620cbe4224$export$2e2bcd8739ae039 = $11306a620cbe4224$var$ButtonBase;

});
parcelRegister("6mEZn", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $cf5ab76918646675$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $aZBDA = parcelRequire("aZBDA");

var $bWvjc = parcelRequire("bWvjc");

var $2oRWW = parcelRequire("2oRWW");

var $Cs8MU = parcelRequire("Cs8MU");

var $9vMEI = parcelRequire("9vMEI");
const $cf5ab76918646675$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $cf5ab76918646675$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $2oRWW.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9vMEI.Focusable // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button",
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $bWvjc.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $9S1b6.cx)($cf5ab76918646675$var$styles.root, isDisabled && $cf5ab76918646675$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("bWvjc", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $6082a61381e8eb31$export$95df08bae54cb4df);
function $6082a61381e8eb31$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("9vMEI", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $4b56e622a06e63b1$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $4b56e622a06e63b1$var$focusRingStyles = null;
const $4b56e622a06e63b1$var$insetFocusRingStyles = null;
const $4b56e622a06e63b1$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $4jQY2.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("1WOZN", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $2bb5aae94fbc8a1a$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");
const $2bb5aae94fbc8a1a$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("gd2Ko", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $bc5c90d2c6b48ace$export$47e2c6fdb142d947);

var $euxye = parcelRequire("euxye");

var $1WOZN = parcelRequire("1WOZN");
const $bc5c90d2c6b48ace$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $euxye.useContext)((0, $1WOZN.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("6oc9v", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc5f7b5be0d8e3ea$export$2e2bcd8739ae039);
function $dc5f7b5be0d8e3ea$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $dc5f7b5be0d8e3ea$var$tabKeyCode = 9;
function $dc5f7b5be0d8e3ea$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $dc5f7b5be0d8e3ea$var$tabKeyCode) return;
    $dc5f7b5be0d8e3ea$var$abort(event);
}
function $dc5f7b5be0d8e3ea$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $dc5f7b5be0d8e3ea$var$abort,
        onMouseUpCapture: $dc5f7b5be0d8e3ea$var$abort,
        onKeyDownCapture: $dc5f7b5be0d8e3ea$var$onKey,
        onKeyUpCapture: $dc5f7b5be0d8e3ea$var$onKey,
        onTouchStartCapture: $dc5f7b5be0d8e3ea$var$abort,
        onTouchEndCapture: $dc5f7b5be0d8e3ea$var$abort,
        onPointerDownCapture: $dc5f7b5be0d8e3ea$var$abort,
        onPointerUpCapture: $dc5f7b5be0d8e3ea$var$abort,
        onClickCapture: $dc5f7b5be0d8e3ea$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $dc5f7b5be0d8e3ea$var$abort
    } : events;
}

});

parcelRegister("d5WY2", function(module, exports) {
$parcel$export(module.exports, "default", () => $50b140d6b5421080$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $abhF2 = parcelRequire("abhF2");
function $50b140d6b5421080$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $50b140d6b5421080$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $50b140d6b5421080$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
        size: $50b140d6b5421080$var$getIconSpacing(spacing),
        appearance: $50b140d6b5421080$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("9Yy3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $0227daf791419ac6$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");
const $0227daf791419ac6$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $0227daf791419ac6$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $0227daf791419ac6$var$styles.common,
            type === 'text' && $0227daf791419ac6$var$styles.text,
            type === 'icon' && $0227daf791419ac6$var$styles.icon,
            isLoading && $0227daf791419ac6$var$styles.fade
        ]),
        children: children
    });
};
$0227daf791419ac6$var$Content.displayName = "Content";
var $0227daf791419ac6$export$2e2bcd8739ae039 = $0227daf791419ac6$var$Content;

});

parcelRegister("fYjvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $74d92b619489009d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");
function $74d92b619489009d$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $74d92b619489009d$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $74d92b619489009d$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iqfTZ.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
            ...iconProps
        })
    });
};
$74d92b619489009d$var$IconRenderer.displayName = "IconRenderer";
var $74d92b619489009d$export$2e2bcd8739ae039 = $74d92b619489009d$var$IconRenderer;

});



parcelRegister("jjk9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $a09e43a02a945a05$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8L2z6 = parcelRequire("8L2z6");
var $eCdE8 = parcelRequire("eCdE8");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
const $a09e43a02a945a05$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $a09e43a02a945a05$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $a09e43a02a945a05$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
                children: (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                        xcss: $a09e43a02a945a05$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.Stack), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
$a09e43a02a945a05$var$Expander.displayName = "Expander";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a09e43a02a945a05$export$2e2bcd8739ae039 = $a09e43a02a945a05$var$Expander;

});

parcelRegister("6QQ0s", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $ff99aabba992eb00$export$e91ea202abb66350);

var $euxye = parcelRequire("euxye");

var $fBAnD = parcelRequire("fBAnD");
function $ff99aabba992eb00$export$e91ea202abb66350() {
    return (0, $euxye.useContext)((0, $fBAnD.FlagGroupContext));
}

});
parcelRegister("fBAnD", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $619029a659d92824$export$c57ba665aaa722be);

var $euxye = parcelRequire("euxye");

var $9jLSB = parcelRequire("9jLSB");
const $619029a659d92824$export$c57ba665aaa722be = /*#__PURE__*/ (0, $euxye.createContext)((0, $9jLSB.defaultFlagGroupContext));

});
parcelRegister("9jLSB", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $4de165b68c1c3bc0$export$643760c4938da30d);

var $2oRWW = parcelRequire("2oRWW");
const $4de165b68c1c3bc0$export$643760c4938da30d = {
    onDismissed: (0, $2oRWW.default),
    isDismissAllowed: false
};

});




parcelRegister("63XI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8b4a01a5b66d491$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");

var $f1Spj = parcelRequire("f1Spj");

var $6QQ0s = parcelRequire("6QQ0s");
const $d8b4a01a5b66d491$var$packageName = "platform-pkg";
const $d8b4a01a5b66d491$var$packageVersion = "0.0.0-use.local";
const $d8b4a01a5b66d491$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $d8b4a01a5b66d491$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $2oRWW.default), autoDismissSeconds: autoDismissSeconds = $d8b4a01a5b66d491$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $euxye.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6QQ0s.useFlagGroup)();
    const onDismissed = (0, $euxye.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $d8b4a01a5b66d491$var$packageName,
        packageVersion: $d8b4a01a5b66d491$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $euxye.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $euxye.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $euxye.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $euxye.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f1Spj.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
$d8b4a01a5b66d491$var$AutoDismissFlag.displayName = "AutoDismissFlag";
var $d8b4a01a5b66d491$export$2e2bcd8739ae039 = $d8b4a01a5b66d491$var$AutoDismissFlag;

});

parcelRegister("8RTvC", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $f728e55d25595804$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $f728e55d25595804$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $inMxE = parcelRequire("inMxE");

var $eIbOZ = parcelRequire("eIbOZ");

var $1MNmN = parcelRequire("1MNmN");

var $2oRWW = parcelRequire("2oRWW");

var $8L2z6 = parcelRequire("8L2z6");
var $p9mZs = parcelRequire("p9mZs");
var $5kyyj = parcelRequire("5kyyj");

var $iqfTZ = parcelRequire("iqfTZ");

var $5PG2M = parcelRequire("5PG2M");

var $ihEDU = parcelRequire("ihEDU");

var $akMu8 = parcelRequire("akMu8");

var $Yce2Z = parcelRequire("Yce2Z");

var $apUrw = parcelRequire("apUrw");

var $9jLSB = parcelRequire("9jLSB");

var $fBAnD = parcelRequire("fBAnD");


// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $f728e55d25595804$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $f728e55d25595804$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $f728e55d25595804$var$dismissAllowedStyles = null;
const $f728e55d25595804$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $f728e55d25595804$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $f728e55d25595804$var$flagGroupContainerStylesSymmetric = null;
const $f728e55d25595804$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $2oRWW.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $euxye.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const latestRef = (0, $euxye.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $euxye.useEffect)(()=>{
        if (!(0, $iqfTZ.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $eIbOZ.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $glbdM.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = firstFlag.props?.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    latestRef.current.onDismissed?.(id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $euxye.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $iqfTZ.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                xcss: (0, $1MNmN.cx)($f728e55d25595804$var$groupStylesNew.root, index === 0 && $f728e55d25595804$var$groupStylesNew.first, index === 1 && $f728e55d25595804$var$groupStylesNew.second, index >= 2 && $f728e55d25595804$var$groupStylesNew.nth, index >= 3 && $f728e55d25595804$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fBAnD.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $9jLSB.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5kyyj.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $4jQY2.default)([
                            $f728e55d25595804$var$groupStyles.root,
                            index === 0 && $f728e55d25595804$var$groupStyles.first,
                            index === 1 && $f728e55d25595804$var$groupStyles.second,
                            index >= 1 && $f728e55d25595804$var$groupStyles.nth,
                            index >= 2 && $f728e55d25595804$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fBAnD.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $9jLSB.defaultFlagGroupContext),
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const useTopLayer = (0, $iqfTZ.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, $iqfTZ.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $iqfTZ.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $4jQY2.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    if (useTopLayer) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
        mode: "manual",
        isOpen: true,
        children: flags
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
        zIndex: (0, $akMu8.layers).flag(),
        children: flags
    });
};
$f728e55d25595804$export$a2c3479950310d7d.displayName = "FlagGroup";
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$f728e55d25595804$export$2e2bcd8739ae039 = $f728e55d25595804$export$a2c3479950310d7d;

});
parcelRegister("p9mZs", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3e1214d52a845f4$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $iqfTZ = parcelRequire("iqfTZ");

var $3uloN = parcelRequire("3uloN");

var $ffmX5 = parcelRequire("ffmX5");

var $bG844 = parcelRequire("bG844");

var $a5cVp = parcelRequire("a5cVp");

var $8L2z6 = parcelRequire("8L2z6");

var $2ZIVA = parcelRequire("2ZIVA");

var $lmGdq = parcelRequire("lmGdq");

var $fp8lq = parcelRequire("fp8lq");
const $b3e1214d52a845f4$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $b3e1214d52a845f4$var$MotionLegacy = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $lmGdq.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8L2z6.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $euxye.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $euxye.useRef)(null);
    const reanimateRef = (0, $euxye.useRef)();
    const animationRef = (0, $euxye.useRef)();
    const staggeredEntryRef = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, $euxye.useEffect)(()=>{
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    const onAnimationEnd = (0, $euxye.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (state === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $2ZIVA.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $2ZIVA.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $euxye.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $bG844.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $ffmX5.getDurationMs)((0, $a5cVp.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    if (styles.animationDuration) animationDuration = (0, $3uloN.convertToMs)(styles.animationDuration);
                    if (styles.animationDelay) animationDelay = (0, $3uloN.convertToMs)(styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $euxye.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $2ZIVA.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $2ZIVA.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $4jQY2.default)([
            hasAnimationStyles && $b3e1214d52a845f4$var$styles.base,
            state === 'init' && $b3e1214d52a845f4$var$styles.hidden,
            (0, $1MNmN.cx)(xcss, customAnimation)
        ]),
        ref: (0, $ljVHR.default)([
            staggered.ref,
            elementRef
        ]),
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId,
        children: children
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $b3e1214d52a845f4$var$MotionNext = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $fp8lq.useMotion)({
        onFinish: onFinishMotion
    });
    (0, $euxye.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]); // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $4jQY2.default)([
            state === 'init' && $b3e1214d52a845f4$var$styles.hidden,
            (0, $1MNmN.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...styleProp,
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        },
        "data-testid": testId,
        children: children
    });
}); /**
     * __Motion__
     *
     * A motion primitive that can be used to animate the entry and exit of components.
     */ 
const $b3e1214d52a845f4$var$Motion = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    if ((0, $iqfTZ.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $e79Pd.jsx)($b3e1214d52a845f4$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($b3e1214d52a845f4$var$MotionLegacy, {
        ...props,
        ref: ref
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $b3e1214d52a845f4$export$2e2bcd8739ae039 = $b3e1214d52a845f4$var$Motion;

});
parcelRegister("3uloN", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $9f98c90346438974$export$75eee42ff540d8ae);
const $9f98c90346438974$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});

parcelRegister("ffmX5", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $5d91183747bcd07c$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $5d91183747bcd07c$export$d0038b6e47881463 = (animation)=>{
    const match = [
        ...animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
    ];
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    const durationValue = parseFloat(match[0][1]);
    const durationUnit = match[0][2];
    const duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    let delay = 0;
    if (match[1]) {
        const delayValue = parseFloat(match[1][1]);
        const delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};

});

parcelRegister("a5cVp", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $1710276661ea9993$export$82b92541889a035d);

var $eIbOZ = parcelRequire("eIbOZ");
const $1710276661ea9993$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $eIbOZ.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("2ZIVA", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $b8cf59c0623cdaee$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $b8cf59c0623cdaee$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("fp8lq", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $5e53c9be9cb80a18$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $3uloN = parcelRequire("3uloN");

var $ffmX5 = parcelRequire("ffmX5");

var $bG844 = parcelRequire("bG844");

var $a5cVp = parcelRequire("a5cVp");

var $8L2z6 = parcelRequire("8L2z6");

var $2ZIVA = parcelRequire("2ZIVA");

var $lmGdq = parcelRequire("lmGdq");
function $5e53c9be9cb80a18$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $bG844.isReducedMotion)();
    const staggered = (0, $lmGdq.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $8L2z6.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $euxye.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'));
    const elementRef = (0, $euxye.useRef)(null);
    const reanimateRef = (0, $euxye.useRef)();
    const animationRef = (0, $euxye.useRef)();
    const staggeredEntryRef = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $euxye.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (currentState === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $2ZIVA.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $2ZIVA.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $2ZIVA.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $2ZIVA.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $euxye.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $euxye.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $ffmX5.getDurationMs)((0, $a5cVp.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    if (computedStyles.animationDuration) animationDuration = (0, $3uloN.convertToMs)(computedStyles.animationDuration);
                    if (computedStyles.animationDelay) animationDelay = (0, $3uloN.convertToMs)(computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $euxye.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $2ZIVA.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $2ZIVA.Reanimate).enter) setState('entering');
        else if (value === (0, $2ZIVA.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $ljVHR.default)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}

});


parcelRegister("5kyyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $738b70ec41865cd6$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1g8lh = parcelRequire("1g8lh");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $738b70ec41865cd6$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1g8lh.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
$738b70ec41865cd6$var$SlideIn.displayName = "SlideIn";
var $738b70ec41865cd6$export$2e2bcd8739ae039 = $738b70ec41865cd6$var$SlideIn;

});


parcelRegister("cSvIR", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $c2270e1fcca9f1fc$export$a4270ab432ac8a58);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $63XI1 = parcelRequire("63XI1");

var $f1Spj = parcelRequire("f1Spj");

var $dpBiw = parcelRequire("dpBiw");

var $8RTvC = parcelRequire("8RTvC");
const $c2270e1fcca9f1fc$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c2270e1fcca9f1fc$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $euxye.useState)([]);
    const removeFlag = (0, $euxye.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $euxye.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c2270e1fcca9f1fc$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dpBiw.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $63XI1.default) : (0, $f1Spj.default);
                    return /*#__PURE__*/ (0, $euxye.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
$c2270e1fcca9f1fc$export$a4270ab432ac8a58.displayName = "FlagsProvider";

});
parcelRegister("dpBiw", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $e84c4419016e8130$export$2eb95677cf2465e1);

var $euxye = parcelRequire("euxye");
const $e84c4419016e8130$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext(null);

});


parcelRegister("32hW2", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $b0c885621da50eb9$export$2879604e6aec4ab);

var $euxye = parcelRequire("euxye");

var $dpBiw = parcelRequire("dpBiw");
function $b0c885621da50eb9$export$2879604e6aec4ab() {
    const api = (0, $euxye.useContext)((0, $dpBiw.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});

parcelRegister("4pQjk", function(module, exports) {
$parcel$export(module.exports, "withFlagsProvider", () => $611dba44915822bf$export$7b676815c264eaf3);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $cSvIR = parcelRequire("cSvIR");
const $611dba44915822bf$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $cSvIR.FlagsProvider), {
        children: fn()
    });

});


parcelRegister("3MtiC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getTheme", () => (parcelRequire("5vgqb")).getTheme);
$parcel$export(module.exports, "default", () => (parcelRequire("csY6G")).default);
$parcel$export(module.exports, "createTheme", () => (parcelRequire("eCTjq")).createTheme);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ /**
 * @deprecated Use `import { getTheme } from '@atlaskit/theme/get-theme'` instead.
 */ 
var $5vgqb = parcelRequire("5vgqb");

var $csY6G = parcelRequire("csY6G");

var $eCTjq = parcelRequire("eCTjq");

});
parcelRegister("5vgqb", function(module, exports) {
$parcel$export(module.exports, "getTheme", () => $d9d3ec2c42fc4d9b$export$89cbf1a0881c8b9c);

var $6E45X = parcelRequire("6E45X");
function $d9d3ec2c42fc4d9b$export$89cbf1a0881c8b9c(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $6E45X.CHANNEL) in props.theme) return props.theme[0, $6E45X.CHANNEL];
        else if ('mode' in props.theme && (0, $6E45X.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $6E45X.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("6E45X", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $d40965feb05ede9d$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $d40965feb05ede9d$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $d40965feb05ede9d$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $d40965feb05ede9d$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $d40965feb05ede9d$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $d40965feb05ede9d$export$c93026a968943f95 = 'light';
const $d40965feb05ede9d$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $d40965feb05ede9d$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});


parcelRegister("csY6G", function(module, exports) {
$parcel$export(module.exports, "default", () => $6af9dfbfe0f0d135$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $eCTjq = parcelRequire("eCTjq");
// Create default global light theme
const $6af9dfbfe0f0d135$var$dest = (0, $eCTjq.createTheme)(()=>({
        mode: 'light'
    }));
const $6af9dfbfe0f0d135$var$Provider = $6af9dfbfe0f0d135$var$dest.Provider;
const $6af9dfbfe0f0d135$var$Consumer = $6af9dfbfe0f0d135$var$dest.Consumer;
const $6af9dfbfe0f0d135$export$7692396083754928 = $6af9dfbfe0f0d135$var$dest.useTheme;
const $6af9dfbfe0f0d135$var$Theme = {
    Provider: $6af9dfbfe0f0d135$var$Provider,
    Consumer: $6af9dfbfe0f0d135$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6af9dfbfe0f0d135$export$2e2bcd8739ae039 = $6af9dfbfe0f0d135$var$Theme;

});
parcelRegister("eCTjq", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $e54688ab22fb9a73$export$25d302a5b900a763);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $e54688ab22fb9a73$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $euxye.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $euxye.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $euxye.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $euxye.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});



parcelRegister("iqjLa", function(module, exports) {
$parcel$export(module.exports, "Popper", () => (parcelRequire("1DTca")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("cFt1H")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("aFVSm")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("hD6gn")).Reference);

var $cFt1H = parcelRequire("cFt1H");
var $1DTca = parcelRequire("1DTca");

var $aFVSm = parcelRequire("aFVSm");

var $hD6gn = parcelRequire("hD6gn");

});
parcelRegister("aFVSm", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $d35ad080dc623dae$export$d0d38e7dec7a1a61);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8vYl3 = parcelRequire("8vYl3");

var $aG9bG = parcelRequire("aG9bG");

var $a09uV = parcelRequire("a09uV");

var $kMZFG = parcelRequire("kMZFG");
function $d35ad080dc623dae$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $kMZFG.useAnchorState)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8vYl3.Manager), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $a09uV.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aG9bG.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}
$d35ad080dc623dae$export$d0d38e7dec7a1a61.displayName = "Manager";

});
parcelRegister("a09uV", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $2a18bbec1c6f59ea$export$804169e6eecdff16);

var $euxye = parcelRequire("euxye");
const $2a18bbec1c6f59ea$export$804169e6eecdff16 = /*#__PURE__*/ (0, $euxye.createContext)(()=>undefined);

});

parcelRegister("kMZFG", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $3b16a5aa69ca096d$export$1b1b50fdcd7ac375);

var $euxye = parcelRequire("euxye");
function $3b16a5aa69ca096d$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $euxye.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("hD6gn", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $b5ecd9b2ab7eab4c$export$e0be378c32fb70a7);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqmNT = parcelRequire("iqmNT");

var $ljVHR = parcelRequire("ljVHR");

var $d4Qyk = parcelRequire("d4Qyk");
function $b5ecd9b2ab7eab4c$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $d4Qyk.useManagerAnchorSetter)();
    const composedRef = (0, $euxye.useMemo)(()=>(0, $ljVHR.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iqmNT.Reference), {
        innerRef: composedRef,
        children: children
    });
}
$b5ecd9b2ab7eab4c$export$e0be378c32fb70a7.displayName = "Reference";

});
parcelRegister("iqmNT", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $d69c580e793c9dcd$export$e0be378c32fb70a7);

var $euxye = parcelRequire("euxye");

var $89doV = parcelRequire("89doV");

var $8vYl3 = parcelRequire("8vYl3");

var $bdIPt = parcelRequire("bdIPt");
function $d69c580e793c9dcd$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $euxye.useContext((0, $8vYl3.ManagerReferenceNodeSetterContext));
    var refHandler = $euxye.useCallback(function(node) {
        (0, $bdIPt.setRef)(innerRef, node);
        (0, $bdIPt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $euxye.useEffect(function() {
        return function() {
            return (0, $bdIPt.setRef)(innerRef, null);
        };
    }, []);
    $euxye.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($89doV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $bdIPt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("d4Qyk", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $8b84042d44749925$export$fcdda419d7091b3);

var $euxye = parcelRequire("euxye");

var $a09uV = parcelRequire("a09uV");
function $8b84042d44749925$export$fcdda419d7091b3() {
    return (0, $euxye.useContext)((0, $a09uV.AnchorSetterContext));
}

});



parcelRegister("kTviw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1162e46866fd67$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $8RC0i = parcelRequire("8RC0i");
const $9b1162e46866fd67$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $8RC0i.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $9b1162e46866fd67$export$2e2bcd8739ae039 = $9b1162e46866fd67$var$withAnalyticsEvents;

});
parcelRegister("8RC0i", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $8e053d6cfdc9a731$export$9ebb5a84d17e5d18);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");
function $8e053d6cfdc9a731$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const handlerCache = (0, $euxye.useRef)({});
    const patchedProps = (0, $euxye.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("codNI", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $020bdb661fe71c91$export$ae933c6cbe5643ad);

var $isn1z = parcelRequire("isn1z");
const $020bdb661fe71c91$export$ae933c6cbe5643ad = (0, $isn1z.HasTextAncestorContext).Provider;

});
parcelRegister("isn1z", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $8c05ba316c24db74$export$19538d0bfc69c6e0);

var $euxye = parcelRequire("euxye");
const $8c05ba316c24db74$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("ajmUh", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $0b7dc9ee0e74024d$export$9322276ec105d055);

var $euxye = parcelRequire("euxye");

var $isn1z = parcelRequire("isn1z");
const $0b7dc9ee0e74024d$export$9322276ec105d055 = ()=>(0, $euxye.useContext)((0, $isn1z.HasTextAncestorContext));

});

parcelRegister("a9o4s", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e9db9862a474ea9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");
function $8e9db9862a474ea9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8e9db9862a474ea9$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $8e9db9862a474ea9$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: $8e9db9862a474ea9$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), {
            key: idx
        }, child);
    }));
}
$8e9db9862a474ea9$export$2e2bcd8739ae039.displayName = "ButtonGroup";

});

parcelRegister("8Sdzy", function(module, exports) {
$parcel$export(module.exports, "Text", () => $fa12d181e6f2c769$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jiTLE = parcelRequire("jiTLE");

var $codNI = parcelRequire("codNI");

var $2Xrjb = parcelRequire("2Xrjb");

var $ajmUh = parcelRequire("ajmUh");
const $fa12d181e6f2c769$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $fa12d181e6f2c769$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $2Xrjb.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($fa12d181e6f2c769$var$inverseColorMap.hasOwnProperty(surface)) return $fa12d181e6f2c769$var$inverseColorMap[surface];
    return 'color.text';
};
const $fa12d181e6f2c769$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $fa12d181e6f2c769$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $fa12d181e6f2c769$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $fa12d181e6f2c769$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $fa12d181e6f2c769$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $fa12d181e6f2c769$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $jiTLE.default)($fa12d181e6f2c769$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $ajmUh.useHasTextAncestor)();
    const color = $fa12d181e6f2c769$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        id: id,
        className: (0, $4jQY2.default)([
            $fa12d181e6f2c769$var$styles.root,
            size && $fa12d181e6f2c769$var$fontSizeMap[size],
            color && $fa12d181e6f2c769$var$textColorMap[color],
            maxLines && $fa12d181e6f2c769$var$styles.truncation,
            maxLines === 1 && $fa12d181e6f2c769$var$styles.breakAll,
            align && $fa12d181e6f2c769$var$styles[`textAlign.${align}`],
            weight && $fa12d181e6f2c769$var$fontWeightMap[weight],
            Component === 'em' && $fa12d181e6f2c769$var$styles['as.em'],
            Component === 'strong' && $fa12d181e6f2c769$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $codNI.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});

parcelRegister("flpE4", function(module, exports) {
$parcel$export(module.exports, "default", () => $3233339a3c2818cd$export$2e2bcd8739ae039);
var $3233339a3c2818cd$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("kY2zM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d076bb01511aa30e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");
const $d076bb01511aa30e$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $euxye.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $euxye.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $d076bb01511aa30e$export$2e2bcd8739ae039 = $d076bb01511aa30e$var$withAnalyticsContext;

});

parcelRegister("fgfJr", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $07c61b2617d7714c$export$53c2b9c37c40e0d8);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $7v5Xl = parcelRequire("7v5Xl");
const $07c61b2617d7714c$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const methodRef = (0, $7v5Xl.useTrackedRef)(method);
    const payloadRef = (0, $7v5Xl.useTrackedRef)(payload);
    return (0, $euxye.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("4qNCE", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf81f66cf23c34b1$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $b3FBM = parcelRequire("b3FBM");

var $bCPR2 = parcelRequire("bCPR2");

var $jK1pi = parcelRequire("jK1pi");
const $cf81f66cf23c34b1$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $cf81f66cf23c34b1$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $2oRWW.default), onMouseUp: providedOnMouseUp = (0, $2oRWW.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $jK1pi.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $euxye.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $euxye.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($cf81f66cf23c34b1$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $euxye.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($cf81f66cf23c34b1$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $euxye.useMemo)(()=>(0, $bCPR2.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b3FBM.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$cf81f66cf23c34b1$var$Button.displayName = 'Button';
var $cf81f66cf23c34b1$export$2e2bcd8739ae039 = $cf81f66cf23c34b1$var$Button;

});

parcelRegister("1D4ep", function(module, exports) {
$parcel$export(module.exports, "default", () => $61584e822f34e055$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4qNCE = parcelRequire("4qNCE");

var $gIrl0 = parcelRequire("gIrl0");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $61584e822f34e055$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4qNCE.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gIrl0.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$61584e822f34e055$var$LoadingButton.displayName = 'LoadingButton';
var $61584e822f34e055$export$2e2bcd8739ae039 = $61584e822f34e055$var$LoadingButton;

});

parcelRegister("j26jU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5860770c0374423$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $2iotI = parcelRequire("2iotI");

var $ihEDU = parcelRequire("ihEDU");
var $8Sdzy = parcelRequire("8Sdzy");

var $abhF2 = parcelRequire("abhF2");

var $5KYFE = parcelRequire("5KYFE");

var $bwCC0 = parcelRequire("bwCC0");

var $aSkMi = parcelRequire("aSkMi");

var $SVR3A = parcelRequire("SVR3A");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $a5860770c0374423$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5KYFE.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $a9o4s.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $SVR3A.default), {
                children: isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $bwCC0.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aSkMi.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
$a5860770c0374423$var$EmptyState.displayName = "EmptyState";
var $a5860770c0374423$export$2e2bcd8739ae039 = $a5860770c0374423$var$EmptyState;

});
parcelRegister("5KYFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d2b3895ef642529$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $7d2b3895ef642529$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $7d2b3895ef642529$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
$7d2b3895ef642529$var$ActionsContainer.displayName = "ActionsContainer";
var $7d2b3895ef642529$export$2e2bcd8739ae039 = $7d2b3895ef642529$var$ActionsContainer;

});

parcelRegister("bwCC0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e9c93fc684da14e$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $3e9c93fc684da14e$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $3e9c93fc684da14e$var$wideContainerStyles = null;
const $3e9c93fc684da14e$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $3e9c93fc684da14e$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
$3e9c93fc684da14e$var$Container.displayName = "Container";
var $3e9c93fc684da14e$export$2e2bcd8739ae039 = $3e9c93fc684da14e$var$Container;

});

parcelRegister("aSkMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd1e976118adfb33$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $bd1e976118adfb33$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $bd1e976118adfb33$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $bd1e976118adfb33$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $bd1e976118adfb33$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        style: {
            [$bd1e976118adfb33$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$bd1e976118adfb33$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
$bd1e976118adfb33$var$Image.displayName = "Image";
var $bd1e976118adfb33$export$2e2bcd8739ae039 = $bd1e976118adfb33$var$Image;

});

parcelRegister("SVR3A", function(module, exports) {
$parcel$export(module.exports, "default", () => $77150373c8964029$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $77150373c8964029$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $77150373c8964029$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
$77150373c8964029$var$SpinnerContainer.displayName = "SpinnerContainer";
var $77150373c8964029$export$2e2bcd8739ae039 = $77150373c8964029$var$SpinnerContainer;

});


parcelRegister("lq8vU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2db35dbddda0ad9$export$2e2bcd8739ae039);

var $jW7qO = parcelRequire("jW7qO");
var $c2db35dbddda0ad9$export$2e2bcd8739ae039 = (0, $jW7qO.default);

});

parcelRegister("7P4NK", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $1690b06fe787194a$export$35f8383928ba8d7);
/// <reference types="node" />

var $9xulT = parcelRequire("9xulT");
const $1690b06fe787194a$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $9xulT.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';

});

parcelRegister("kkn6j", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEvent", () => (parcelRequire("bEzCm")).default);
$parcel$export(module.exports, "isAnalyticsEvent", () => (parcelRequire("fScF2")).isAnalyticsEvent);
$parcel$export(module.exports, "UIAnalyticsEvent", () => (parcelRequire("9xulT")).default);
$parcel$export(module.exports, "isUIAnalyticsEvent", () => (parcelRequire("7P4NK")).isUIAnalyticsEvent);
$parcel$export(module.exports, "AnalyticsListener", () => (parcelRequire("f6SzU")).default);
$parcel$export(module.exports, "AnalyticsContext", () => (parcelRequire("hUqPj")).default);
$parcel$export(module.exports, "withAnalyticsContext", () => (parcelRequire("kY2zM")).default);
$parcel$export(module.exports, "AnalyticsErrorBoundary", () => (parcelRequire("9i9im")).default);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("kTviw")).default);
$parcel$export(module.exports, "AnalyticsReactContext", () => (parcelRequire("lq8vU")).default);
$parcel$export(module.exports, "useAnalyticsEvents", () => (parcelRequire("inMxE")).useAnalyticsEvents);
$parcel$export(module.exports, "useCallbackWithAnalytics", () => (parcelRequire("fgfJr")).useCallbackWithAnalytics);
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => (parcelRequire("aZBDA")).usePlatformLeafEventHandler);
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => (parcelRequire("7iH0N")).usePlatformLeafSyntheticEventHandler);
$parcel$export(module.exports, "createAndFireEvent", () => (parcelRequire("flpE4")).default);
$parcel$export(module.exports, "cleanProps", () => (parcelRequire("dyaYg")).default);
$parcel$export(module.exports, "AnalyticsDecorator", () => (parcelRequire("fnQ06")).AnalyticsDecorator);
$parcel$export(module.exports, "AnalyticsDelegate", () => (parcelRequire("iARmn")).default);
$parcel$export(module.exports, "withAnalytics", () => (parcelRequire("6tNB1")).default);

var $bEzCm = parcelRequire("bEzCm");

var $fScF2 = parcelRequire("fScF2");

var $9xulT = parcelRequire("9xulT");

var $7P4NK = parcelRequire("7P4NK");

var $f6SzU = parcelRequire("f6SzU");

var $hUqPj = parcelRequire("hUqPj");

var $kY2zM = parcelRequire("kY2zM");

var $9i9im = parcelRequire("9i9im");

var $kTviw = parcelRequire("kTviw");

var $lq8vU = parcelRequire("lq8vU");

var $inMxE = parcelRequire("inMxE");

var $fgfJr = parcelRequire("fgfJr");

var $aZBDA = parcelRequire("aZBDA");

var $7iH0N = parcelRequire("7iH0N");

var $flpE4 = parcelRequire("flpE4");

var $dyaYg = parcelRequire("dyaYg");

var $fnQ06 = parcelRequire("fnQ06");

var $iARmn = parcelRequire("iARmn");

var $6tNB1 = parcelRequire("6tNB1");

});
parcelRegister("fScF2", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $6070a43038a87a35$export$ad4be5c2ec28cecf);

var $bEzCm = parcelRequire("bEzCm");
const $6070a43038a87a35$export$ad4be5c2ec28cecf = (obj)=>obj instanceof (0, $bEzCm.default) || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';

});

parcelRegister("9i9im", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e6e9475766d41cf$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $dwtyn = parcelRequire("dwtyn");

var $dgWJg = parcelRequire("dgWJg");

var $dH2m9 = parcelRequire("dH2m9");
class $6e6e9475766d41cf$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    constructor(props){
        super(props), // Gated by analytics-next-lock-context-type(-all-afm): keep the value captured at construction so a late gate flip can't swap the context type and remount the subtree.
        this.lockedIsModernContext = (0, $dwtyn.default) || (0, $iqfTZ.fg)('analytics-next-use-legacy-context') === false;
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        const isModernContext = (0, $iqfTZ.fg)('analytics-next-lock-context-type-all-afm') || (0, $iqfTZ.fg)('analytics-next-lock-context-type') ? this.lockedIsModernContext : (0, $dwtyn.default) || (0, $iqfTZ.fg)('analytics-next-use-legacy-context') === false;
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dH2m9.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(ErrorComponent, {})
                });
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dgWJg.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(ErrorComponent, {})
                });
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dH2m9.default), {
            data: data,
            children: children
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dgWJg.default), {
            data: data,
            children: children
        });
    }
}
$6e6e9475766d41cf$export$2e2bcd8739ae039.displayName = "AnalyticsErrorBoundary";

});

parcelRegister("dyaYg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c598b443f56410cb$export$2e2bcd8739ae039);
function $c598b443f56410cb$export$2e2bcd8739ae039(props) {
    const { createAnalyticsEvent: createAnalyticsEvent, ...cleanedProps } = props;
    return cleanedProps;
}

});

parcelRegister("fnQ06", function(module, exports) {
$parcel$export(module.exports, "AnalyticsDecorator", () => $fec11d1171fed606$export$29afdd4b31a211bd);

var $euxye = parcelRequire("euxye");

var $aUFjn = parcelRequire("aUFjn");

var $eMP7Q = parcelRequire("eMP7Q");
class $fec11d1171fed606$export$29afdd4b31a211bd extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            match: '*',
            matchPrivate: false
        };
    }
    static{
        this.contextTypes = (0, $eMP7Q.ContextTypes);
    }
    static{
        this.childContextTypes = (0, $eMP7Q.ContextTypes);
    }
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent,
            getParentAnalyticsData: this.getParentAnalyticsData
        };
    }
    render() {
        const { children: children } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.only(children);
    }
    constructor(...args){
        super(...args), this.getDecoratedAnalyticsData = (name, srcData, isPrivate)=>{
            const { data: data, getData: getData, match: match, matchPrivate: matchPrivate } = this.props;
            const decoratedData = {
                ...srcData
            };
            if (matchPrivate === isPrivate && (0, $aUFjn.default)(match, name)) {
                if (typeof data === 'object') Object.assign(decoratedData, data);
                if (typeof getData === 'function') Object.assign(decoratedData, getData(name, decoratedData));
            }
            return decoratedData;
        }, this.onAnalyticsEvent = (name, srcData, isPrivate)=>{
            const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent !== 'function') return;
            const decoratedData = this.getDecoratedAnalyticsData(name, srcData, isPrivate);
            onAnalyticsEvent(name, decoratedData, isPrivate);
        }, this.getParentAnalyticsData = (name, isPrivate)=>{
            const parentData = this.getDecoratedAnalyticsData(name, {}, isPrivate);
            const { getParentAnalyticsData: getParentAnalyticsData } = this.context;
            if (typeof getParentAnalyticsData === 'function') Object.assign(parentData, getParentAnalyticsData(name, isPrivate));
            return parentData;
        };
    }
}

});
parcelRegister("aUFjn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b541e5179eb96aca$export$2e2bcd8739ae039);
const $b541e5179eb96aca$var$ENDS_WITH_DOT = /\.$/;
function $b541e5179eb96aca$var$matchEvent(matcher, name) {
    if (matcher === '*' || name === undefined) return true;
    if (typeof matcher === 'string') {
        if ($b541e5179eb96aca$var$ENDS_WITH_DOT.test(matcher)) return name.substr(0, matcher.length) === matcher;
        return name === matcher;
    }
    if (typeof matcher === 'function') return matcher(name);
    return matcher.test(name);
}
var $b541e5179eb96aca$export$2e2bcd8739ae039 = $b541e5179eb96aca$var$matchEvent;

});

parcelRegister("eMP7Q", function(module, exports) {
$parcel$export(module.exports, "ContextTypes", () => $9e7bdba6befb4d79$export$bd0f7835a18a8866);

var $bUjzO = parcelRequire("bUjzO");
const $9e7bdba6befb4d79$export$bd0f7835a18a8866 = {
    onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
    getParentAnalyticsData: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
};

});


parcelRegister("iARmn", function(module, exports) {
$parcel$export(module.exports, "default", () => $87c9d73e63da6970$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");
const $87c9d73e63da6970$var$ContextTypes = {
    onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
};
/**
 * Listens to public and private events and delegates to an analytics
 * stack in a different React root.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $87c9d73e63da6970$var$AnalyticsDelegate extends (0, $euxye.Component) {
    static{
        this.contextTypes = $87c9d73e63da6970$var$ContextTypes;
    }
    static{
        this.childContextTypes = $87c9d73e63da6970$var$ContextTypes;
    }
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent
        };
    }
    render() {
        const { children: children } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.only(children);
    }
    constructor(...args){
        super(...args), this.onAnalyticsEvent = (name, data, isPrivate)=>{
            const { delegateAnalyticsEvent: delegateAnalyticsEvent } = this.props;
            const eventData = {
                ...data
            };
            if (delegateAnalyticsEvent) delegateAnalyticsEvent(name, eventData, isPrivate);
            const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent === 'function') onAnalyticsEvent(name, data, isPrivate);
        };
    }
}
var $87c9d73e63da6970$export$2e2bcd8739ae039 = $87c9d73e63da6970$var$AnalyticsDelegate;

});

parcelRegister("6tNB1", function(module, exports) {
$parcel$export(module.exports, "default", () => $72e4430c1d6e2d02$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");
/**
 * The withAnalytics HOC wraps a component and provides the `fireAnalyticsEvent`
 * and `firePrivateAnalyticsEvent` methods to it as props. It contains the logic
 * for how to fire events, including handling the analyticsId and analyticsData
 * props. The `map` argument may be an object or a function that returns an object.
 * The properties of the `map` object/result can be strings (the name of the event
 * that will be fired) or functions (which are responsible for firing the event).
 * You can specify a default `analyticsId` and `analyticsData` with the `defaultProps`
 * param. Please be aware that specifying a default `analyticsId` will cause public
 * events to always fire for your component unless it has been set to a falsy by
 * the component consumer.
 *
 * @param WrappedComponent
 * @param map
 * @param defaultProps
 * @param withDelegation
 */ const $72e4430c1d6e2d02$var$withAnalytics = (WrappedComponent, map = {}, defaultProps = {}, withDelegation)=>{
    return class WithAnalytics extends (0, $euxye.Component) {
        static{
            this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name})`;
        }
        static{
            this.contextTypes = {
                onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
                getParentAnalyticsData: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
            };
        }
        static{
            this.defaultProps = {
                analyticsId: defaultProps.analyticsId,
                analyticsData: defaultProps.analyticsData
            };
        }
        constructor(props){
            super(props), this.delegateAnalyticsEvent = (analyticsId, data, isPrivate)=>{
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(analyticsId, data, isPrivate);
            }, this.fireAnalyticsEvent = (name, data)=>{
                const { analyticsData: analyticsData, analyticsId: analyticsId } = this.props;
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!analyticsId || !onAnalyticsEvent) return;
                const eventData = {
                    ...analyticsData,
                    ...data
                };
                onAnalyticsEvent(`${analyticsId}.${name}`, eventData, false);
            }, this.privateAnalyticsEvent = (name, data)=>{
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(`${name}`, data, true);
            }, this.getParentAnalyticsData = (name)=>{
                const { getParentAnalyticsData: getParentAnalyticsData } = this.context;
                let parentData = {};
                if (typeof getParentAnalyticsData === 'function' && this.props.analyticsId) {
                    const { analyticsId: analyticsId } = this.props;
                    parentData = getParentAnalyticsData(`${analyticsId}.${name}`, false);
                }
                return parentData;
            };
            this.state = {
                evaluatedMap: {}
            };
        }
        componentDidMount() {
            this.setState({
                evaluatedMap: typeof map === 'function' ? map(this.fireAnalyticsEvent) : map
            });
        }
        render() {
            const { analyticsId: analyticsId, analyticsData: analyticsData, ...componentProps } = this.props;
            Object.keys(this.state.evaluatedMap).forEach((prop)=>{
                const handler = this.state.evaluatedMap[prop];
                const originalProp = componentProps[prop];
                componentProps[prop] = (...args)=>{
                    if (typeof handler === 'function') handler(...args);
                    else this.fireAnalyticsEvent(handler);
                    if (typeof originalProp === 'function') originalProp(...args);
                };
            });
            return /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                firePrivateAnalyticsEvent: this.privateAnalyticsEvent,
                getParentAnalyticsData: this.getParentAnalyticsData,
                delegateAnalyticsEvent: withDelegation ? this.delegateAnalyticsEvent : undefined,
                analyticsId: analyticsId,
                ref: this.props.innerRef,
                ...componentProps
            });
        }
    };
};
var $72e4430c1d6e2d02$export$2e2bcd8739ae039 = $72e4430c1d6e2d02$var$withAnalytics;

});


const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ const $0ce01f968965dadd$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $0ce01f968965dadd$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $0ce01f968965dadd$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $0ce01f968965dadd$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $0ce01f968965dadd$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $0ce01f968965dadd$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $0ce01f968965dadd$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $0ce01f968965dadd$export$4695c1a423ffe431 = 'DASHBOARD';
const $0ce01f968965dadd$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $0ce01f968965dadd$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $0ce01f968965dadd$export$9a80695e72849f84 = 'X-Atlassian-Capability';

const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$c6d9b82b8528dcc3 = false;

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;


$parcel$global.rlb("4Smn9")
//# sourceMappingURL=shared~vendor~atlaskit~ar.af9e77be.js.map
